/**
 * Root namespace for OSA 3.0 JS Core
 * @namespace
 */
var osa;
(function (osa) {
    /**
     * OSA framework version
     * @const
     */
    osa.version = '3.4.11';
    Object.defineProperty(osa, "versions", {
        enumerable: true,
        get: function () {
            var versions = {
                'OSA': osa.version
            };
            osa.domains.map(function (domain) {
                versions[domain.name] = domain.module.version;
            });
            return versions;
        }
    });
})(osa || (osa = {}));
var osa;
(function (osa) {
    var error;
    (function (error) {
        error.ValidationError = function (type, message) {
            var me = Error(message || 'Validation error.');
            me.type = type;
            me.name = 'ValidationError';
            return me;
        };
    })(error = osa.error || (osa.error = {}));
})(osa || (osa = {}));
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Content Type parser
         */
        var ContentType = /** @class */ (function () {
            function ContentType(contentType) {
                var e_1, _a;
                var parts = (contentType || 'unknown').split(';');
                this.mime = common.trimString(parts.shift());
                this.properties = {};
                try {
                    for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                        var part = parts_1_1.value;
                        var params = part.split('=');
                        this.properties[common.trimString(params[0])] = common.trimString(params[1]);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            Object.defineProperty(ContentType.prototype, "boundary", {
                /**
                 * Gets boundary property
                 */
                get: function () {
                    return this.properties['boundary'];
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ContentType.prototype, "charset", {
                /**
                 * Gets charset property
                 */
                get: function () {
                    return this.properties['charset'];
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ContentType.prototype, "odata", {
                /**
                 * Gets odata property
                 */
                get: function () {
                    return this.properties['odata'];
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ContentType.prototype, "name", {
                /**
                 * Gets name property
                 */
                get: function () {
                    return this.properties['name'];
                },
                enumerable: false,
                configurable: true
            });
            ContentType.prototype.toString = function () {
                return this.mime;
            };
            return ContentType;
        }());
        common.ContentType = ContentType;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Text reader class
         */
        var TextReader = /** @class */ (function () {
            function TextReader(text) {
                this.text = text || '';
                this.position = 0;
                if (TextReader.leadingNewLineRegex.test(this.text)) {
                    this.text = this.text.replace(TextReader.leadingNewLineRegex, ''); // OSA2-2792: remove leading \r\n
                }
            }
            TextReader.isNewLine = function (text) {
                return text === '\r\n' || text === '\n';
            };
            TextReader.prototype.line = function () {
                return this.to('\r\n');
            };
            TextReader.prototype.to = function (boundary) {
                if (boundary === undefined) {
                    var value_1 = this.text.slice(this.position);
                    this.position = this.text.length;
                    return value_1;
                }
                var pattern = String(boundary).replace(TextReader.newLineRegex, TextReader.newLineRegexStr);
                var regex = new RegExp(pattern, 'g');
                regex.lastIndex = this.position;
                var match = regex.exec(this.text);
                if (match == null) {
                    return null;
                }
                var value = this.text.slice(this.position, match.index);
                this.position = regex.lastIndex;
                return value;
            };
            TextReader.leadingNewLineRegex = /^(\r?\n)+/g;
            TextReader.newLineRegex = /(\r?\n)/g;
            TextReader.newLineRegexStr = '(\r?\n)';
            return TextReader;
        }());
        common.TextReader = TextReader;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Sets the validation error hook
         */
        function setValidationError(hook) {
            osa.common.validationError = hook;
        }
        common.setValidationError = setValidationError;
        Object.defineProperty(osa.common, 'validationError', (function () {
            var validationErrorFn;
            return {
                enumerable: true,
                configurable: false,
                get: function () {
                    if (validationErrorFn != void (0))
                        return validationErrorFn;
                    validationErrorFn = function (err, validationMode) {
                        switch (validationMode) {
                            case osa.common.ValidationMode.None:
                                break; // do nothing
                            case osa.common.ValidationMode.Warning:
                                console.warn(err.message);
                                break;
                            case osa.common.ValidationMode.Error:
                                throw err;
                        }
                    };
                    return validationErrorFn;
                },
                set: function (value) {
                    validationErrorFn = value;
                }
            };
        })());
        var MetaFlags;
        (function (MetaFlags) {
            MetaFlags[MetaFlags["Complex"] = 1] = "Complex";
            MetaFlags[MetaFlags["Entity"] = 2] = "Entity";
            MetaFlags[MetaFlags["Array"] = 4] = "Array";
        })(MetaFlags = common.MetaFlags || (common.MetaFlags = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var osa;
(function (osa) {
    var common;
    (function (common) {
        var EnumConst;
        (function (EnumConst) {
            EnumConst[EnumConst["Value"] = 4] = "Value";
        })(EnumConst = common.EnumConst || (common.EnumConst = {}));
        ;
        common.DateConst = 3;
        common.TimeConst = 13;
        common.DateTimeOffsetConst = 15;
        /**
         * OData v3 types
         */
        var OData3Types;
        (function (OData3Types) {
            OData3Types[OData3Types["Reference"] = 0] = "Reference";
            OData3Types[OData3Types["Boolean"] = 1] = "Boolean";
            OData3Types[OData3Types["String"] = 2] = "String";
            OData3Types[OData3Types["DateTime"] = common.DateConst] = "DateTime";
            OData3Types[OData3Types["Enum"] = 4] = "Enum";
            OData3Types[OData3Types["Double"] = 5] = "Double";
            OData3Types[OData3Types["Single"] = 6] = "Single";
            OData3Types[OData3Types["Guid"] = 7] = "Guid";
            OData3Types[OData3Types["Int16"] = 8] = "Int16";
            OData3Types[OData3Types["Int32"] = 9] = "Int32";
            OData3Types[OData3Types["Int64"] = 10] = "Int64";
            OData3Types[OData3Types["SByte"] = 11] = "SByte";
            OData3Types[OData3Types["Byte"] = 12] = "Byte";
            OData3Types[OData3Types["Time"] = common.TimeConst] = "Time";
            OData3Types[OData3Types["Decimal"] = 14] = "Decimal";
            OData3Types[OData3Types["DateTimeOffset"] = common.DateTimeOffsetConst] = "DateTimeOffset";
            OData3Types[OData3Types["Stream"] = 16] = "Stream";
            OData3Types[OData3Types["Binary"] = 17] = "Binary";
        })(OData3Types = common.OData3Types || (common.OData3Types = {}));
        /**
         * OData v4 types
         */
        var OData4Types;
        (function (OData4Types) {
            OData4Types[OData4Types["Reference"] = 0] = "Reference";
            OData4Types[OData4Types["Boolean"] = 1] = "Boolean";
            OData4Types[OData4Types["String"] = 2] = "String";
            OData4Types[OData4Types["Date"] = common.DateConst] = "Date";
            OData4Types[OData4Types["TimeOfDay"] = OData4Types.Date] = "TimeOfDay";
            OData4Types[OData4Types["Enum"] = 4] = "Enum";
            OData4Types[OData4Types["Double"] = 5] = "Double";
            OData4Types[OData4Types["Single"] = 6] = "Single";
            OData4Types[OData4Types["Guid"] = 7] = "Guid";
            OData4Types[OData4Types["Int16"] = 8] = "Int16";
            OData4Types[OData4Types["Int32"] = 9] = "Int32";
            OData4Types[OData4Types["Int64"] = 10] = "Int64";
            OData4Types[OData4Types["SByte"] = 11] = "SByte";
            OData4Types[OData4Types["Byte"] = 12] = "Byte";
            OData4Types[OData4Types["Duration"] = common.TimeConst] = "Duration";
            OData4Types[OData4Types["Decimal"] = 14] = "Decimal";
            OData4Types[OData4Types["DateTimeOffset"] = common.DateTimeOffsetConst] = "DateTimeOffset";
            OData4Types[OData4Types["Stream"] = 16] = "Stream";
            OData4Types[OData4Types["Binary"] = 17] = "Binary";
        })(OData4Types = common.OData4Types || (common.OData4Types = {}));
        /**
         * A version independent metadata.
         * To get a version dependent metadata, use Protocol->getPropertyMetadata()
         */
        var GenericMetadata = /** @class */ (function () {
            function GenericMetadata(info, odataName) {
                this.name = info.n;
                this.odataName = odataName;
                this.type = info.t;
                this.odataType = info.r;
                this.flags = info.f;
                if (this.isRefType()) {
                    this.referenceTypeCtor = info.r2 && info.r2();
                }
                if (this.isEnum()) {
                    this.enumObject = info.r2 && info.r2();
                }
            }
            GenericMetadata.prototype.isRefType = function () {
                return this.isComplex() || this.isEntity();
            };
            GenericMetadata.prototype.isComplex = function () {
                return (this.flags & common.MetaFlags.Complex) === common.MetaFlags.Complex;
            };
            GenericMetadata.prototype.isEntity = function () {
                return (this.flags & common.MetaFlags.Entity) === common.MetaFlags.Entity;
            };
            GenericMetadata.prototype.isArray = function () {
                return (this.flags & common.MetaFlags.Array) === common.MetaFlags.Array;
            };
            GenericMetadata.prototype.isEnum = function () {
                return this.type === EnumConst.Value;
            };
            GenericMetadata.prototype.isPrimitive = function () {
                return this.type != null && !this.isEnum();
            };
            GenericMetadata.prototype.isEntityArray = function () {
                var isEntityFlag = this.isComplex() || this.isEntity();
                return this.isArray() && isEntityFlag;
            };
            ;
            GenericMetadata.prototype.createFrom = function (value) {
                var _this = this;
                if (this.isArray() && this.isRefType()) {
                    if (!Array.isArray(value)) {
                        throw osa.error.ArgumentError('Expected value type is array');
                    }
                    return value.map(function (val) {
                        if (val instanceof _this.referenceTypeCtor) {
                            return val;
                        }
                        var Ctor = _this.referenceTypeCtor;
                        return Ctor.new(val);
                    });
                }
                else if (this.isArray()) {
                    if (!Array.isArray(value)) {
                        throw osa.error.ArgumentError('Expected value type is array');
                    }
                    return value.slice();
                }
                else if (this.isRefType() && !(value instanceof this.referenceTypeCtor)) {
                    var Ctor = this.referenceTypeCtor;
                    return Ctor.new(value);
                }
                else {
                    switch (this.type) {
                        case common.DateTimeOffsetConst:
                            return osa.common.odata.types.DateTimeOffset.from(value);
                        case common.DateConst:
                            return osa.common.odata.types.EdmDate.from(value);
                        case common.TimeConst:
                            return osa.common.odata.types.EdmDuration.from(value);
                    }
                }
                return value;
            };
            return GenericMetadata;
        }());
        common.GenericMetadata = GenericMetadata;
        /**
         * @internal
         */
        var ODataMetadata = /** @class */ (function (_super) {
            __extends(ODataMetadata, _super);
            function ODataMetadata() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ODataMetadata;
        }(GenericMetadata));
        common.ODataMetadata = ODataMetadata;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * @internal
         */
        var MetadataOdata3 = /** @class */ (function (_super) {
            __extends(MetadataOdata3, _super);
            function MetadataOdata3(info, odataName) {
                var _this = _super.call(this, info, odataName) || this;
                if (_this.type !== common.OData3Types.Enum) {
                    _this.odataName = odataName;
                }
                else {
                    // osa2 backward compatibility
                    // enum for the odata3 should have odata name XxxValue
                    // where Xxx is the property name
                    _this.odataName = odataName + 'Value';
                }
                return _this;
            }
            MetadataOdata3.prototype.validate = function (input, validationMode) {
                if (input === void (0))
                    return true;
                var isValid = false;
                if ((this.flags & common.MetaFlags.Array) === common.MetaFlags.Array) {
                    isValid = common.isArray(input);
                    if (!common.isArray(input)) {
                        var typeName = !!this.referenceTypeCtor ? this.referenceTypeCtor['odataType'] : common.OData3Types[this.type];
                        var s = 'Input for property "' + this.name + '" expected to be array of type "' + typeName + '"';
                        var e = new osa.error.ValidationError(!!this.referenceTypeCtor ? common.OData3Types.Reference : this.type, s);
                        common.validationError(e, validationMode);
                    }
                    return isValid;
                }
                if (this.isRefType()) {
                    if (input instanceof this.referenceTypeCtor)
                        return true;
                    var s = 'Input for property "' + this.name + '" expected to be of type "' + this.referenceTypeCtor['odataType'] + '"';
                    var e = new osa.error.ValidationError(common.OData3Types.Reference, s);
                    common.validationError(e, validationMode);
                    return false;
                }
                if (this.type === void (0))
                    return true;
                switch (this.type) {
                    case common.OData3Types.Enum:
                    case common.OData3Types.Byte:
                    case common.OData3Types.SByte:
                    case common.OData3Types.Single:
                    case common.OData3Types.Decimal:
                    case common.OData3Types.Int16:
                    case common.OData3Types.Int32:
                    case common.OData3Types.Int64:
                        isValid = common.isInteger(input);
                        break;
                    case common.OData3Types.Double:
                        isValid = common.isNumber(input);
                        break;
                    case common.OData3Types.Binary:
                    case common.OData3Types.Guid:
                    case common.OData3Types.String:
                        isValid = common.isString(input);
                        break;
                    case common.OData3Types.Boolean:
                        isValid = common.isBoolean(input);
                        break;
                    case common.OData3Types.DateTime:
                        isValid = common.isDate(input) || common.isString(input) || common.isEdmDate(input);
                        break;
                    case common.OData3Types.Time:
                        isValid = common.isDate(input) || common.isString(input) || common.isDuration(input);
                        break;
                    case common.OData3Types.DateTimeOffset:
                        isValid = common.isDate(input) || common.isString(input) || common.isDateTimeOffset(input);
                        break;
                }
                if (!isValid)
                    this.handleError(input, validationMode);
                return isValid;
            };
            MetadataOdata3.prototype.getValue = function (data) {
                var self = this;
                var value = data[this.name];
                if (value == null) {
                    return this.defaultValue();
                }
                if (this.isArray() && osa.common.isArray(value)) {
                    return value.map(function (item) {
                        return self.convertValue(item);
                    });
                }
                return this.convertValue(value);
            };
            MetadataOdata3.prototype.defaultValue = function () {
                if (this.isArray()) {
                    return [];
                }
                switch (this.type) {
                    case common.OData3Types.Int64:
                    case common.OData3Types.Decimal:
                        return null; // was 'null'
                }
                return null;
            };
            MetadataOdata3.prototype.convertValue = function (value) {
                switch (this.type) {
                    case common.OData3Types.Int64:
                    case common.OData3Types.Decimal:
                        return String(value);
                    case common.OData3Types.Time:
                        return common.convertFormat(function () { return osa.common.odata.types.EdmDuration.from(value); });
                    case common.OData3Types.DateTime: {
                        return common.convertFormat(function () { return osa.common.odata.types.EdmDate.from(value); }, { iso: true });
                    }
                    case common.OData3Types.DateTimeOffset: {
                        return common.convertFormat(function () { return osa.common.odata.types.DateTimeOffset.from(value); });
                    }
                    case common.OData3Types.Enum:
                        return value;
                }
                return value;
            };
            MetadataOdata3.prototype.deserialize = function (value) {
                if (value === void (0)) {
                    return value;
                }
                var self = this;
                if (common.isArray(value) && !this.isEntityArray()) {
                    return value.map(function (item) {
                        return self.deserialize(item);
                    });
                }
                switch (this.type) {
                    case common.OData3Types.Int64:
                    case common.OData3Types.Decimal:
                        return Number(value);
                    case common.OData3Types.Time:
                        return osa.common.odata.types.EdmDuration.from(value);
                    case common.OData3Types.DateTime:
                        return osa.common.odata.types.EdmDate.from(value);
                    case common.OData3Types.DateTimeOffset:
                        return osa.common.odata.types.DateTimeOffset.from(value);
                }
                return value;
            };
            MetadataOdata3.prototype.handleError = function (input, validationMode) {
                var jsType;
                switch (this.type) {
                    case common.OData3Types.Enum:
                    case common.OData3Types.Byte:
                    case common.OData3Types.SByte:
                    case common.OData3Types.Single:
                    case common.OData3Types.Decimal:
                    case common.OData3Types.Int16:
                    case common.OData3Types.Int32:
                    case common.OData3Types.Int64:
                    case common.OData3Types.Double:
                        jsType = 'number';
                        break;
                    case common.OData3Types.Binary:
                    case common.OData3Types.Guid:
                    case common.OData3Types.String:
                        jsType = 'string';
                        break;
                    case common.OData3Types.Boolean:
                        jsType = 'boolean';
                        break;
                    case common.OData3Types.DateTime:
                    case common.OData3Types.Time:
                    case common.OData3Types.DateTimeOffset:
                        jsType = 'Date|string';
                        break;
                }
                var s = 'Input "' + input + '" for property "' + this.name + '" expected to be of type "' + jsType + '"';
                var e = new osa.error.ValidationError(this.type, s);
                common.validationError(e, validationMode);
            };
            return MetadataOdata3;
        }(common.ODataMetadata));
        common.MetadataOdata3 = MetadataOdata3;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * @internal
         */
        var MetadataOdata4 = /** @class */ (function (_super) {
            __extends(MetadataOdata4, _super);
            function MetadataOdata4(info, odataName) {
                return _super.call(this, info, odataName) || this;
            }
            MetadataOdata4.prototype.getValue = function (data) {
                var _this = this;
                var value = data[this.name];
                if (value == null) {
                    return this.defaultValue();
                }
                if (this.isArray() && osa.common.isArray(value)) {
                    return value.map(function (item) { return _this.convertValue(item); });
                }
                return this.convertValue(value);
            };
            MetadataOdata4.prototype.defaultValue = function () {
                if (this.isArray()) {
                    return [];
                }
                return null;
            };
            MetadataOdata4.prototype.isArray = function () {
                return (this.flags & common.MetaFlags.Array) === common.MetaFlags.Array;
            };
            MetadataOdata4.prototype.convertValue = function (value) {
                switch (this.type) {
                    case common.OData4Types.Double:
                        return value && value.toExponential();
                    case common.OData4Types.Duration:
                        return common.convertFormat(function () { return osa.common.odata.types.EdmDuration.from(value); });
                    case common.OData4Types.Date: {
                        return common.convertFormat(function () { return osa.common.odata.types.EdmDate.from(value); }, { iso: false });
                    }
                    case common.OData4Types.DateTimeOffset: {
                        return common.convertFormat(function () { return osa.common.odata.types.DateTimeOffset.from(value); });
                    }
                    case common.OData4Types.Enum: {
                        return this.enumObject[value];
                    }
                }
                return value;
            };
            MetadataOdata4.prototype.validate = function (input, validationMode) {
                if (input == null) {
                    return true;
                }
                var isValid = false;
                if ((this.flags & common.MetaFlags.Array) === common.MetaFlags.Array) {
                    isValid = common.isArray(input);
                    if (!common.isArray(input)) {
                        var typeName = !!this.referenceTypeCtor ? this.referenceTypeCtor['odataType'] : common.OData4Types[this.type];
                        var s = "Input for property \"" + this.name + "\" expected to be array of type \"" + typeName + "\"";
                        var e = new osa.error.ValidationError(!!this.referenceTypeCtor ? common.OData4Types.Reference : this.type, s);
                        common.validationError(e, validationMode);
                    }
                    return isValid;
                }
                if (this.isRefType()) {
                    if (input instanceof this.referenceTypeCtor)
                        return true;
                    var s = "Input for property \"" + this.name + "\" expected to be of type \"" + this.referenceTypeCtor['odataType'] + "\"";
                    var e = new osa.error.ValidationError(common.OData4Types.Reference, s);
                    common.validationError(e, validationMode);
                    return false;
                }
                // Don't check 0, because it's internal type
                if (!this.type)
                    return true;
                switch (this.type) {
                    case common.OData4Types.Enum:
                        // compatibility with the odata3 metadata
                        // during the serialization the enum is converted to string
                        isValid = common.isInteger(input);
                        break;
                    case common.OData4Types.Byte:
                    case common.OData4Types.SByte:
                    case common.OData4Types.Single:
                    case common.OData4Types.Decimal:
                    case common.OData4Types.Int16:
                    case common.OData4Types.Int32:
                    case common.OData4Types.Int64:
                        isValid = common.isInteger(input);
                        break;
                    case common.OData4Types.Double:
                        isValid = common.isNumber(input);
                        break;
                    case common.OData4Types.Binary:
                    case common.OData4Types.Guid:
                    case common.OData4Types.String:
                        isValid = common.isString(input);
                        break;
                    case common.OData4Types.Boolean:
                        isValid = common.isBoolean(input);
                        break;
                    case common.OData4Types.Date:
                        isValid = common.isDate(input) || common.isString(input) || common.isEdmDate(input);
                        break;
                    case common.OData4Types.Duration:
                        isValid = common.isDate(input) || common.isString(input) || common.isDuration(input);
                        break;
                    case common.OData4Types.DateTimeOffset:
                        isValid = common.isDate(input) || common.isString(input) || common.isDateTimeOffset(input);
                        break;
                }
                if (!isValid)
                    this.handleError(input, validationMode);
                return isValid;
            };
            MetadataOdata4.prototype.deserialize = function (value) {
                var _this = this;
                if (!value) {
                    return value;
                }
                if (common.isArray(value) && !this.isEntityArray()) {
                    return value.map(function (item) { return _this.deserialize(item); });
                }
                switch (this.type) {
                    case common.OData4Types.Duration:
                        return osa.common.odata.types.EdmDuration.from(value);
                    case common.OData4Types.Date:
                        return osa.common.odata.types.EdmDate.from(value);
                    case common.OData4Types.DateTimeOffset:
                        return osa.common.odata.types.DateTimeOffset.from(value);
                    case common.OData4Types.Double:
                        return Number.parseFloat(value);
                    case common.OData4Types.Enum: {
                        return this.enumObject[value];
                    }
                }
                return value;
            };
            MetadataOdata4.prototype.handleError = function (input, validationMode) {
                var jsType;
                switch (this.type) {
                    case common.OData4Types.Enum: // compatibility with odata3 metadata
                    case common.OData4Types.Byte:
                    case common.OData4Types.SByte:
                    case common.OData4Types.Single:
                    case common.OData4Types.Decimal:
                    case common.OData4Types.Int16:
                    case common.OData4Types.Int32:
                    case common.OData4Types.Int64:
                    case common.OData4Types.Double:
                        jsType = 'number';
                        break;
                    case common.OData4Types.Binary:
                    case common.OData4Types.Guid:
                    case common.OData4Types.String:
                        jsType = 'string';
                        break;
                    case common.OData4Types.Boolean:
                        jsType = 'boolean';
                        break;
                    case common.OData4Types.Date:
                    case common.OData4Types.Duration:
                    case common.OData4Types.DateTimeOffset:
                        jsType = 'Date|string';
                        break;
                }
                var s = "Input \"" + input + "\" for property \"" + this.name + "\" expected to be of type \"" + jsType + "\"";
                var e = new osa.error.ValidationError(this.type, s);
                common.validationError(e, validationMode);
            };
            return MetadataOdata4;
        }(common.ODataMetadata));
        common.MetadataOdata4 = MetadataOdata4;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var constants;
    (function (constants) {
        constants.CorrelationIdName = 'CorrelationId';
        constants.ContentTypeHeaderName = 'Content-Type';
        constants.AcceptHeaderName = 'Accept';
        constants.PreferHeaderName = 'Prefer';
        constants.PreferenceAppliedHeaderName = 'Preference-Applied';
        constants.RetryAfterHeaderName = 'Retry-After';
        constants.AsyncResultHeaderName = 'AsyncResult';
        constants.LocationHeaderName = 'Location';
        constants.ContentId = 'Content-ID';
        constants.OsaFault = '@osa.fault';
        constants.ODataV4Type = '@odata.type';
        constants.OdataV4Count = '@odata.count';
        constants.ODataV4NextLink = '@odata.nextLink';
        constants.ODataV4Id = '@odata.id';
        constants.ODataV4Context = '@odata.context';
        constants.ODataV4Bind = '@odata.bind';
        constants.ODataV4Value = 'value';
        constants.ODataV4DeltaLink = '@odata.deltaLink';
        var HttpStatus;
        (function (HttpStatus) {
            HttpStatus[HttpStatus["Continue"] = 100] = "Continue";
            HttpStatus[HttpStatus["SwitchingProtocols"] = 101] = "SwitchingProtocols";
            HttpStatus[HttpStatus["Processing"] = 102] = "Processing";
            HttpStatus[HttpStatus["EarlyHints"] = 103] = "EarlyHints";
            HttpStatus[HttpStatus["Ok"] = 200] = "Ok";
            HttpStatus[HttpStatus["Created"] = 201] = "Created";
            HttpStatus[HttpStatus["Accepted"] = 202] = "Accepted";
            HttpStatus[HttpStatus["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
            HttpStatus[HttpStatus["NoContent"] = 204] = "NoContent";
            HttpStatus[HttpStatus["ResetContent"] = 205] = "ResetContent";
            HttpStatus[HttpStatus["PartialContent"] = 206] = "PartialContent";
            HttpStatus[HttpStatus["MultiStatus"] = 207] = "MultiStatus";
            HttpStatus[HttpStatus["AlreadyReported"] = 208] = "AlreadyReported";
            HttpStatus[HttpStatus["ImUsed"] = 226] = "ImUsed";
            HttpStatus[HttpStatus["MultipleChoices"] = 300] = "MultipleChoices";
            HttpStatus[HttpStatus["MovedPermanently"] = 301] = "MovedPermanently";
            HttpStatus[HttpStatus["Found"] = 302] = "Found";
            HttpStatus[HttpStatus["SeeOther"] = 303] = "SeeOther";
            HttpStatus[HttpStatus["NotModified"] = 304] = "NotModified";
            HttpStatus[HttpStatus["UseProxy"] = 305] = "UseProxy";
            HttpStatus[HttpStatus["TemporaryRedirect"] = 307] = "TemporaryRedirect";
            HttpStatus[HttpStatus["PermanentRedirect"] = 308] = "PermanentRedirect";
            HttpStatus[HttpStatus["BadRequest"] = 400] = "BadRequest";
            HttpStatus[HttpStatus["Unauthorized"] = 401] = "Unauthorized";
            HttpStatus[HttpStatus["PaymentRequired"] = 402] = "PaymentRequired";
            HttpStatus[HttpStatus["Forbidden"] = 403] = "Forbidden";
            HttpStatus[HttpStatus["NotFound"] = 404] = "NotFound";
            HttpStatus[HttpStatus["MethodNotAllowed"] = 405] = "MethodNotAllowed";
            HttpStatus[HttpStatus["NotAccaptable"] = 406] = "NotAccaptable";
            HttpStatus[HttpStatus["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
            HttpStatus[HttpStatus["RequestTimeout"] = 408] = "RequestTimeout";
            HttpStatus[HttpStatus["Conflict"] = 409] = "Conflict";
            HttpStatus[HttpStatus["Gone"] = 410] = "Gone";
            HttpStatus[HttpStatus["LengthRequired"] = 411] = "LengthRequired";
            HttpStatus[HttpStatus["PreconditionFailed"] = 412] = "PreconditionFailed";
            HttpStatus[HttpStatus["PayloadTooLarge"] = 413] = "PayloadTooLarge";
            HttpStatus[HttpStatus["UriTooLong"] = 414] = "UriTooLong";
            HttpStatus[HttpStatus["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
            HttpStatus[HttpStatus["RangeNotSatisfiable"] = 416] = "RangeNotSatisfiable";
            HttpStatus[HttpStatus["ExpectationFailed"] = 417] = "ExpectationFailed";
            HttpStatus[HttpStatus["Teapot"] = 418] = "Teapot";
            HttpStatus[HttpStatus["MisdirectedRequest"] = 421] = "MisdirectedRequest";
            HttpStatus[HttpStatus["UnprocessableEntity"] = 422] = "UnprocessableEntity";
            HttpStatus[HttpStatus["Locked"] = 423] = "Locked";
            HttpStatus[HttpStatus["FailedDependency"] = 424] = "FailedDependency";
            HttpStatus[HttpStatus["TooEarly"] = 425] = "TooEarly";
            HttpStatus[HttpStatus["UpgradeRequired"] = 426] = "UpgradeRequired";
            HttpStatus[HttpStatus["PreconditionRequired"] = 428] = "PreconditionRequired";
            HttpStatus[HttpStatus["TooManyRequests"] = 429] = "TooManyRequests";
            HttpStatus[HttpStatus["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
            HttpStatus[HttpStatus["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
            HttpStatus[HttpStatus["InternalServerError"] = 500] = "InternalServerError";
            HttpStatus[HttpStatus["NotImplemented"] = 501] = "NotImplemented";
            HttpStatus[HttpStatus["BadGateway"] = 502] = "BadGateway";
            HttpStatus[HttpStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
            HttpStatus[HttpStatus["GatewayTimeout"] = 504] = "GatewayTimeout";
            HttpStatus[HttpStatus["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
            HttpStatus[HttpStatus["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
            HttpStatus[HttpStatus["InsufficientStorage"] = 507] = "InsufficientStorage";
            HttpStatus[HttpStatus["LoopDetected"] = 508] = "LoopDetected";
            HttpStatus[HttpStatus["BandwidthLimitExceeded"] = 509] = "BandwidthLimitExceeded";
            HttpStatus[HttpStatus["NotExtended"] = 510] = "NotExtended";
            HttpStatus[HttpStatus["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
        })(HttpStatus = constants.HttpStatus || (constants.HttpStatus = {}));
    })(constants = osa.constants || (osa.constants = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * @internal
         */
        common.BatchSymbol = Symbol('Batch');
        /**
         * @internal
         */
        common.BuiltRequestSymbol = Symbol('BuiltRequest');
        /**
         * @internal
         */
        function appendQueryString(url, query) {
            if (query === void (0) || query == '') {
                return url;
            }
            return [url, query].join(url.indexOf('?') < 0 ? '?' : '&');
        }
        common.appendQueryString = appendQueryString;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="Dictionary.ts"/>
/// <reference path="DomainModule.ts"/>
/// <reference path="RequestOptions.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        var ValidationMode;
        (function (ValidationMode) {
            ValidationMode[ValidationMode["None"] = 0] = "None";
            ValidationMode[ValidationMode["Warning"] = 1] = "Warning";
            ValidationMode[ValidationMode["Error"] = 2] = "Error";
        })(ValidationMode = common.ValidationMode || (common.ValidationMode = {}));
        /**
         * gets CorrelationId from response/request options
         * @param options
         * @param result
         * @returns {string}
         */
        function getCorrelationId(options, result) {
            if (result && result[osa.constants.CorrelationIdName]) {
                return result[osa.constants.CorrelationIdName];
            }
            else if (result && typeof result.getHeader === 'function') {
                var responseCorrelationId = result.getHeader(osa.constants.CorrelationIdName);
                if (!!responseCorrelationId) {
                    return responseCorrelationId;
                }
            }
            else if (!!options.headers && !!options.headers[osa.constants.CorrelationIdName]) {
                return options.headers[osa.constants.CorrelationIdName];
            }
        }
        common.getCorrelationId = getCorrelationId;
        /**
         * gets window object
         */
        function getWindow() {
            return typeof self === 'object' ? self : (typeof window === 'object' ? window : {});
        }
        common.getWindow = getWindow;
        /**
         * returns true if running under node environment, otherwise false
         * @returns {boolean}
         */
        function isNodeEnvironment() {
            return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
        }
        common.isNodeEnvironment = isNodeEnvironment;
        /**
         * Capitalize string
         * @param value
         * @internal
         */
        function capitalize(value) {
            if (value === void (0) || typeof value !== 'string' || value.length === 0) {
                return value;
            }
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
        common.capitalize = capitalize;
        /**
         * Uncapitalize string
         * @param value
         * @internal
         */
        function uncapitalize(value) {
            if (value === void (0) || typeof value !== 'string' || value.length === 0) {
                return value;
            }
            return value.charAt(0).toLowerCase() + value.slice(1);
        }
        common.uncapitalize = uncapitalize;
        /**
         * Generate GUID
         * @internal
         */
        function uuid() {
            function S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            }
            return (S4() + S4() + '-' + S4() + '-4' + S4().substr(0, 3) + '-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
        }
        common.uuid = uuid;
        /**
         * regexp for asp.net date
         * @internal
         */
        common.msDateRegexp = /^\/Date\((-?\d+)([+|-]\d+)?\)\/$/i;
        /**
         * regexp for ISO-8601 date
         * @internal
         */
        common.isoDateRegexp = /^\d\d\d\d-\d\d-\d\d(\s|T)\d\d:\d\d(:\d\d(\.\d{1,9})?)?(([+|-]\d\d:\d\d)|Z)?$/i;
        /**
         * regexp for EDM.Duration date
         * @internal
         */
        common.edmDateRegexp = /^(\d{4})-(\d{1,2})-(\d{1,2})$/i;
        /**
         * Checks if input is a boolean
         * @param input
         * @returns {boolean}
         */
        function isBoolean(input) {
            return typeof (input) === 'boolean';
        }
        common.isBoolean = isBoolean;
        /**
         * Checks if input is a array
         * @param input
         * @returns {boolean}
         */
        function isArray(input) {
            return {}.toString.call(input) === '[object Array]';
        }
        common.isArray = isArray;
        /**
         * Checks if input is a string
         * @param input
         * @returns {boolean}
         */
        function isString(input) {
            return typeof input === 'string';
        }
        common.isString = isString;
        /**
         * Checks if input is a function
         * @param input
         * @returns {boolean}
         */
        function isFunction(input) {
            return typeof input === 'function';
        }
        common.isFunction = isFunction;
        /**
         * Checks if input is a boolean
         * @param input
         * @returns {boolean}
         */
        function isDate(input) {
            return input instanceof Date;
        }
        common.isDate = isDate;
        function isDateTimeOffset(input) {
            return input && input instanceof common.odata.types.DateTimeOffset;
        }
        common.isDateTimeOffset = isDateTimeOffset;
        function isEdmDate(input) {
            return input && input instanceof common.odata.types.EdmDate;
        }
        common.isEdmDate = isEdmDate;
        function isDuration(input) {
            return input && input instanceof common.odata.types.EdmDuration;
        }
        common.isDuration = isDuration;
        /**
         * Checks if input is a number
         * @param input
         * @returns {boolean}
         */
        function isNumber(input) {
            return typeof input === 'number' && !isNaN(input);
        }
        common.isNumber = isNumber;
        /**
         * Checks if input is an integer
         * @param input
         * @returns {boolean}
         */
        function isInteger(input) {
            if (!isNumber(input)) {
                return false;
            }
            return (+input % 1) === 0;
        }
        common.isInteger = isInteger;
        /**
         * Checks if input is an object
         * @param input
         * @returns {boolean}
         */
        function isObject(input) {
            return input === Object(input);
        }
        common.isObject = isObject;
        /**
         * Removes leading and trailing whitespaces from a string
         * @param str String to trim
         */
        function trimString(str) {
            if (!str) {
                return str;
            }
            else if (str.trim) {
                return str.trim();
            }
            return str.replace(/^\s+|\s+$/g, '');
        }
        common.trimString = trimString;
        /**
         * We don't expose void result to public api. It's needed only
         * for internal Java .Net cases
         * @param {string} type
         * @returns {boolean}
         */
        function isVoidResult(type) {
            return type && type.toLowerCase().includes('voidresult');
        }
        common.isVoidResult = isVoidResult;
        /**
         * Encodes URI
         * @param {string} uri to encode
         * @return {string} encoded uri
         */
        function encodeUri(uri) {
            var encodedUri = encodeURIComponent(uri);
            return encodedUri
                .replace(/\(/g, '%28')
                .replace(/\)/g, '%29');
        }
        common.encodeUri = encodeUri;
        /**
         * Encodes string according to the odata rules
         * @param {string} id to encode
         */
        function encodeString(id) {
            var quoteValue = String(id).replace(/'/g, "''");
            return ["'", quoteValue, "'"].join('');
        }
        common.encodeString = encodeString;
        /**
         * @internal
         * */
        function throwError(msg) {
            throw new Error(msg);
        }
        common.throwError = throwError;
        function convertFormat(fn, args) {
            var value = fn();
            if (value == null) {
                return value;
            }
            return value.format(args);
        }
        common.convertFormat = convertFormat;
        function lowerCaseHeaders(headers) {
            if (headers == null) {
                return {};
            }
            return Object.keys(headers).reduce(function (acc, key) {
                var lowerCaseKey = key.toLowerCase();
                var value = headers[key];
                if (value == null) {
                    delete acc[lowerCaseKey];
                }
                else {
                    acc[lowerCaseKey] = value;
                }
                return acc;
            }, {});
        }
        common.lowerCaseHeaders = lowerCaseHeaders;
        function delay(ms) {
            return new Promise(function (resolve) { return setTimeout(resolve, ms); });
        }
        common.delay = delay;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Deferred property class
         * @internal
         */
        var Deferred = /** @class */ (function () {
            function Deferred(url, service, requestContext) {
                this.url = url;
                this.$service = service;
                this.requestContext = requestContext;
            }
            /**
             * Resolve deferred url
             * @param params - extra OData parameters
             */
            Deferred.prototype.resolve = function (params) {
                var url = this.toAbsoluteUrl(this.url);
                return this.$service.requestDeferred(url, this.requestContext, params);
            };
            Deferred.prototype.toAbsoluteUrl = function (url) {
                if (url.indexOf('http') === 0) {
                    return url;
                }
                var absoluteUrl = this.$service.$context.url + "/" + url;
                // Remove duplicated slashes
                return absoluteUrl.replace(/([^:]\/)\/+/g, '$1');
            };
            return Deferred;
        }());
        common.Deferred = Deferred;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Event emitter implementation
         */
        var EventEmitter = /** @class */ (function () {
            function EventEmitter() {
                this.$listeners = {};
            }
            /**
             * @private
             * @internal
             */
            EventEmitter.prototype.checkName = function (name) {
                if (!name) {
                    throw new osa.error.ArgumentError('Event name is missing.');
                }
            };
            /**
             * Subscribes for some event by name.
             * The listener will not be added if it is a duplicate.
             * @param name - Event name. If you pass a regular expression as the event name then the listener will be added to all events that match it.
             * @param listener - Event listener function. If the listener returns true then it will be removed after it is called.
             */
            EventEmitter.prototype.on = function (name, listener) {
                this.checkName(name);
                if ((this.$listeners[name] || (this.$listeners[name] = [])).indexOf(listener) === -1) {
                    this.$listeners[name].push(listener);
                }
                return this;
            };
            /**
             * Unsubscribes for some event by name
             * @param name - Event name.
             * @param listener - Event listener function to remove.
             */
            EventEmitter.prototype.off = function (name, listener) {
                this.checkName(name);
                if (listener === void 0) {
                    delete this.$listeners[name];
                }
                else {
                    var idx = (this.$listeners[name] || []).indexOf(listener);
                    if (idx !== -1) {
                        this.$listeners[name].splice(idx, 1);
                    }
                }
                return this;
            };
            /**
             * Raise up event
             * @param name - Event name.
             * @param args - Arguments to be passed to event listeners
             */
            EventEmitter.prototype.trigger = function (name) {
                var e_2, _a;
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                this.checkName(name);
                var listeners = this.$listeners[name] || [];
                try {
                    for (var listeners_1 = __values(listeners), listeners_1_1 = listeners_1.next(); !listeners_1_1.done; listeners_1_1 = listeners_1.next()) {
                        var listener = listeners_1_1.value;
                        if (!!listener.apply(null, args)) {
                            this.off(name, listener);
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (listeners_1_1 && !listeners_1_1.done && (_a = listeners_1.return)) _a.call(listeners_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            };
            return EventEmitter;
        }());
        common.EventEmitter = EventEmitter;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * @internal
         */
        var DefaultClientInfo = /** @class */ (function () {
            function DefaultClientInfo(domain) {
                var e_3, _a;
                var versions = [];
                var osaVersions = osa.versions;
                try {
                    for (var _b = __values(Object.getOwnPropertyNames(osaVersions)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var componentName = _c.value;
                        versions.push([componentName, osaVersions[componentName]].join('/'));
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                var info = {
                    locale: 'en',
                    timezone: DefaultClientInfo.tz,
                    instanceId: DefaultClientInfo.instanceId,
                    instanceTag: versions.join('; '),
                    frameworkVersion: osa.version
                };
                var _self = typeof global === 'undefined' ? (typeof self === 'undefined' ? window : self) : global;
                if (common.isNodeEnvironment()) {
                    // node.js
                    info.operatingSystemName = process.platform;
                    info.operatingSystemVersion = process.arch;
                    info.runtimeName = 'nodejs';
                    info.runtimeVersion = process.version;
                    if (typeof require !== 'undefined') {
                        var os = require('os');
                        info.machineName = os.hostname();
                        info.operatingSystemVersion = os.type();
                    }
                }
                else if ('navigator' in _self) {
                    // browser
                    var navigator_1 = _self.navigator;
                    info.operatingSystemName = navigator_1.platform;
                    info.runtimeName = navigator_1.appCodeName;
                    info.runtimeVersion = navigator_1.appVersion;
                }
                if (!!domain) {
                    info.domainVersion = domain.module.version;
                }
                return info;
            }
            DefaultClientInfo.tz = (function (offset) {
                var pad = function (num) {
                    if ((num + '').length < 2) {
                        return '0' + num;
                    }
                    return num + '';
                };
                return [pad(Math.round(offset / -60)), pad(Math.abs(offset % 60)), '00']
                    .join(':');
            })(new Date().getTimezoneOffset());
            DefaultClientInfo.instanceId = (function () {
                try {
                    var storageTag = 'InstanceId';
                    if (typeof window !== 'undefined'
                        && 'localStorage' in window
                        && typeof window.localStorage.setItem === 'function'
                        && typeof window.localStorage.getItem === 'function') {
                        var id = localStorage.getItem(storageTag) || common.uuid();
                        localStorage.setItem(storageTag, id);
                        return id;
                    }
                    else if (common.isNodeEnvironment()) {
                        var homedir = process.env['USERPROFILE']
                            || process.env['HOME']
                            || process.env['TEMP']
                            || process.env['TMP'];
                        if (!!homedir) {
                            var fs = require('fs');
                            var path = require('path');
                            var subDir = path.join(homedir, '.osa-clientinfo');
                            if (!fs.existsSync(subDir)) {
                                fs.mkdirSync(subDir);
                            }
                            var instaceFileName = path.join(subDir, [storageTag, __filename.replace(/[^a-z0-9]+/gi, '_')].join('-'));
                            try {
                                return fs.readFileSync(instaceFileName).toString();
                            }
                            catch (err) {
                                if (err.code === 'ENOENT') {
                                    var uuid_1 = common.uuid();
                                    fs.writeFileSync(instaceFileName, uuid_1);
                                    return uuid_1;
                                }
                            }
                        }
                    }
                }
                catch (err) {
                    console.error(err);
                }
                return common.uuid();
            })();
            return DefaultClientInfo;
        }());
        /**
         * @internal
         */
        function getDefaultClientInfo(domain) {
            return new DefaultClientInfo(domain);
        }
        common.getDefaultClientInfo = getDefaultClientInfo;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="ContentType.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        var HttpStatus = osa.constants.HttpStatus;
        /**
         * HTTP result class
         */
        var HttpResult = /** @class */ (function () {
            function HttpResult(response, contentType) {
                this.response = response;
                this.contentType = new common.ContentType(contentType || this.getHeader(osa.constants.ContentTypeHeaderName));
                if (response) {
                    this.status = this.response.status || 0;
                }
            }
            Object.defineProperty(HttpResult.prototype, "statusText", {
                /**
                 * Gets HTTP status text
                 */
                get: function () {
                    return HttpStatus[this.status];
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(HttpResult.prototype, "headers", {
                /**
                 * Gets HTTP headers
                 */
                get: function () {
                    return this.response.headers;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(HttpResult.prototype, "body", {
                /**
                 * Body
                 */
                get: function () {
                    return this.response.body;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(HttpResult.prototype, "blob", {
                /**
                 * Blob result
                 */
                get: function () {
                    return this.response.blob();
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(HttpResult.prototype, "json", {
                /**
                 * JSON result
                 */
                get: function () {
                    return this.response.json();
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(HttpResult.prototype, "text", {
                /**
                 * Text result
                 */
                get: function () {
                    return this.response.text();
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(HttpResult.prototype, "buffer", {
                /**
                 * Buffer result
                 */
                get: function () {
                    return this.response.buffer();
                },
                enumerable: false,
                configurable: true
            });
            /**
             * Gets HTTP header value
             * @param name - header name
             */
            HttpResult.prototype.getHeader = function (name) {
                return this.response && this.response.headers ? this.response.headers.get(name) : void (0);
            };
            return HttpResult;
        }());
        common.HttpResult = HttpResult;
        /**
         * Batch response
         * @internal
         */
        var BatchResponse = /** @class */ (function (_super) {
            __extends(BatchResponse, _super);
            function BatchResponse(status, statusText, headers, body) {
                var _this = this;
                var contentType = headers[osa.constants.ContentTypeHeaderName] || headers[osa.constants.ContentTypeHeaderName.toLowerCase()];
                _this = _super.call(this, null, contentType) || this;
                _this.$headers = headers;
                _this.status = status;
                _this.$body = body;
                return _this;
            }
            Object.defineProperty(BatchResponse.prototype, "blob", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    throw new osa.error.NotImpl();
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BatchResponse.prototype, "json", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    throw new osa.error.NotImpl();
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BatchResponse.prototype, "text", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return Promise.resolve(this.$body);
                },
                enumerable: false,
                configurable: true
            });
            /**
             * @inheritDoc
             */
            BatchResponse.prototype.getHeader = function (name) {
                return this.$headers ? this.$headers[name] || this.$headers[name.toLowerCase()] : void (0);
            };
            return BatchResponse;
        }(HttpResult));
        common.BatchResponse = BatchResponse;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Extend target object using properties from extension object
         * @param target - Object to extend
         * @param extension - Extension object
         * @param skipUndefined - do not copy undefined values
         */
        function extend(target, extension, skipUndefined) {
            var e_4, _a;
            if (skipUndefined === void 0) { skipUndefined = false; }
            if (extension != null && typeof extension === 'object') {
                try {
                    for (var _b = __values(Object.getOwnPropertyNames(extension)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var p = _c.value;
                        target = target || {};
                        if (target[p] == null && extension[p] != null) {
                            target[p] = extension[p];
                        }
                        else if (typeof target[p] === 'object') {
                            target[p] = extend(target[p], extension[p]);
                        }
                        else if (!skipUndefined || extension[p] !== void (0)) {
                            target[p] = extension[p];
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
            return target;
        }
        common.extend = extend;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="Extensible.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Implements ODataParameters
         */
        var ODataParams = /** @class */ (function () {
            function ODataParams(params) {
                this.extend(params);
            }
            ODataParams.merge = function (params1, params2) {
                return new ODataParams(params1).extend(params2);
            };
            /**
             * Ensure parameters object is class of ODataParams
             * @param params - Parameters object
             * @returns {ODataParams} - Instance of ODataParams
             */
            ODataParams.cast = function (params) {
                if (params instanceof ODataParams) {
                    return params;
                }
                else if (typeof params === 'object') {
                    return new ODataParams(params);
                }
                var p = new ODataParams();
                if (params !== void (0)) {
                    p[params] = void (0);
                }
                return p;
            };
            /**
             * @inheritDoc
             */
            ODataParams.prototype.extend = function (extension) {
                return common.extend(this, extension);
            };
            /**
             * Check if property can be included into query parameters
             * @param name - property name
             * @internal
             */
            ODataParams.prototype.isIncluded = function (name) {
                return [
                    'headers',
                    'method',
                    'query',
                    'id',
                    'typeFilter'
                ].indexOf(name) < 0;
            };
            /**
             * Gets parameters encoded to query string
             *
             * @param requestProtocol OData protocol version
             * @param options an object with additional options
             */
            ODataParams.prototype.toQueryString = function (requestProtocol, options) {
                var e_5, _a;
                if (options === void 0) { options = { encode: true }; }
                var encode = options && options.encode ? encodeURIComponent : function (v) { return v; };
                var quoteValue = function (name, value) {
                    var prefix = '';
                    var doQuote = osa.context.wrapParams === true && name[0] !== '$' && typeof value === 'string';
                    if (value instanceof Date) {
                        prefix = 'datetime';
                        if (value.toJSON) {
                            value = value.toJSON();
                        }
                        else {
                            value = value.toISOString();
                        }
                        doQuote = true;
                    }
                    else if (typeof value === 'object') {
                        if (requestProtocol !== void (0)) {
                            value = requestProtocol.serialize(value);
                        }
                        value = JSON.stringify(value);
                    }
                    if (doQuote) {
                        value = [prefix, '\'', value, '\''].join('');
                    }
                    else {
                        value = [prefix, value].join('');
                    }
                    return encode(value);
                };
                var args = [];
                try {
                    for (var _b = __values(Object.getOwnPropertyNames(this)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var n = _c.value;
                        if (this.isIncluded(n)) {
                            var values = Array.isArray(this[n]) ? this[n] : [this[n]];
                            if (n[0] === '$') {
                                values = [values.filter(function (v) { return !!v; }).length > 0 ? values.join(',') : void (0)];
                            }
                            for (var i = 0; i < values.length; i++) {
                                if (values[i] === void (0) || values[i] === null) {
                                    if (n[0] !== '$') {
                                        args.push(encode(n));
                                    }
                                }
                                else {
                                    args.push([
                                        encode(n),
                                        quoteValue(n, values[i])
                                    ].join('='));
                                }
                            }
                        }
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
                if (this.query) {
                    args.push(encode(this.query));
                }
                return args.join('&');
            };
            return ODataParams;
        }());
        common.ODataParams = ODataParams;
        common.Params = ODataParams;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="Params.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * OData parameters with resource identifier
         * @deprecated Use osa.common.ODataParams instead
         */
        var ODataParamsWithId = /** @class */ (function (_super) {
            __extends(ODataParamsWithId, _super);
            /**
             * Constructs OData parameters object with id
             * @param id - Entity id
             * @param params - Additional parameters
             */
            function ODataParamsWithId(id, params) {
                var _this = _super.call(this, params) || this;
                _this.id = id;
                return _this;
            }
            /**
             * Check if property can be included into query parameters
             * @param name - property name
             * @internal
             */
            ODataParamsWithId.prototype.isIncluded = function (name) {
                return [
                    'id'
                ].indexOf(name) < 0
                    && _super.prototype.isIncluded.call(this, name);
            };
            return ODataParamsWithId;
        }(common.ODataParams));
        common.ODataParamsWithId = ODataParamsWithId;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        var getters = ['hasNext', 'hasDeltaLink', 'deltaToken'];
        var addGetters = function (array) {
            var e_6, _a;
            try {
                for (var getters_1 = __values(getters), getters_1_1 = getters_1.next(); !getters_1_1.done; getters_1_1 = getters_1.next()) {
                    var getter = getters_1_1.value;
                    var descriptor = Object.getOwnPropertyDescriptor(EntityArrayImpl.prototype, getter);
                    Object.defineProperty(array, getter, descriptor);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (getters_1_1 && !getters_1_1.done && (_a = getters_1.return)) _a.call(getters_1);
                }
                finally { if (e_6) throw e_6.error; }
            }
        };
        /**
         * @internal
         */
        var EntityArrayImpl = /** @class */ (function () {
            function EntityArrayImpl(data, count, deltaLink, nextDeferred) {
                var me = (data || []);
                me.next = EntityArrayImpl.prototype.next;
                me.count = count == null ? me.length : Number(count);
                if (!!nextDeferred && !!nextDeferred.url) {
                    me.$next = nextDeferred;
                }
                if (!!deltaLink) {
                    me.deltaLink = new URL(deltaLink);
                }
                addGetters(me);
                return me;
            }
            Object.defineProperty(EntityArrayImpl.prototype, "hasNext", {
                get: function () {
                    return !!this.$next;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(EntityArrayImpl.prototype, "hasDeltaLink", {
                get: function () {
                    return !!this.deltaLink;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(EntityArrayImpl.prototype, "deltaToken", {
                get: function () {
                    if (this.hasDeltaLink) {
                        return this.deltaLink.searchParams.get('$deltatoken');
                    }
                    return null;
                },
                enumerable: false,
                configurable: true
            });
            EntityArrayImpl.prototype.next = function (params) {
                var $this = this;
                if ($this.$next instanceof common.Deferred) {
                    return $this.$next.resolve(params);
                }
                throw new osa.error.ArgumentError('No more data.');
            };
            return EntityArrayImpl;
        }());
        /**
         * Entity array constructor
         * @internal
         */
        common.EntityArray = EntityArrayImpl;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * ODATA 4 metadata format property key.
         */
        common.Odata4MetadataFormatKey = 'odata.v4.metadataFormat';
        /**
         * OSA 2 compatibility mode property key.
         */
        common.Osa2CompatibilityModeKey = 'osa.v2.compatibilityMode';
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/**
 * OData protocol implementation
 * @namespace
 */
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            /**
             * OData version
             */
            var Version;
            (function (Version) {
                /**
                 * OData Version 2.0
                 */
                Version[Version["V2"] = 2] = "V2";
                /**
                 * OData Version 3.0
                 */
                Version[Version["V3"] = 3] = "V3";
                /**
                 * OData Version 4.0
                 */
                Version[Version["V4"] = 4] = "V4";
            })(Version = odata.Version || (odata.Version = {}));
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="Extensible.ts"/>
/// <reference path="odata/Version.ts"/>
/// <reference path="EventEmitter.ts"/>
/**
 * Common utility classes
 * @namespace
 */
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Allowed header name delimiters, i.e. ClientInfo-ClientId, ClientInfo.ClientId, ClientInfo_ClientId
         */
        var HeaderNameDelimiter;
        (function (HeaderNameDelimiter) {
            HeaderNameDelimiter["Dot"] = ".";
            HeaderNameDelimiter["Dash"] = "-";
            HeaderNameDelimiter["Underscore"] = "_";
        })(HeaderNameDelimiter = common.HeaderNameDelimiter || (common.HeaderNameDelimiter = {}));
        /**
         * Class represents OSA context
         */
        var Context = /** @class */ (function (_super) {
            __extends(Context, _super);
            function Context(context) {
                var _this = _super.call(this) || this;
                _this.headers = {};
                _this.clientInfo = {};
                _this.securityOptions = {};
                _this.extend(context);
                return _this;
            }
            /**
             * Cast to Context object
             * @param value - Object to cast
             */
            Context.cast = function (value) {
                if (value instanceof Context) {
                    return value;
                }
                return new Context(value);
            };
            /**
             * Gets setting by key
             */
            Context.prototype.get = function (key) {
                return this[key];
            };
            /**
             * Sets setting with a key
             */
            Context.prototype.set = function (key, value) {
                this[key] = value;
            };
            /**
             * Extend {@link Context} properties from other object
             * @param extension - Object to get values
             */
            Context.prototype.extend = function (extension) {
                return common.extend(this, extension);
            };
            return Context;
        }(common.EventEmitter));
        common.Context = Context;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Which header to use for the authorization
         */
        var TokenHeaders;
        (function (TokenHeaders) {
            TokenHeaders["UseBoth"] = "use-both";
            TokenHeaders["UseSecurityToken"] = "use-securitytoken";
            TokenHeaders["UseAuthorization"] = "use-authorization";
        })(TokenHeaders = common.TokenHeaders || (common.TokenHeaders = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="Context.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * @internal
         */
        var CompiledContext = /** @class */ (function () {
            function CompiledContext(arg) {
                if (arg instanceof osa.base.Service) {
                    this.$service = arg;
                }
                else if (arg instanceof common.Domain) {
                    this.$d = arg;
                }
                else {
                    this.$ctx = arg;
                }
            }
            Object.defineProperty(CompiledContext.prototype, "url", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    var url = this.get('url');
                    if (url === void (0) || !url) {
                        throw new osa.error.ArgumentError('Url for service is required.');
                    }
                    return url
                        .replace(/@@OSA-DOMAIN-NAME@@/i, this.$domain.name)
                        .replace(/@@OSA-DOMAIN-NAME_LOWER@@/i, (this.$domain.name || '').toLowerCase());
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "correlationId", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('correlationId');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "product", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('product');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "logRequests", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('logRequests');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "appendTimestamp", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('appendTimestamp');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "token", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('token');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "permissions", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('permissions');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "protocol", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('protocol');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "headers", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    var headers = {};
                    headers['ProductId'] = this.get('product');
                    headers[osa.constants.CorrelationIdName] = this.get('correlationId');
                    var defaultHeaders = common.extend({}, headers, true);
                    return common.extend(defaultHeaders, this.getExtended('headers'));
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "fetch", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('fetch');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "headerNameDelimiter", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('headerNameDelimiter');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "clientInfo", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.getExtended('clientInfo');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "securityOptions", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.getExtended('securityOptions');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "fetchOptions", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.getExtended('fetchOptions');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "validationMode", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('validationMode');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "wrapParams", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get('wrapParams');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, common.Odata4MetadataFormatKey, {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get(common.Odata4MetadataFormatKey);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, common.Osa2CompatibilityModeKey, {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return this.get(common.Osa2CompatibilityModeKey) || false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CompiledContext.prototype, "$domain", {
                get: function () {
                    return this.$d || (this.$service || {}).domain || new common.Domain({
                        version: void (0),
                        domain: void (0),
                        context: void (0),
                        service: void (0)
                    }, 'Unknown');
                },
                enumerable: false,
                configurable: true
            });
            ;
            Object.defineProperty(CompiledContext.prototype, "$context", {
                get: function () {
                    return this.$ctx || (this.$service || {}).context;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * @internal
             */
            CompiledContext.prototype.trigger = function (args) {
                if (!!this.$context
                    && !!this.$context.trigger) {
                    this.$context.trigger
                        .apply(this.$context, args);
                }
                if (!!this.$domain.module.context && !!this.$domain.module.context.trigger) {
                    this.$domain.module.context.trigger
                        .apply(this.$domain.module.context, args);
                }
                if (!!osa.context.trigger) {
                    osa.context.trigger.apply(osa.context, args);
                }
            };
            /**
             * @internal
             * @param name - property name to get
             */
            CompiledContext.prototype.get = function (name) {
                //console.log('get: ' + name);
                if (name in (this.$context || {})) {
                    return this.$context[name];
                }
                else if (name in (this.$domain.module.context || {})) {
                    return this.$domain.module.context[name];
                }
                return osa.context[name];
            };
            /**
             * @internal
             * @param name - property name to get
             */
            CompiledContext.prototype.getExtended = function (name) {
                var extendedValue = common.extend({}, osa.context[name]);
                extendedValue = common.extend(extendedValue, (this.$domain.module.context || {})[name]);
                extendedValue = common.extend(extendedValue, (this.$context || {})[name]);
                return extendedValue;
            };
            return CompiledContext;
        }());
        common.CompiledContext = CompiledContext;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="Dictionary.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Domain information class
         */
        var Domain = /** @class */ (function () {
            function Domain(module, name) {
                this.module = module;
                this.name = name;
                this.typeMap = {};
            }
            Object.defineProperty(Domain.prototype, "osaModule", {
                /**
                 * OSAJS core module
                 */
                get: function () {
                    return osa;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * Get data type constructor by odata type name
             * @param odataType - OData type name
             */
            Domain.prototype.getType = function (odataType) {
                if (!odataType) {
                    throw new osa.error.ArgumentError('OData type name is required.');
                }
                if (this.typeMap[odataType] === void (0)) {
                    throw new osa.error.GeneralError([odataType, 'type is unknown.'].join(' '));
                }
                return this.typeMap[odataType];
            };
            /**
             * @private
             * @param classCtor
             * @param odataType
             * @param propertyMap
             * @internal
             */
            Domain.prototype.defineType = function (classCtor, odataType, propertyMap) {
                classCtor.propertyMap = propertyMap;
                // @ts-ignore
                classCtor.odataType = odataType;
                this.typeMap[odataType] = classCtor;
            };
            /**
             * Returns component (entity/complex type) constructor by OData type
             * @param odataType {string} OData type
             * @internal
             */
            Domain.prototype.getDataTypeConstructor = function (odataType) {
                var typeCtor = this.typeMap[odataType];
                if (typeCtor == null && odataType != null) {
                    // Assume shared entity
                    var domainName_1 = odataType.split('.')[0];
                    var domain = osa.domains.find(function (domain) { return domain.name.toLowerCase() === domainName_1.toLowerCase(); });
                    if (!domain) {
                        throw new osa.error.GeneralError(['Unable to resolve domain: ', domainName_1,
                            '. Probably domain is incompatible with current @wk/osa version'].join(''));
                    }
                    typeCtor = domain.typeMap[odataType];
                }
                return typeCtor;
            };
            return Domain;
        }());
        common.Domain = Domain;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            var ODataV4Bind = osa.constants.ODataV4Bind;
            /**
             * @internal
             */
            odata.OdataMetadataSymbol = Symbol('@odata');
            /**
             * @internal
             */
            odata.OdataBindSymbol = Symbol(ODataV4Bind);
            /**
             * Extract an ODATA metadata such as mediaContentType, mediaEtag
             * @param dataType
             */
            function getOdataMetadata(dataType) {
                return dataType[odata.OdataMetadataSymbol] || {};
            }
            odata.getOdataMetadata = getOdataMetadata;
            /**
             * @internal
             */
            function setOdataMetadata(dataType, metadata) {
                dataType[odata.OdataMetadataSymbol] = metadata;
            }
            odata.setOdataMetadata = setOdataMetadata;
            /**
             * Extract bound entity references
             */
            function getBoundLinks(dataType) {
                return dataType[odata.OdataBindSymbol] || {};
            }
            odata.getBoundLinks = getBoundLinks;
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/// <reference path="Version.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            /**
             * @internal
             */
            function toSerializerOptions(arg) {
                if (arg == null) {
                    return {};
                }
                if (typeof arg === 'boolean') {
                    return { includeNavigational: arg };
                }
                return arg;
            }
            odata.toSerializerOptions = toSerializerOptions;
            /**
             * Encodes string according to the odata rules
             * @param {string} id to encode
             */
            function encodeString(id) {
                var quoteValue = String(id).replace(/'/g, "''");
                return ["'", quoteValue, "'"].join('');
            }
            odata.encodeString = encodeString;
            /**
             * OData protocol implementation
             */
            var Protocol = /** @class */ (function () {
                function Protocol(version, $service) {
                    this.version = version;
                    this.$service = $service;
                }
                Object.defineProperty(Protocol.prototype, "contentType", {
                    get: function () {
                        return 'application/json';
                    },
                    enumerable: false,
                    configurable: true
                });
                Protocol.prototype.deltaProperties = function (obj) {
                    var knownProperties = this.knownProperties(obj);
                    var reverseMap = knownProperties.reduce(function (acc, item) {
                        var _a;
                        return (__assign(__assign({}, acc), (_a = {}, _a[item.dtoName] = item, _a)));
                    }, {});
                    var unknownProperties = Object.keys(obj)
                        .filter(function (key) { return reverseMap[key] == null; })
                        .map(function (key) {
                        return {
                            info: null,
                            dtoName: key,
                            odataName: key,
                            meta: null
                        };
                    });
                    var delta = Object.keys(obj)
                        .filter(function (key) { return reverseMap[key] != null; })
                        .map(function (key) {
                        return reverseMap[key];
                    });
                    return delta.concat(unknownProperties);
                };
                Protocol.prototype.knownProperties = function (obj) {
                    var _this = this;
                    var propertyMap = obj instanceof osa.base.DataType ? obj.getPropertyMap() : {};
                    return Object.entries(propertyMap).map(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], info = _b[1];
                        var meta = _this.getPropertyMetadata(info, key);
                        return {
                            info: info,
                            dtoName: meta.name,
                            odataName: meta.odataName,
                            meta: meta
                        };
                    });
                };
                Protocol.prototype.allProperties = function (obj) {
                    var knownProperties = this.knownProperties(obj);
                    var reverseMap = knownProperties.reduce(function (acc, item) {
                        var _a;
                        return (__assign(__assign({}, acc), (_a = {}, _a[item.dtoName] = item, _a)));
                    }, {});
                    var unknownProperties = Object.keys(obj)
                        .filter(function (key) { return reverseMap[key] == null; })
                        .map(function (key) {
                        return {
                            info: null,
                            dtoName: key,
                            odataName: key,
                            meta: null
                        };
                    });
                    return knownProperties.concat(unknownProperties);
                };
                Protocol.prototype.loadResult = function (options, rawHttpResult) {
                    var _this = this;
                    return function (result) {
                        if (options && options.batch && result.status >= 200 && result.status < 300) {
                            if (result.contentType.mime !== 'multipart/mixed') {
                                throw new osa.error.RequestError(result.status, ['Content type expected to be multipart/mixed, actual content-type is', result.contentType].join(' '));
                            }
                            else if (!result.contentType.boundary) {
                                throw new osa.error.RequestError(result.status, 'Malformed MIME message, boundary is not found');
                            }
                            return _this.deserializeBatch(result);
                        }
                        if (rawHttpResult && result.status >= 200 && result.status < 300) {
                            return result;
                        }
                        if (result.status === 204) {
                            return undefined;
                        }
                        if (result.getHeader(osa.constants.ContentTypeHeaderName) == null && result.status === 200) {
                            return undefined; // treat such cases as status 204
                        }
                        if (result.contentType.mime !== 'application/json') {
                            if (result.status >= 200 && result.status < 300) {
                                throw new osa.error.RequestError(result.status, ['Content type expected to be application/json, actual content-type is', result.contentType].join(' '));
                            }
                            else {
                                throw new osa.error.RequestError(result.status, ['HTTP', result.status, result.statusText].join(' '));
                            }
                        }
                        return _this.getJSON(result)
                            .then(function (json) {
                            if (!json) {
                                throw new osa.error.RequestError(result.status, [
                                    'JSON response expected (',
                                    'HTTP ',
                                    result.status, ' ',
                                    result.statusText, ')'
                                ].join(''));
                            }
                            return _this.checkError(json, result);
                        })
                            .then(function (json) {
                            _this.$service.trigger('jsonResponse', json, result, options, _this.$service);
                            return _this.deserialize(json, null, options.requestContext);
                        })
                            .catch(function (err) {
                            _this.$service.trigger('error', err, result, options, _this.$service);
                            throw err;
                        });
                    };
                };
                Protocol.prototype.getJSON = function (result) {
                    return result.text.then(function (txt) {
                        try {
                            if (!txt)
                                return void (0);
                            return JSON.parse(txt);
                        }
                        catch (err) {
                            throw osa.error.GeneralError(['Malformed JSON received in response.', err].join(' -> '));
                        }
                    });
                };
                Protocol.prototype.checkError = function (json, result) {
                    if (!!json) {
                        var errorJson = json['error'] || json['odata.error'];
                        if (errorJson !== void (0)) {
                            var fault = (errorJson.innererror || {}).fault;
                            if (fault === void (0)) {
                                var faultJsonBody = result.getHeader('Fault');
                                if (!!faultJsonBody) {
                                    try {
                                        fault = JSON.parse(faultJsonBody);
                                        if ('d' in fault && Object.keys(fault).length === 1) {
                                            fault = fault['d'];
                                        }
                                    }
                                    catch (err) {
                                    }
                                }
                            }
                            if (!!fault) {
                                this.patchAbstractClientFault(fault);
                                result.fault = this.deserialize(fault);
                            }
                            throw new osa.error.OdataError(errorJson, result);
                        }
                    }
                    return json;
                };
                Protocol.prototype.patchAbstractClientFault = function (fault) {
                    throw new osa.error.NotImpl();
                };
                Protocol.prototype.createODataObject = function (obj) {
                    throw new osa.error.NotImpl();
                };
                Protocol.prototype.deserialize = function (data, knownType, requestContext) {
                    throw new osa.error.NotImpl();
                };
                Protocol.prototype.serializeBatch = function (batch) {
                    var boundary = ['batch', common.uuid()].join('_');
                    var type = ['multipart/mixed; boundary', boundary].join('=');
                    var body = [];
                    var writePart = function (part, boundary, index) {
                        body.push(['--', boundary].join(''));
                        body.push(osa.constants.ContentTypeHeaderName + ': application/http');
                        body.push('Content-Transfer-Encoding: binary');
                        body.push(osa.constants.ContentId + ": " + index);
                        body.push('');
                        body.push([part.method, part.url, 'HTTP/1.1'].join(' '));
                        var headers = (part.headers || {});
                        for (var h in headers) {
                            body.push([h, headers[h]].join(': '));
                        }
                        body.push('');
                        body.push((part.body) || '');
                    };
                    batch.forEach(function (part, i) {
                        var isChangeSet = part.method.toLowerCase() !== 'get';
                        if (isChangeSet) {
                            var changeBoundary = ['changeset', common.uuid()].join('_');
                            body.push(['--', boundary].join(''));
                            body.push([osa.constants.ContentTypeHeaderName + ': multipart/mixed; boundary', changeBoundary].join('='));
                            body.push('');
                            writePart(part, changeBoundary, ++i);
                            body.push(['--', changeBoundary, '--'].join(''));
                        }
                        else {
                            writePart(part, boundary, ++i);
                        }
                    });
                    body.push(['--', boundary, '--'].join(''));
                    body.push('');
                    return { body: body.join('\r\n'), type: type };
                };
                Protocol.prototype.deserializeBatch = function (result) {
                    return result.text.then(function (body) { return deserializeBatch(body, result.contentType.boundary); });
                };
                Protocol.prototype.isExcludedProp = function (prop) {
                    return prop == 'hasMedia' || prop == 'hasStream' || prop[0] == '$' || prop == 'ODataType';
                };
                Protocol.prototype.serialize = function (obj, args) {
                    var e_7, _a;
                    var options = toSerializerOptions(args);
                    if (obj == null) {
                        return null;
                    }
                    else if (typeof obj !== 'object') {
                        return obj;
                    }
                    else if (obj instanceof Date) {
                        return obj;
                    }
                    else if (obj instanceof common.Deferred) {
                        return void (0);
                    }
                    else if (Array.isArray(obj)) {
                        return this.serializeArray(obj, options);
                    }
                    var data = this.createODataObject(obj);
                    if (data == null) {
                        return null;
                    }
                    var properties = options.allProperties ? this.allProperties(obj) : this.deltaProperties(obj);
                    try {
                        for (var properties_1 = __values(properties), properties_1_1 = properties_1.next(); !properties_1_1.done; properties_1_1 = properties_1.next()) {
                            var _b = properties_1_1.value, dtoName = _b.dtoName, odataName = _b.odataName, meta = _b.meta;
                            if (this.isExcludedProp(dtoName) || common.isFunction(obj[dtoName])) {
                                continue;
                            }
                            if (odataName === 'Id' && obj instanceof osa.base.Entity && obj[dtoName] === undefined) {
                                continue;
                            }
                            if (meta != null && meta.isEntity()) {
                                if (!options.includeNavigational) {
                                    continue;
                                }
                                var value = obj[dtoName];
                                if (value == null) {
                                    this.odataBind(obj, data, dtoName, odataName);
                                    continue;
                                }
                                if (meta.isArray() && Array.isArray(value) && value.length === 0) {
                                    continue;
                                }
                            }
                            if (meta != null) {
                                meta.validate(obj[dtoName], this.$service.$context.validationMode);
                                data[odataName] = this.serialize(meta.getValue(obj), options);
                            }
                            else {
                                data[odataName] = this.serialize(obj[dtoName], options);
                            }
                        }
                    }
                    catch (e_7_1) { e_7 = { error: e_7_1 }; }
                    finally {
                        try {
                            if (properties_1_1 && !properties_1_1.done && (_a = properties_1.return)) _a.call(properties_1);
                        }
                        finally { if (e_7) throw e_7.error; }
                    }
                    return data;
                };
                Protocol.prototype.odataBind = function (source, target, dtoName, odataName) {
                };
                /**
                 * Build operation url depending on http method
                 * @param name operation name
                 * @param method http method
                 * @param data operation data
                 * @param params additional parameters
                 * @internal
                 */
                Protocol.prototype.buildOperationUrl = function (name, method, data, params) {
                    return name;
                };
                /**
                 * Convert data to url data
                 */
                Protocol.prototype.toUrlData = function (data) {
                    return data;
                };
                /**
                 * @internal
                 */
                Protocol.prototype.buildReferenceUrl = function (entity, propertyName, value) {
                    propertyName = value == null ? propertyName : osa.base.Service.buildIdLink(propertyName, value.id);
                    return this.$service.buildUrl(['$links', propertyName].join('/'), void (0), void (0), entity);
                };
                /**
                 * @internal
                 */
                Protocol.prototype.getHttpRequest = function (ctx) {
                    return osa.common.HttpTransport.from(ctx);
                };
                return Protocol;
            }());
            odata.Protocol = Protocol;
            function deserializeBatch(body, boundary) {
                var responseStatusRegex = /^HTTP\/1\.\d (\d{3}) (.*)$/i;
                var responseHeaderRegex = /^([^()<>@,;:\\"\/[\]?={} \t]+)\s?:\s?(.*)/;
                var readHeaders = function (read) {
                    var headers = {};
                    var line;
                    while ((line = read.line())) {
                        var hdrParts = responseHeaderRegex.exec(line);
                        if (hdrParts) {
                            headers[hdrParts[1].toLowerCase()] = hdrParts[2];
                        }
                    }
                    return headers;
                };
                var readParts = function (read, boundary) {
                    var parts = [];
                    var delim = '--' + boundary;
                    var partBody = read.to(delim);
                    if (partBody !== '' && !common.TextReader.isNewLine(partBody)) {
                        throw new osa.error.GeneralError('Bad MIME message');
                    }
                    var partEnd;
                    while ((partEnd = read.line()) === '') {
                        var headers = readHeaders(read);
                        var contentTypeHeader = headers[osa.constants.ContentTypeHeaderName] || headers[osa.constants.ContentTypeHeaderName.toLowerCase()];
                        var contentType = new common.ContentType(contentTypeHeader);
                        if (contentType.mime === 'multipart/mixed') {
                            // changeset response
                            parts = parts.concat(readParts(read, contentType.boundary));
                            var part = read.to(delim);
                            if (part === null || part.trim()) {
                                throw new osa.error.GeneralError('Broken MIME message');
                            }
                        }
                        else if (contentType.mime === 'application/http') {
                            // batch response
                            var statusLine = read.line();
                            var statusMatch = responseStatusRegex.exec(statusLine);
                            if (!statusMatch) {
                                throw new osa.error.GeneralError(['Bad HTTP response status line:', statusLine].join(' '));
                            }
                            headers = readHeaders(read);
                            partBody = read.to('\r\n' + delim);
                            parts.push(new common.BatchResponse(+statusMatch[1], statusMatch[2], headers, partBody));
                        }
                        else {
                            throw new osa.error.GeneralError(['Unexpected Content-Type in batch response:', contentType].join(' '));
                        }
                    }
                    if (partEnd !== '--') {
                        throw new osa.error.GeneralError('Unexpected end of MIME message');
                    }
                    return parts;
                };
                return readParts(new common.TextReader(body), boundary);
            }
            odata.deserializeBatch = deserializeBatch;
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="Protocol.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            /**
             * OData V2 protocol implementation
             */
            var ProtocolOdata2 = /** @class */ (function (_super) {
                __extends(ProtocolOdata2, _super);
                function ProtocolOdata2() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(ProtocolOdata2.prototype, "contentType", {
                    get: function () {
                        return 'application/json;odata=verbose';
                    },
                    enumerable: false,
                    configurable: true
                });
                ProtocolOdata2.prototype.queryBuilder = function (expression) {
                    var builder = new osa.query.odata3.Query();
                    if (expression == null) {
                        return builder;
                    }
                    return expression(builder);
                };
                ProtocolOdata2.prototype.getJSON = function (result) {
                    return _super.prototype.getJSON.call(this, result).then(function (json) {
                        if (json['d'] === void (0)) {
                            if (json['error'] || json['odata.error']) {
                                return json;
                            }
                            throw new osa.error.RequestError(result.status, 'Unexpected OData response received.');
                        }
                        return json['d'];
                    });
                };
                ProtocolOdata2.prototype.createODataObject = function (obj) {
                    if (obj instanceof osa.base.DataType) {
                        var meta = {
                            'type': Object.getPrototypeOf(obj).constructor.odataType
                        };
                        if (obj instanceof osa.base.Entity && !!obj.$url) {
                            meta['uri'] = obj.$url;
                        }
                        return {
                            '__metadata': meta
                        };
                    }
                    if (obj === null) {
                        return null;
                    }
                    else if (obj === void (0)) {
                        return void (0);
                    }
                    return {};
                };
                ProtocolOdata2.prototype.patchAbstractClientFault = function (fault) {
                    if (fault.__metadata && fault.__metadata.type === 'common.AbstractClientFault') {
                        fault.__metadata.type = 'common.CommonClientFault';
                    }
                };
                ProtocolOdata2.prototype.serializeArray = function (obj, arg) {
                    var _this = this;
                    var options = odata.toSerializerOptions(arg);
                    var filtered = !options.includeNavigational ? obj.filter(function (it) { return !(it instanceof osa.base.Entity); }) : obj;
                    return {
                        'results': filtered.map(function (it) { return _this.serialize(it, options); })
                    };
                };
                return ProtocolOdata2;
            }(odata.Protocol));
            odata.ProtocolOdata2 = ProtocolOdata2;
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="Protocol.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            /**
             * OData V3 protocol implementation
             */
            var ProtocolOdata3 = /** @class */ (function (_super) {
                __extends(ProtocolOdata3, _super);
                function ProtocolOdata3(svc) {
                    // We use v3 as v2 with odata=verbose
                    return _super.call(this, odata.Version.V3, svc) || this;
                }
                Object.defineProperty(ProtocolOdata3.prototype, "acceptHeader", {
                    get: function () {
                        return 'odata=verbose';
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ProtocolOdata3.prototype, "versionMaxHeader", {
                    get: function () {
                        return 'MaxDataServiceVersion';
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ProtocolOdata3.prototype, "versionHeader", {
                    get: function () {
                        return 'DataServiceVersion';
                    },
                    enumerable: false,
                    configurable: true
                });
                ProtocolOdata3.prototype.deserialize = function (data, knownType, requstContext) {
                    return new odata.DeserializerOdata3(data, requstContext, this.$service).deserialize(knownType);
                };
                ProtocolOdata3.prototype.getPropertyMetadata = function (propInfo, prop) {
                    return new common.MetadataOdata3(propInfo, prop);
                };
                /**
                 * @inheritDoc
                 */
                ProtocolOdata3.prototype.serialize = function (obj, args) {
                    var options = odata.toSerializerOptions(args);
                    if (options.reference) {
                        return {
                            'uri': this.$service.buildUrl(void (0), void (0), void (0), obj)
                        };
                    }
                    return _super.prototype.serialize.call(this, obj, args);
                };
                return ProtocolOdata3;
            }(odata.ProtocolOdata2));
            odata.ProtocolOdata3 = ProtocolOdata3;
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="Protocol.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            var ODataV4Bind = osa.constants.ODataV4Bind;
            /**
             * OData V4 protocol implementation
             */
            var ProtocolOdata4 = /** @class */ (function (_super) {
                __extends(ProtocolOdata4, _super);
                function ProtocolOdata4(svc) {
                    return _super.call(this, odata.Version.V4, svc) || this;
                }
                ProtocolOdata4.prototype.getPropertyMetadata = function (propInfo, prop) {
                    return new common.MetadataOdata4(propInfo, prop);
                };
                Object.defineProperty(ProtocolOdata4.prototype, "acceptHeader", {
                    get: function () {
                        var format = metadataFormat(this.$service.$context);
                        return "odata.metadata=" + format;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ProtocolOdata4.prototype, "contentType", {
                    get: function () {
                        return 'application/json;odata.metadata=minimal';
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ProtocolOdata4.prototype, "versionMaxHeader", {
                    get: function () {
                        return 'OData-MaxVersion';
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ProtocolOdata4.prototype, "versionHeader", {
                    get: function () {
                        return 'OData-Version';
                    },
                    enumerable: false,
                    configurable: true
                });
                ProtocolOdata4.prototype.queryBuilder = function (expression) {
                    var builder = new osa.query.odata4.Query(null);
                    if (expression == null) {
                        return builder;
                    }
                    return expression(builder);
                };
                ProtocolOdata4.prototype.checkError = function (json, result) {
                    if (!json) {
                        return json;
                    }
                    var errorJson = json['error'];
                    if (!errorJson) {
                        return json;
                    }
                    var fault = errorJson[osa.constants.OsaFault];
                    if (!!fault) {
                        this.patchAbstractClientFault(fault);
                        result.fault = this.deserialize(fault);
                    }
                    throw new osa.error.OdataError(errorJson, result);
                };
                ProtocolOdata4.prototype.createODataObject = function (obj) {
                    var _a;
                    if (obj instanceof osa.base.DataType) {
                        var meta = (_a = {},
                            _a[osa.constants.ODataV4Type] = "#" + Object.getPrototypeOf(obj).constructor.odataType,
                            _a);
                        if (obj instanceof osa.base.Entity && !!obj.$url) {
                            meta[osa.constants.ODataV4Id] = obj.$url;
                        }
                        return meta;
                    }
                    if (obj == null) {
                        return null;
                    }
                    else {
                        return {};
                    }
                };
                ProtocolOdata4.prototype.deserialize = function (data, knownType, requestContext) {
                    return new odata.DeserializerOdata4(data, requestContext, this.$service).deserialize(knownType);
                };
                ProtocolOdata4.prototype.patchAbstractClientFault = function (fault) {
                    if (fault[osa.constants.ODataV4Type] === '#common.AbstractClientFault') {
                        fault[osa.constants.ODataV4Type] = '#common.CommonClientFault';
                    }
                };
                ProtocolOdata4.prototype.odataBind = function (source, target, dtoName, odataName) {
                    var bind = osa.common.odata.getBoundLinks(source);
                    var refs = bind[dtoName];
                    if (refs != null) {
                        target[odataName + ODataV4Bind] = refs;
                    }
                };
                ProtocolOdata4.prototype.serializeArray = function (obj, arg) {
                    var _this = this;
                    var options = odata.toSerializerOptions(arg);
                    var filtered = !options.includeNavigational ? obj.filter(function (it) { return !(it instanceof osa.base.Entity); }) : obj;
                    return filtered.map(function (x) { return _this.serialize(x, options); });
                };
                /**
                 * @inheritDoc
                 * @internal
                 */
                ProtocolOdata4.prototype.buildOperationUrl = function (name, method, data, params) {
                    var url;
                    if (method.toLowerCase() === 'get' && data != null) {
                        var paramsAlias = Object.keys(data).map(function (key) { return key + "=@" + key; }).join(',');
                        url = name + "(" + paramsAlias + ")";
                    }
                    else {
                        url = name + "()";
                    }
                    return url;
                };
                /**
                 * @inheritDoc
                 * @internal
                 */
                ProtocolOdata4.prototype.toUrlData = function (data) {
                    if (data == null) {
                        return data;
                    }
                    var alias = {};
                    for (var key in data) {
                        if (data.hasOwnProperty(key) && data[key][0] !== '@') {
                            alias["@" + key] = data[key];
                        }
                    }
                    return alias;
                };
                /**
                 * @internal
                 */
                ProtocolOdata4.prototype.buildReferenceUrl = function (entity, propertyName, value) {
                    var ref = this.$service.buildUrl(propertyName, '$ref', void (0), entity);
                    if (value) {
                        var entitySet = osa.base.Service.resolveEntitySet(this.$service, value);
                        var id = osa.base.Service.buildIdLink(entitySet.name, value.id);
                        ref = ref + ("?$id=" + osa.base.Service.combineUrl(this.$service.$context.url, id));
                    }
                    return ref;
                };
                /**
                 * @inheritDoc
                 */
                ProtocolOdata4.prototype.serialize = function (obj, arg) {
                    var _a, _b;
                    var _this = this;
                    var options = odata.toSerializerOptions(arg);
                    if (options.reference) {
                        if (Array.isArray(obj)) {
                            return _a = {},
                                _a[osa.constants.ODataV4Value] = obj.map(function (it) { return _this.serialize(it, options); }),
                                _a;
                        }
                        else {
                            var refUrl = this.$service.buildUrl(void (0), void (0), void (0), obj);
                            return _b = {},
                                _b[osa.constants.ODataV4Id] = refUrl,
                                _b;
                        }
                    }
                    return _super.prototype.serialize.call(this, obj, options);
                };
                return ProtocolOdata4;
            }(odata.Protocol));
            odata.ProtocolOdata4 = ProtocolOdata4;
            function metadataFormat(context) {
                var value = context.get(common.Odata4MetadataFormatKey);
                switch (value) {
                    case 'minimal':
                    case 'full':
                    case 'none':
                        return value;
                    default:
                        return 'minimal';
                }
            }
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            /**
             * Base class for request context
             */
            var RequestContext = /** @class */ (function () {
                /**
                 * Creates new instance of request context
                 * @param type a return type
                 * @param isCollection a flag indicating whether the return type is a collection
                 * @param typeFilter
                 */
                function RequestContext(type, isCollection, typeFilter) {
                    if (isCollection === void 0) { isCollection = false; }
                    this.type = type;
                    this.isCollection = isCollection;
                    this.typeFilter = typeFilter;
                }
                RequestContext.prototype.isVoid = function () {
                    return false;
                };
                RequestContext.prototype.isPrimitive = function () {
                    return this.type == null;
                };
                RequestContext.prototype.getBody = function (data) {
                    return data;
                };
                RequestContext.prototype.resolveType = function () {
                    return this.typeFilter || this.type;
                };
                return RequestContext;
            }());
            odata.RequestContext = RequestContext;
            /**
             * Void result request context
             */
            var VoidResultContext = /** @class */ (function (_super) {
                __extends(VoidResultContext, _super);
                function VoidResultContext() {
                    return _super.call(this, null) || this;
                }
                VoidResultContext.prototype.isVoid = function () {
                    return true;
                };
                return VoidResultContext;
            }(RequestContext));
            odata.VoidResultContext = VoidResultContext;
            /**
             * Operation request context
             */
            var OperationContext = /** @class */ (function (_super) {
                __extends(OperationContext, _super);
                /**
                 * Creates new instance of operation request context
                 * @param type a return type of operation
                 * @param isCollection a flag indicating whether the return type is a collection
                 * @param voidOperation a flag indicating whether the operation returns void
                 * @param typeFilter a type filter
                 * @param name a name of operation
                 */
                function OperationContext(type, isCollection, voidOperation, typeFilter, name) {
                    if (isCollection === void 0) { isCollection = false; }
                    if (voidOperation === void 0) { voidOperation = false; }
                    var _this = _super.call(this, type, isCollection, typeFilter) || this;
                    _this.type = type;
                    _this.voidOperation = voidOperation;
                    _this.name = name;
                    return _this;
                }
                OperationContext.prototype.isVoid = function () {
                    return this.voidOperation;
                };
                OperationContext.prototype.getBody = function (data) {
                    // Void result handler for JAVA .Net
                    if (this.voidOperation) {
                        return void (0);
                    }
                    // Primitive response
                    if (!this.type) {
                        return (data || {})['value'];
                    }
                    return data;
                };
                return OperationContext;
            }(RequestContext));
            odata.OperationContext = OperationContext;
            /**
             * Property request context
             */
            var PropertyContext = /** @class */ (function (_super) {
                __extends(PropertyContext, _super);
                function PropertyContext(meta, isCollection) {
                    if (isCollection === void 0) { isCollection = false; }
                    var _this = _super.call(this, null, isCollection) || this;
                    _this.meta = meta;
                    return _this;
                }
                return PropertyContext;
            }(RequestContext));
            odata.PropertyContext = PropertyContext;
            /**
             * Reference request context
             */
            var ReferenceContext = /** @class */ (function (_super) {
                __extends(ReferenceContext, _super);
                function ReferenceContext(isCollection, _isVoid) {
                    var _this = _super.call(this, null, isCollection) || this;
                    _this._isVoid = _isVoid;
                    return _this;
                }
                ReferenceContext.prototype.isVoid = function () {
                    return this._isVoid;
                };
                return ReferenceContext;
            }(RequestContext));
            odata.ReferenceContext = ReferenceContext;
            var DeltaQueryContext = /** @class */ (function (_super) {
                __extends(DeltaQueryContext, _super);
                function DeltaQueryContext(type) {
                    return _super.call(this, type) || this;
                }
                return DeltaQueryContext;
            }(RequestContext));
            odata.DeltaQueryContext = DeltaQueryContext;
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            /**
             * OData 3 JSON response deserializer
             */
            var Deserializer = /** @class */ (function () {
                function Deserializer(response, requestContext, $service) {
                    this.response = response;
                    this.requestContext = requestContext;
                    this.$service = $service;
                }
                return Deserializer;
            }());
            odata.Deserializer = Deserializer;
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            /**
             * OData 3 JSON response deserializer
             */
            var DeserializerOdata3 = /** @class */ (function (_super) {
                __extends(DeserializerOdata3, _super);
                function DeserializerOdata3(response, requestContext, $service) {
                    var _this = _super.call(this, response, requestContext, $service) || this;
                    _this.response = response;
                    _this.requestContext = requestContext;
                    _this.$service = $service;
                    return _this;
                }
                DeserializerOdata3.prototype.recognizeType = function (data, knownType) {
                    var isCollection = false;
                    var odataType = (data['__metadata'] || {})['type']
                        || (data['odata.metadata'] || '').split('#')[1]
                        || knownType;
                    if (odataType !== void (0)) {
                        var m = /^Collection\((.+)\)$/g.exec(odataType);
                        if (!!m) {
                            odataType = m[1];
                            isCollection = true;
                        }
                    }
                    return [
                        odataType,
                        isCollection || (data['__metadata'] === void (0) && 'results' in data)
                    ];
                };
                DeserializerOdata3.prototype.deserialize = function (knownType) {
                    var _a;
                    var response = this.unwrapResponse(this.response);
                    if (this.requestContext instanceof osa.common.odata.PropertyContext) {
                        return this.deserializeProperty(response);
                    }
                    if (this.requestContext instanceof osa.common.odata.ReferenceContext) {
                        return this.requestContext.isVoid() ? void (0) : this.response;
                    }
                    return this.doDeserialize(response, knownType || ((_a = this.requestContext) === null || _a === void 0 ? void 0 : _a.resolveType()));
                };
                DeserializerOdata3.prototype.deserializeProperty = function (payload) {
                    var ctx = this.requestContext;
                    var value = payload;
                    if (!ctx.meta.isComplex()) {
                        return ctx.meta.deserialize(value);
                    }
                    return this.doDeserialize(value, ctx.meta.odataType);
                };
                DeserializerOdata3.prototype.unwrapResponse = function (payload) {
                    var response = payload;
                    if (this.requestContext == null) {
                        return response;
                    }
                    else if (this.requestContext instanceof osa.common.odata.OperationContext) {
                        // expect either 'results' or <operation name> field or an object with the __metadata field
                        if (payload[this.requestContext.name] != null && payload.__metadata === undefined) {
                            response = payload[this.requestContext.name];
                        }
                        if (response['__count'] !== undefined) {
                            return {
                                results: response.results,
                                __count: response['__count'],
                                __next: response['__next']
                            };
                        }
                        if (response['results'] !== undefined) {
                            return response['results'];
                        }
                    }
                    else if (this.requestContext instanceof osa.common.odata.PropertyContext) {
                        // expect either 'results' or <property name> field or an object with the __metadata field
                        if (response[this.requestContext.meta.odataName] !== undefined && response.__metadata === undefined) {
                            response = response[this.requestContext.meta.odataName];
                        }
                        if (response['__count'] !== undefined) {
                            return {
                                results: response.results,
                                __count: response['__count'],
                                __next: response['__next']
                            };
                        }
                        if (response['results'] !== undefined) {
                            return response['results'];
                        }
                    }
                    // do not unwrap 'results' for the rest of the contexts
                    return response;
                };
                DeserializerOdata3.prototype.doDeserialize = function (data, knownType) {
                    var e_8, _a, e_9, _b, _c;
                    var _this = this;
                    if (Array.isArray(data)) {
                        return data.map(function (item) { return _this.doDeserialize(item, knownType); });
                    }
                    if (data !== null && typeof data === 'object') {
                        if (data['__deferred'] !== void (0)) {
                            return new common.Deferred(data['__deferred']['uri'], this.$service);
                        }
                        var _d = __read(this.recognizeType(data, knownType), 2), odataType = _d[0], isCollection = _d[1];
                        if (isCollection) {
                            if (!('results' in data)) {
                                throw new osa.error.GeneralError('Expected "results" do not exist in payload.');
                            }
                            return new common.EntityArray(this.doDeserialize(data['results'], odataType), data['__count'], undefined, new common.Deferred(data['__next'], this.$service));
                        }
                        if (odataType != null) {
                            var uri = (data['__metadata'] || {})['uri'] || null;
                            var __metadata = data['__metadata'];
                            delete data['__metadata'];
                            var typeCtor = this.$service.domain.getDataTypeConstructor(odataType);
                            var propMap = typeCtor.getPropertyMap(typeCtor);
                            var protocol = this.$service.protocol();
                            var result = {};
                            try {
                                for (var _e = __values(Object.getOwnPropertyNames(propMap)), _f = _e.next(); !_f.done; _f = _e.next()) {
                                    var prop = _f.value;
                                    var propInfo = propMap[prop];
                                    var metaInfo = protocol.getPropertyMetadata(propInfo, prop);
                                    var value = data[metaInfo.odataName];
                                    delete data[metaInfo.odataName];
                                    if (value == null) {
                                        result[metaInfo.odataName] = value;
                                        continue;
                                    }
                                    if (typeof value !== 'object') {
                                        result[metaInfo.odataName] = metaInfo.deserialize(value);
                                        continue;
                                    }
                                    if (typeof value === 'object') {
                                        var propertyType = propInfo.r;
                                        result[metaInfo.odataName] = this.doDeserialize(value, propertyType);
                                        continue;
                                    }
                                    throw new osa.error.GeneralError('Unexpected payload format.');
                                }
                            }
                            catch (e_8_1) { e_8 = { error: e_8_1 }; }
                            finally {
                                try {
                                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                                }
                                finally { if (e_8) throw e_8.error; }
                            }
                            try {
                                // Other properties
                                for (var _g = __values(Object.getOwnPropertyNames(data)), _h = _g.next(); !_h.done; _h = _g.next()) {
                                    var prop = _h.value;
                                    result[prop] = data[prop];
                                }
                            }
                            catch (e_9_1) { e_9 = { error: e_9_1 }; }
                            finally {
                                try {
                                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                                }
                                finally { if (e_9) throw e_9.error; }
                            }
                            var dataObject = this.getDataTypeObject(result, typeCtor);
                            if (dataObject instanceof osa.base.Entity) {
                                dataObject.$service = this.$service;
                                dataObject.$url = uri;
                                this.deserializeOdataMedata(__metadata || {}, dataObject);
                            }
                            return dataObject;
                        }
                        else if (data['__metadata'] === void (0)) {
                            var propNames = Object.getOwnPropertyNames(data);
                            if (propNames.length === 1 && propNames[0][0] !== '_') {
                                var val = this.doDeserialize(data[propNames[0]]);
                                if (val instanceof osa.base.DataType) {
                                    var t = (Object.getPrototypeOf(val).constructor || {})['odataType'] || '';
                                    if (t.lastIndexOf(propNames[0]) === t.length - propNames[0].length) {
                                        return val;
                                    }
                                }
                                return _c = {}, _c[propNames[0]] = val, _c;
                            }
                        }
                        throw new osa.error.GeneralError('Unable to resolve the object type');
                    }
                    return data;
                };
                DeserializerOdata3.prototype.deserializeOdataMedata = function (metadata, entity) {
                    var mediaEtag = metadata['media_etag'];
                    var mediaContentType = metadata['content_type'];
                    odata.setOdataMetadata(entity, {
                        mediaEtag: mediaEtag,
                        mediaContentType: mediaContentType
                    });
                };
                DeserializerOdata3.prototype.getDataTypeObject = function (data, ctor) {
                    var result = {};
                    var protocol = this.$service.protocol();
                    if (typeof data === 'object') {
                        var propMap = osa.base.DataType.getPropertyMap(ctor);
                        for (var prop in propMap) {
                            var propInfo = propMap[prop];
                            var metaInfo = protocol.getPropertyMetadata(propInfo, prop);
                            result[metaInfo.name] = metaInfo.deserialize(data[metaInfo.odataName]);
                            delete data[metaInfo.odataName];
                        }
                        for (var prop in data) {
                            result[prop] = data[prop];
                        }
                    }
                    else {
                        var idField = osa.base.DataType.getPropertyName('Id', ctor);
                        if (!!idField) {
                            result[idField] = data;
                        }
                    }
                    return ctor.fromObjectShallow(result);
                };
                return DeserializerOdata3;
            }(odata.Deserializer));
            odata.DeserializerOdata3 = DeserializerOdata3;
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            var ODataV4Context = osa.constants.ODataV4Context;
            /**
             * OData 4 JSON response deserializer
             * Respects response metadata and request context
             */
            var DeserializerOdata4 = /** @class */ (function (_super) {
                __extends(DeserializerOdata4, _super);
                function DeserializerOdata4(response, requestContext, $service) {
                    var _this = _super.call(this, response, requestContext, $service) || this;
                    _this.response = response;
                    _this.requestContext = requestContext;
                    _this.$service = $service;
                    _this.requestContext = _this.requestContext || new odata.RequestContext(null);
                    _this.ODataContext = (_this.response || {})[osa.constants.ODataV4Context];
                    return _this;
                }
                DeserializerOdata4.prototype.getBody = function (response, knownType) {
                    if (this.requestContext.isVoid()) {
                        return void (0);
                    }
                    if (knownType != null && !knownType.startsWith('Edm.')) {
                        return response;
                    }
                    return this.primitiveResponse(response, knownType);
                };
                DeserializerOdata4.prototype.primitiveResponse = function (data, knownType) {
                    return (data || {})['value'];
                };
                DeserializerOdata4.prototype.deserialize = function (knownType) {
                    if (this.requestContext instanceof osa.common.odata.PropertyContext) {
                        return this.deserializeProperty(this.response);
                    }
                    else if (this.requestContext instanceof osa.common.odata.ReferenceContext) {
                        return this.requestContext.isVoid() ? void (0) : this.response;
                    }
                    else if (this.requestContext instanceof osa.common.odata.DeltaQueryContext) {
                        return this.deserializeDeltaFeed(this.response, this.requestContext.type);
                    }
                    return this.doDeserialize(this.response, knownType);
                };
                DeserializerOdata4.prototype.deserializeProperty = function (payload) {
                    var ctx = this.requestContext;
                    var value = payload;
                    if (ctx.meta.isComplex()) {
                        return this.doDeserialize(value, ctx.meta.odataType);
                    }
                    value = value['value'];
                    return ctx.meta.deserialize(value);
                };
                DeserializerOdata4.prototype.doDeserialize = function (response, knownType) {
                    var _this = this;
                    // Retrieve request specific body
                    var odataType = this.tryGetType(response, knownType) || this.requestContext.resolveType();
                    var data = this.getBody(response, odataType);
                    if (data == null || Object.prototype.toString.call(data) !== '[object Object]') {
                        return data;
                    }
                    if (Array.isArray(data)) {
                        return data.map(function (x) { return _this.deserializeValue(x, odataType); });
                    }
                    if (this.isEntitySet(data)) {
                        return new common.EntityArray(data['value'].map(function (x) { return _this.deserializeValue(x, odataType); }), data[osa.constants.OdataV4Count], data[osa.constants.ODataV4DeltaLink], new common.Deferred(data[osa.constants.ODataV4NextLink], this.$service, new odata.RequestContext(odataType, true)));
                    }
                    return this.deserializeValue(data, odataType);
                };
                DeserializerOdata4.prototype.deserializeValue = function (data, type) {
                    if (!data || typeof data !== 'object') {
                        // Simple primitive property
                        return data;
                    }
                    // We can receive derived entity. Trying to get actual type
                    var odataType = this.tryGetType(data, type);
                    return this.deserializeDataType(data, odataType);
                };
                DeserializerOdata4.prototype.deserializeDataType = function (data, type) {
                    var e_10, _a, e_11, _b;
                    var _this = this;
                    type = this.tryGetType(data, type);
                    if (!type) {
                        throw new osa.error.GeneralError('Received object with undefined type.');
                    }
                    var ctor = this.$service.domain.getDataTypeConstructor(type);
                    var propMap = ctor.getPropertyMap(ctor);
                    var result = {};
                    var protocol = this.$service.protocol();
                    var _loop_1 = function (prop) {
                        var value = data[prop];
                        var propInfo = propMap[prop];
                        var metaInfo = protocol.getPropertyMetadata(propInfo, prop);
                        delete data[prop];
                        if (value == null) {
                            result[propInfo.n] = value;
                            return "continue";
                        }
                        if (typeof value !== 'object') {
                            result[propInfo.n] = metaInfo.deserialize(value);
                            return "continue";
                        }
                        if (Array.isArray(value)) {
                            // Respect response metadata type, otherwise take type form property map
                            var arrayType_1 = this_1.tryGetPropertyType(prop, data) || propMap[prop].r;
                            var array = value.map(function (x) { return _this.deserializeValue(x, arrayType_1); });
                            if (metaInfo.isEntityArray()) {
                                // Data type
                                result[propInfo.n] = new common.EntityArray(array, data[osa.constants.OdataV4Count], undefined, new common.Deferred(data[osa.constants.ODataV4NextLink], this_1.$service));
                            }
                            else {
                                // Primitive
                                result[propInfo.n] = value.map(function (x) { return _this.deserializeValue(x, arrayType_1); });
                            }
                            return "continue";
                        }
                        // Plain DataType
                        var objectType = this_1.tryGetType(value) || propMap[prop].r;
                        result[propInfo.n] = this_1.deserializeDataType(value, objectType);
                    };
                    var this_1 = this;
                    try {
                        // Start with own DataType properties
                        for (var _c = __values(Object.getOwnPropertyNames(propMap)), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var prop = _d.value;
                            _loop_1(prop);
                        }
                    }
                    catch (e_10_1) { e_10 = { error: e_10_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_10) throw e_10.error; }
                    }
                    try {
                        // Other properties
                        for (var _e = __values(Object.getOwnPropertyNames(data)), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var prop = _f.value;
                            var value = data[prop];
                            var navigationalName = this.tryGetNavigational(prop);
                            if (navigationalName && !result[navigationalName]) {
                                result[navigationalName] = new common.Deferred(value, this.$service);
                            }
                            else if (!this.isODataProperty(prop)) {
                                result[prop] = value;
                            }
                        }
                    }
                    catch (e_11_1) { e_11 = { error: e_11_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_11) throw e_11.error; }
                    }
                    var dataObject = ctor.fromObjectShallow(result);
                    if (dataObject instanceof osa.base.Entity) {
                        dataObject.$service = this.$service;
                        dataObject.$url = this.buildAbsoluteEntityUri(data, dataObject);
                        this.deserializeOdataMedata(data, dataObject);
                    }
                    return dataObject;
                };
                DeserializerOdata4.prototype.deserializeOdataMedata = function (payload, entity) {
                    var mediaEtag = payload['@odata.mediaEtag'];
                    var mediaContentType = payload['@odata.mediaContentType'];
                    odata.setOdataMetadata(entity, {
                        mediaEtag: mediaEtag,
                        mediaContentType: mediaContentType
                    });
                };
                DeserializerOdata4.prototype.tryGetType = function (data, knownType) {
                    var type = (data[osa.constants.ODataV4Type] || '').split('#')[1] || knownType;
                    return this.tryGetCollectionType(type);
                };
                DeserializerOdata4.prototype.tryGetNavigational = function (propertyName) {
                    var regExp = new RegExp('^(.+?)@odata\.navigationLink$', 'g');
                    return (regExp.exec(propertyName) || [])[1];
                };
                DeserializerOdata4.prototype.isODataProperty = function (propertyName) {
                    return propertyName.indexOf('@odata') !== -1;
                };
                // We can't check @odata.nextLink or @odata.count because they are optional
                DeserializerOdata4.prototype.isEntitySet = function (obj) {
                    return Array.isArray(obj['value']);
                };
                DeserializerOdata4.prototype.tryGetPropertyType = function (propertyName, data) {
                    var type = (data[propertyName + "@odata.type"] || '').split('#')[1];
                    return this.tryGetCollectionType(type);
                };
                DeserializerOdata4.prototype.tryGetCollectionType = function (type) {
                    if (!type) {
                        return type;
                    }
                    var m = /^Collection\((.+)\)$/g.exec(type);
                    return !!m ? m[1] : type;
                };
                DeserializerOdata4.prototype.buildAbsoluteEntityUri = function (response, entity) {
                    var odataId = response[osa.constants.ODataV4Id];
                    if (odataId) {
                        return odataId.startsWith(this.$service.$context.url) ? odataId : this.$service.$context.url + "/" + odataId;
                    }
                    else {
                        var svcClazz = Object.getPrototypeOf(this.$service).constructor;
                        var entitySet = svcClazz.resolveEntitySet(this.$service, entity);
                        if (entitySet == null) {
                            return null;
                        }
                        return this.$service.$context.url + "/" + (osa.base.Service.buildIdLink(entitySet.name, entity.id));
                    }
                };
                DeserializerOdata4.prototype.deserializeDeltaFeed = function (response, knownType) {
                    var _this = this;
                    var items = response.value.map(function (entry) {
                        var context = entry[ODataV4Context] || "#" + knownType + "/$entity";
                        if (context.endsWith('$deletedLink')) {
                            return new common.DeletedLink(entry.relationship, entry.source, entry.target);
                        }
                        if (context.endsWith('$link')) {
                            return new common.CreatedLink(entry.relationship, entry.source, entry.target);
                        }
                        if (context.endsWith('$deletedEntity')) {
                            return new common.DeletedEntity(entry.id, entry.reason);
                        }
                        if (context.endsWith('$entity')) {
                            var entityType = _this.getEntityTypeNameFromDeltaContext(context);
                            var props = _this.deserializeValue(entry, entityType);
                            props.id = decodeURIComponent(props.id);
                            return new common.ChangedEntity(props.id, context, props);
                        }
                        throw new Error("Unsupported delta entry, context: \"" + context + "\"");
                    });
                    var deltaLink = response['@odata.deltaLink'];
                    var nextPageLink = response['@odata.nextPageLink'];
                    var next = function () { return _this.$service.loadDelta(_this.requestContext.type, nextPageLink); };
                    return new common.DeltaLinkResult(items, next, deltaLink, nextPageLink);
                };
                DeserializerOdata4.prototype.getEntityTypeNameFromDeltaContext = function (context) {
                    var clazz = this.$service.constructor;
                    var entitySetName = this.requestContext.type;
                    if (context) {
                        var matches = context.match(/#([^/]+)/);
                        entitySetName = matches.length ? matches[1] : null;
                    }
                    entitySetName = entitySetName.charAt(0).toLowerCase() + entitySetName.slice(1);
                    return Object.keys(clazz.$entitySetMap)
                        .find(function (entityName) { return clazz.$entitySetMap[entityName] === entitySetName; });
                };
                return DeserializerOdata4;
            }(odata.Deserializer));
            odata.DeserializerOdata4 = DeserializerOdata4;
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            var types;
            (function (types) {
                /**
                 * DateTimeOffset representation
                 */
                var DateTimeOffset = /** @class */ (function () {
                    function DateTimeOffset(date, offset) {
                        this._offset = offset;
                        this._date = new Date(date);
                        if (typeof date === 'string') {
                            var dateParse = date.match(common.isoDateRegexp);
                            if (dateParse[5]) {
                                this._offset = this.getTimeZoneOffset(dateParse[5]);
                            }
                        }
                    }
                    Object.defineProperty(DateTimeOffset.prototype, "offset", {
                        get: function () {
                            return this._offset;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(DateTimeOffset.prototype, "value", {
                        get: function () {
                            return this._date;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    DateTimeOffset.prototype.format = function () {
                        if (typeof this._offset !== 'number') {
                            return this._date.toISOString();
                        }
                        var utc = this._date.getTime() + (this._date.getTimezoneOffset() * 60000);
                        var offset = this._offset / 60;
                        var nd = new Date(utc + (3600000 * offset));
                        return nd.getFullYear()
                            + '-' + this.pad(nd.getMonth() + 1)
                            + '-' + this.pad(nd.getDate())
                            + 'T' + this.pad(nd.getHours())
                            + ':' + this.pad(nd.getMinutes())
                            + ':' + this.pad(nd.getSeconds())
                            + '.' + this.pad(nd.getMilliseconds(), 3)
                            + this.getOffset(this._offset);
                    };
                    DateTimeOffset.prototype.toString = function () {
                        return this.format();
                    };
                    DateTimeOffset.from = function (value, offset) {
                        return parseDateTimeOffset(value);
                    };
                    DateTimeOffset.prototype.getOffset = function (tzo) {
                        if (tzo === void 0) { tzo = 0; }
                        var dif = tzo >= 0 ? '+' : '-';
                        return "" + dif + this.pad(tzo / 60) + ":" + this.pad(tzo % 60);
                    };
                    DateTimeOffset.prototype.pad = function (num, size) {
                        if (size === void 0) { size = 2; }
                        var norm = Math.abs(num << 0);
                        return ('' + norm).padStart(size, '0');
                    };
                    DateTimeOffset.prototype.getTimeZoneOffset = function (str) {
                        var sign = str[0];
                        var time = str.slice(1).split(':');
                        var hours = Number.parseInt(time[0]);
                        var minutes = Number.parseInt(time[1]);
                        return +("" + sign + (hours * 60 + minutes));
                    };
                    return DateTimeOffset;
                }());
                types.DateTimeOffset = DateTimeOffset;
                /**
                 * converts any date-like objects into DateTimeOffset
                 * @internal
                 *
                 * @param input
                 * @returns Date|string
                 */
                function parseDateTimeOffset(input) {
                    if (input === null) {
                        return null;
                    }
                    if (input === undefined) {
                        return undefined;
                    }
                    if (common.isString(input)) {
                        if (common.msDateRegexp.test(input)) {
                            var msDate = (input || '').match(common.msDateRegexp);
                            if (msDate) {
                                var offset = typeof msDate[2] === 'undefined' ? void (0) : +msDate[2];
                                var date = (+msDate[1]);
                                return new odata.types.DateTimeOffset(date - (offset || 0) * 60 * 1000, offset);
                            }
                        }
                        if (common.isoDateRegexp.test(input)) {
                            return new odata.types.DateTimeOffset(input);
                        }
                        if (common.edmDateRegexp.test(input)) {
                            return new odata.types.DateTimeOffset(new Date(input));
                        }
                    }
                    if (common.isDate(input) || common.isNumber(input)) {
                        return new odata.types.DateTimeOffset(input);
                    }
                    if (common.isDateTimeOffset(input)) {
                        return input;
                    }
                    return common.throwError('Invalid DateTimeOffset format');
                }
            })(types = odata.types || (odata.types = {}));
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            var types;
            (function (types) {
                /**
                 * Edm date representation
                 */
                var EdmDate = /** @class */ (function () {
                    function EdmDate(date) {
                        this.date = date;
                        this._date = new Date(date);
                    }
                    Object.defineProperty(EdmDate.prototype, "value", {
                        get: function () {
                            return this._date;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    EdmDate.from = function (value) {
                        return parseEdmDate(value);
                    };
                    EdmDate.prototype.format = function (options) {
                        if (options && options.iso) {
                            return this._date.toISOString();
                        }
                        var month = ("0" + (this._date.getMonth() + 1)).substr(-2);
                        var date = ("0" + this._date.getDate()).substr(-2);
                        return this._date.getFullYear() + "-" + month + "-" + date;
                    };
                    EdmDate.prototype.toString = function () {
                        return this.format({ iso: false });
                    };
                    return EdmDate;
                }());
                types.EdmDate = EdmDate;
                /**
                 * converts any date-like objects into EdmDate
                 * @internal
                 * */
                function parseEdmDate(input) {
                    if (input === null) {
                        return null;
                    }
                    if (input === undefined) {
                        return undefined;
                    }
                    if (common.isString(input)) {
                        if (common.msDateRegexp.test(input)) {
                            var msDate = input.match(common.msDateRegexp);
                            if (msDate) {
                                var offset = typeof msDate[2] === 'undefined' ? 0 : (+msDate[2]);
                                var date = +msDate[1];
                                return new odata.types.EdmDate(date - offset * 60 * 1000);
                            }
                        }
                        if (common.isoDateRegexp.test(input)) {
                            return new odata.types.EdmDate(input);
                        }
                        if (common.edmDateRegexp.test(input)) {
                            return new odata.types.EdmDate(input);
                        }
                    }
                    if (common.isDate(input) || common.isNumber(input)) {
                        return new odata.types.EdmDate(input);
                    }
                    if (common.isEdmDate(input)) {
                        return input;
                    }
                    return common.throwError('Invalid EdmDate format');
                }
            })(types = odata.types || (odata.types = {}));
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        var odata;
        (function (odata) {
            var types;
            (function (types) {
                /**
                 * Edm duration representation
                 */
                var EdmDuration = /** @class */ (function () {
                    function EdmDuration(value) {
                        this.value = value;
                        this.value = __assign({}, value);
                    }
                    EdmDuration.from = function (value) {
                        return parseEdmDuration(value);
                    };
                    EdmDuration.prototype.format = function () {
                        var _this = this;
                        var str = function (prop) {
                            var value = _this.value[prop];
                            if (value == null) {
                                return null;
                            }
                            return value + prop[0].toUpperCase();
                        };
                        var date = [str('years'), str('months'), str('weeks'), str('days')]
                            .filter(function (x) { return x != null; })
                            .join('');
                        var time = [str('hours'), str('minutes'), str('seconds')]
                            .filter(function (x) { return x != null; })
                            .join('');
                        if (date === '' && time == '') {
                            return 'PT0S';
                        }
                        return "P" + date + (time === '' ? '' : 'T' + time);
                    };
                    EdmDuration.prototype.toString = function () {
                        return this.format();
                    };
                    return EdmDuration;
                }());
                types.EdmDuration = EdmDuration;
                function toNumber(x) {
                    if (x === undefined) {
                        return undefined;
                    }
                    return +x;
                }
                function isNull() {
                    var values = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        values[_i] = arguments[_i];
                    }
                    return values.filter(function (x) { return x != null; }).length === 0;
                }
                var durationRegex = /^(-?)P(?=\d|T\d)(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?)?$/;
                function parseEdmDuration(input) {
                    if (input === null) {
                        return null;
                    }
                    if (input === undefined) {
                        return undefined;
                    }
                    if (common.isString(input)) {
                        var match = input.toUpperCase().match(durationRegex);
                        if (match != null) {
                            var format = {};
                            var years = toNumber(match[2]);
                            var months = toNumber(match[3]);
                            var weeks = toNumber(match[4]);
                            var days = toNumber(match[5]);
                            var hours = toNumber(match[6]);
                            var minutes = toNumber(match[7]);
                            var seconds = toNumber(match[8]);
                            if (years !== undefined) {
                                format.years = years;
                            }
                            if (months !== undefined) {
                                format.months = months;
                            }
                            if (weeks !== undefined) {
                                format.weeks = weeks;
                            }
                            if (days !== undefined) {
                                format.days = days;
                            }
                            if (hours !== undefined) {
                                format.hours = hours;
                            }
                            if (minutes !== undefined) {
                                format.minutes = minutes;
                            }
                            if (seconds !== undefined) {
                                format.seconds = seconds;
                            }
                            if (isNull(years, months, weeks, days, hours, minutes, seconds)) {
                                format.seconds = 0;
                            }
                            return new EdmDuration(format);
                        }
                        if (common.isoDateRegexp.test(input)) {
                            return parseEdmDuration(new Date(input));
                        }
                    }
                    if (common.isDate(input)) {
                        var format = {
                            hours: input.getUTCHours(),
                            minutes: input.getUTCMinutes(),
                            seconds: (input.getUTCSeconds() * 1000 + input.getUTCMilliseconds()) / 1000
                        };
                        return new EdmDuration(format);
                    }
                    if (common.isNumber(input)) {
                        return parseEdmDuration(new Date(input));
                    }
                    if (common.isDuration(input)) {
                        return input;
                    }
                    return common.throwError('Invalid EdmDuration format');
                }
            })(types = odata.types || (odata.types = {}));
        })(odata = common.odata || (common.odata = {}));
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var common;
    (function (common) {
        /**
         * Batch calss
         * @internal
         */
        var Batch = /** @class */ (function () {
            function Batch() {
                var _this = this;
                this.options = [];
                this.ready = new Promise(function (done) {
                    _this.promise = new Promise(function (resolve, reject) {
                        _this.resolve = resolve;
                        _this.reject = reject;
                        done();
                    });
                });
            }
            Batch.prototype.request = function (options) {
                var _this = this;
                this.options.push(options);
                return this.ready.then(function () { return _this.promise.then(function () { return _this.result(options); }); });
            };
            Batch.prototype.result = function (options) {
                var idx = this.options.indexOf(options);
                if (idx < 0) {
                    throw new osa.error.GeneralError('Request not found in batch.');
                }
                return this.responses[idx];
            };
            Batch.prototype.cancel = function (err) {
                var _this = this;
                return this.ready
                    .then(function () { return _this.reject(err || new osa.error.GeneralError('Request canceled.')); });
            };
            Batch.prototype.response = function (response) {
                if (!Array.isArray(response) || this.options.length !== response.length) {
                    throw new osa.error.GeneralError('Number of responses do not match number of requests in batch.');
                }
                this.responses = response;
                return this.resolve(this);
            };
            return Batch;
        }());
        common.Batch = Batch;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var osa;
(function (osa) {
    var common;
    (function (common) {
        var HttpStatus = osa.constants.HttpStatus;
        var LocationHeaderName = osa.constants.LocationHeaderName;
        var RetryAfterHeaderName = osa.constants.RetryAfterHeaderName;
        var AsyncResultHeaderName = osa.constants.AsyncResultHeaderName;
        /**
         * An HTTP client.
         */
        var HttpTransport = /** @class */ (function () {
            /**
             * Creates a new instance of HttpTransport.
             * @param ctx The context to use.
             * @protected
             */
            function HttpTransport(ctx) {
                this.ctx = ctx;
            }
            /**
             * Creates a new instance of HttpTransport.
             * @param ctx The context to use.
             */
            HttpTransport.from = function (ctx) {
                return new HttpTransport(ctx);
            };
            /**
             * Sends the request and returns the response.
             * Capabilities:
             * - OIDC authentication, client credentials grant
             * @param options the request options
             * @returns {Promise<HttpResult>}
             */
            HttpTransport.prototype.send = function (options) {
                var _this = this;
                this.log([options.method, options.url].join(' '));
                // keep the call inside the promise chain to maintain the order of execution e.g. callbacks, hooks, etc
                return Promise.resolve().then(function () {
                    return _this.authenticate(options);
                }).then(function (token) {
                    _this.applySecurityToken(options, token);
                }).then(function () {
                    return _this.fetch(options.url, options.fetchOptions);
                });
            };
            /**
             * Logs the message.
             * @param message the message to log
             * @protected
             */
            HttpTransport.prototype.log = function (message) {
                if (this.ctx.logRequests) {
                    console.log(message);
                }
            };
            /**
             * Authenticates the request.
             * @param ctx the context
             * @param options the request options
             * @protected
             */
            HttpTransport.prototype.authenticate = function (options) {
                var fetch = this.ctx.fetch || osa.fetch;
                return osa.security.authenticate(this.ctx, __assign(__assign({}, options), { fetch: fetch }));
            };
            HttpTransport.prototype.applySecurityToken = function (options, token) {
                osa.security.applySecurityToken(this.ctx, options, token);
            };
            HttpTransport.prototype.fetch = function (url, options) {
                var fetch = this.ctx.fetch || osa.fetch;
                return fetch(url, options).then(function (response) {
                    return new common.HttpResult(response);
                });
            };
            return HttpTransport;
        }());
        common.HttpTransport = HttpTransport;
        /**
         * An HTTP client for async requests.
         */
        var AsyncHttpRequest = /** @class */ (function () {
            function AsyncHttpRequest(transport, requestOptions) {
                this.transport = transport;
                this.requestOptions = requestOptions;
                this.co = this.coroutine();
            }
            /**
             * Converts the request to an async request.
             */
            AsyncHttpRequest.from = function (transport, requestOptions, asyncOptions) {
                var _a, _b;
                var wait = (asyncOptions === null || asyncOptions === void 0 ? void 0 : asyncOptions.wait) || 0;
                var preference = "respond-async,wait=" + wait;
                var oldPreferHeaderValue = requestOptions.headers[osa.constants.PreferHeaderName] || '';
                var preferHeaderValue = oldPreferHeaderValue === '' ? preference : oldPreferHeaderValue + ';' + preference;
                var options = __assign(__assign({}, requestOptions), { headers: __assign(__assign({}, requestOptions.headers), (_a = {}, _a[osa.constants.PreferHeaderName] = preferHeaderValue, _a)), fetchOptions: __assign(__assign({}, requestOptions.fetchOptions), { headers: __assign(__assign({}, requestOptions.fetchOptions.headers), (_b = {}, _b[osa.constants.PreferHeaderName.toLowerCase()] = preferHeaderValue, _b)) }) });
                return new AsyncHttpRequest(transport, options);
            };
            /**
             * Polls the async request until it is done.
             */
            AsyncHttpRequest.prototype.send = function () {
                var _this = this;
                return this.poll().then(function (_a) {
                    var done = _a.done, httpResult = _a.httpResult;
                    if (done) {
                        return httpResult;
                    }
                    return _this.delay(AsyncHttpRequest.toDelay(httpResult.headers.get(RetryAfterHeaderName))).then(function () {
                        return _this.send();
                    });
                });
            };
            /**
             * Single poll of the async request.
             * @returns {[boolean, HttpResult, string]} returns true if the async request is done, the response and the location header which is the url to poll
             */
            AsyncHttpRequest.prototype.poll = function () {
                return this.co.next().then(function (_a) {
                    var done = _a.done, httpResult = _a.value;
                    if (done) {
                        return {
                            done: true,
                            httpResult: httpResult,
                            location: null
                        };
                    }
                    return {
                        done: false,
                        location: httpResult.headers.get(LocationHeaderName),
                        httpResult: httpResult
                    };
                });
            };
            AsyncHttpRequest.prototype.coroutine = function () {
                return __asyncGenerator(this, arguments, function coroutine_1() {
                    var options, response, location_1, asyncResultHeader;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                options = this.requestOptions;
                                _a.label = 1;
                            case 1:
                                if (!true) return [3 /*break*/, 9];
                                return [4 /*yield*/, __await(this.transport.send(options))];
                            case 2:
                                response = _a.sent();
                                if (!(response.status === HttpStatus.Accepted)) return [3 /*break*/, 5];
                                location_1 = response.headers.get(LocationHeaderName);
                                options = AsyncHttpRequest.newPoll(options, location_1);
                                return [4 /*yield*/, __await(response)];
                            case 3: return [4 /*yield*/, _a.sent()];
                            case 4:
                                _a.sent();
                                return [3 /*break*/, 1];
                            case 5:
                                asyncResultHeader = response.headers.get(AsyncResultHeaderName);
                                if (!(response.status === HttpStatus.Ok && asyncResultHeader != null)) return [3 /*break*/, 7];
                                return [4 /*yield*/, __await(AsyncHttpRequest.toAsyncResult(response, asyncResultHeader))];
                            case 6: return [2 /*return*/, _a.sent()];
                            case 7: return [4 /*yield*/, __await(response)];
                            case 8: return [2 /*return*/, _a.sent()];
                            case 9: return [2 /*return*/];
                        }
                    });
                });
            };
            /**
             * Converts the response to async result.
             */
            AsyncHttpRequest.toAsyncResult = function (response, asyncResultHeader) {
                // @ts-ignore
                response.status = Number(asyncResultHeader);
                return response;
            };
            /**
             * Creates a new poll request
             * @returns {RequestOptions} returns the new request options and the delay in milliseconds before the next request to be sent
             */
            AsyncHttpRequest.newPoll = function (options, location) {
                if (location == null) {
                    throw new Error('Can not process async request - location header is missing');
                }
                var filter = function (header, value) {
                    if (header.match(AsyncHttpRequest.ContentTypeHeaderRegEx)) {
                        return undefined;
                    }
                    if (!header.match(AsyncHttpRequest.PreferHeaderRegEx)) {
                        return value;
                    }
                    return AsyncHttpRequest.filterPreferHeader(value, AsyncHttpRequest.respondAsyncRegEx);
                };
                return __assign(__assign({}, options), { url: location, method: "GET" /* GET */, headers: __assign({}, AsyncHttpRequest.newHeaders(options.headers, filter)), body: undefined, fetchOptions: __assign(__assign({}, options.fetchOptions), { method: "GET" /* GET */, headers: __assign({}, AsyncHttpRequest.newHeaders(options.fetchOptions.headers, filter)), body: undefined }) });
            };
            AsyncHttpRequest.newHeaders = function (headers, projector) {
                return Object.keys(headers).reduce(function (newHeaders, key) {
                    newHeaders[key] = projector(key, headers[key]);
                    return newHeaders;
                }, {});
            };
            /**
             * Filters out the respond-async part of the Prefer header.
             */
            AsyncHttpRequest.filterPreferHeader = function (preferValue, regExp) {
                if (preferValue == null || preferValue === '') {
                    return;
                }
                return preferValue.split(';').filter(function (p) { return !p.match(regExp); }).map(function (x) { return x.trim(); }).join('; ');
            };
            /**
             * Sends the request and returns the response.
             * @param ms The delay in milliseconds
             */
            AsyncHttpRequest.prototype.delay = function (ms) {
                return common.delay(ms);
            };
            /**
             * Delays the execution.
             * @param retryAfter the retry after header value
             */
            AsyncHttpRequest.toDelay = function (retryAfter) {
                var ms = retryAfter != null ? Number(retryAfter) * 1000 || 1000 : 1000;
                return ms;
            };
            /**
             * Regular expression to match the Prefer header.
             */
            AsyncHttpRequest.PreferHeaderRegEx = /^prefer$/i;
            /**
             * Regular expression to match the Content-Type header.
             */
            AsyncHttpRequest.ContentTypeHeaderRegEx = /^content-type$/i;
            /**
             * Regular expression to match the respond-async part of the Prefer header.
             */
            AsyncHttpRequest.respondAsyncRegEx = /respond-async/i;
            return AsyncHttpRequest;
        }());
        common.AsyncHttpRequest = AsyncHttpRequest;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var base;
    (function (base) {
        /**
         * Base DataType
         */
        var DataType = /** @class */ (function () {
            function DataType(data) {
                checkInstanceCreate(this, DataType);
                var Ctor = this.constructor;
                return Ctor.new(data);
            }
            /**
             * Get OData type for current instance
             * @internal
             */
            DataType.resolveOdataType = function (self) {
                if (self instanceof DataType) {
                    return self.constructor.odataType;
                }
                return null;
            };
            /**
             * @internal
             */
            DataType.fromObject = function (data, builder) {
                var Ctor = this;
                if (data == null) {
                    return null;
                }
                if (data instanceof Ctor) {
                    return data;
                }
                var instance = new Ctor();
                if (typeof data === 'object') {
                    return builder(data, instance);
                }
                if (osa.common.isString(data)) {
                    var idField = instance.getPropertyName('Id');
                    if (!!idField) {
                        instance[idField] = data;
                    }
                }
                else {
                    throw osa.error.ArgumentError('Expected either object or string');
                }
                return instance;
            };
            /**
             * Creates a DataType instance and uses the shallow copy builder
             * Shallow copy is required because the .new does not support creating any Deferred properties.
             *
             * @internal
             */
            DataType.fromObjectShallow = function (data) {
                var Ctor = this;
                return Ctor.fromObject(data, function (data, instance) {
                    return Ctor.shallow(data, instance);
                });
            };
            /**
             * Creates DataType instance from plain javascript object
             * @param data an initializer
             * @returns an initialized instance of particular class
             */
            DataType.new = function (data) {
                var Ctor = this;
                return Ctor.fromObject(data, function (data, instance) {
                    return Ctor.deep(data, instance);
                });
            };
            /**
             * @internal
             */
            DataType.shallow = function (data, instance) {
                return Object.assign(instance, data);
            };
            /**
             * @internal
             */
            DataType.deep = function (data, instance) {
                var propMap = instance.getPropertyMap();
                var usedNames = new Set();
                for (var prop in propMap) {
                    var propInfo = propMap[prop];
                    var metadata = new osa.common.GenericMetadata(propInfo, prop);
                    if (data.hasOwnProperty(metadata.name) || data.hasOwnProperty(prop)) {
                        var value = data[metadata.name];
                        if (value === undefined) {
                            value = data[prop];
                        }
                        if (value != null) {
                            instance[metadata.name] = metadata.createFrom(value);
                        }
                        else {
                            instance[metadata.name] = value;
                        }
                    }
                    usedNames.add(metadata.name);
                    usedNames.add(prop);
                }
                for (var prop in data) {
                    if (usedNames.has(prop)) {
                        continue;
                    }
                    instance[prop] = data[prop];
                }
                return instance;
            };
            /**
             * @internal
             */
            DataType.walk = function (ctor, callback) {
                if (!!ctor) {
                    var result = callback(ctor);
                    if (result !== void (0) && result !== false) {
                        return result;
                    }
                    if (!!ctor.prototype) {
                        var proto = Object.getPrototypeOf(ctor.prototype);
                        if (!!proto) {
                            return DataType.walk(proto.constructor, callback);
                        }
                    }
                }
                return void (0);
            };
            /**
             * @internal
             */
            DataType.getPropertyMap = function (ctor) {
                var properties = {};
                DataType.walk(ctor, function (dataType) {
                    osa.common.extend(properties, dataType.propertyMap);
                });
                return properties;
            };
            /**
             * @internal
             */
            DataType.getPropertyName = function (jsonName, ctor) {
                return DataType.walk(ctor, function (dataType) {
                    var propertyName = (dataType.propertyMap || {})[jsonName];
                    return osa.common.isObject(propertyName) ? propertyName.n : propertyName;
                });
            };
            /**
             * @internal
             */
            DataType.prototype.getPropertyMap = function () {
                var properties = {};
                DataType.walk(Object.getPrototypeOf(this).constructor, function (dataType) {
                    osa.common.extend(properties, dataType.propertyMap);
                });
                return properties;
            };
            /**
             * Map JSON property name to DataType object property name
             * @param jsonName - Name of the property in JSON format
             * @internal
             */
            DataType.prototype.getPropertyName = function (jsonName) {
                return DataType.walk(Object.getPrototypeOf(this).constructor, function (dataType) {
                    var propertyName = (dataType.propertyMap || {})[jsonName];
                    return osa.common.isObject(propertyName) ? propertyName.n : propertyName;
                });
            };
            /**
             * Map OData property name to property type
             * @param clazz - Class to start the search from
             * @param odataName - Name of the property in OData format
             * @internal
             */
            DataType.getPropertyMetadata = function (clazz, odataName) {
                var metadata = DataType.walk(clazz, function (dataType) { var _a; return (_a = dataType.propertyMap) === null || _a === void 0 ? void 0 : _a[odataName]; });
                if (!metadata) {
                    throw new Error("Property " + odataName + " not found in " + clazz.odataType);
                }
                return metadata;
            };
            /**
             * Map OData property name to property type
             * @param clazz - Class to start the search from
             * @param odataName - Name of the property in OData format
             * @returns Property type class for Entity and Complex, an object for Enum and OData type name
             * @internal
             */
            DataType.getDataTypePropertyMetadata = function (clazz, odataName) {
                var metadata = DataType.getPropertyMetadata(clazz, odataName);
                if (!metadata.r2) {
                    throw new Error("Property " + odataName + " in " + clazz.odataType + " is neither entity nor complex type");
                }
                return metadata;
            };
            return DataType;
        }());
        base.DataType = DataType;
        /**
         * @ignore
         */
        function checkInstanceCreate(instance, clazz) {
            var ctor = instance.constructor;
            if (ctor === clazz) {
                throw new Error("Abstract class " + ctor.name + " instantiation; use either proper descendant or deserialization");
            }
        }
        base.checkInstanceCreate = checkInstanceCreate;
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
/// <reference path="DataType.ts"/>
var osa;
(function (osa) {
    var base;
    (function (base) {
        /**
         * @internal
         */
        base.ServiceSymbol = Symbol('$service');
        /**
         * Base class for entities
         */
        var Entity = /** @class */ (function (_super) {
            __extends(Entity, _super);
            function Entity(data) {
                var _this = _super.call(this, data) || this;
                base.checkInstanceCreate(_this, Entity);
                return _this;
            }
            Object.defineProperty(Entity.prototype, "$service", {
                /**
                 * Get associated service
                 * @internal
                 */
                get: function () {
                    return this[base.ServiceSymbol] || this.$module.service;
                },
                /**
                 * Set associated service
                 * @internal
                 */
                set: function (value) {
                    this[base.ServiceSymbol] = value;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Entity.prototype, "$module", {
                /**
                 * Get domain module
                 * @internal
                 */
                get: function () {
                    return Object.getPrototypeOf(this).constructor.$module;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Entity.prototype, "hasStream", {
                /**
                 * Check if entity can be read as stream
                 */
                get: function () {
                    return Object.getPrototypeOf(this).constructor.$hasStream
                        || false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Entity.prototype, "hasMedia", {
                /**
                 * Check if media stream associated with entity
                 */
                get: function () {
                    return !!this.$url && this.$service !== void 0;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * @internal
             */
            Entity.prototype.getDeferredMap = function () {
                var properties = {};
                base.DataType.walk(Object.getPrototypeOf(this).constructor, function (dataType) {
                    if ('deferredMap' in dataType) {
                        osa.common.extend(properties, dataType['deferredMap']);
                    }
                });
                return properties;
            };
            /**
             * Gets media stream URL
             * @param params - Additional query arguments
             * @param name - stream property name
             */
            Entity.prototype.getMediaUrl = function (params, name) {
                if (this.$service === void (0)) {
                    throw new osa.error.ArgumentError('No service instance associated with entity.');
                }
                return this.$service.buildUrl(name, '$value', params, this);
            };
            /**
             * Gets media stream HTTP result
             * @param params - Additional query arguments
             * @returns {Promise<common.HttpResult>} - you can get contents of media stream from HttpResult.text or HttpResult.blob promises.
             */
            Entity.prototype.getMedia = function (params) {
                return this.$service.executeRequest({
                    method: 'GET',
                    url: this.getMediaUrl(params),
                    headers: base.Service.getHeadersDefault(params)
                }, true);
            };
            /**
             * Save media stream
             * @param content - Media Link Entry
             * @param type - Content-Type header indicating its media type
             * @param params - Additional query arguments
             */
            Entity.prototype.putMedia = function (content, type, params) {
                return this.$service.executeRequest({
                    method: 'PUT',
                    url: this.getMediaUrl(params),
                    body: content,
                    bodyType: type,
                    headers: base.Service.getHeadersDefault(params, this.id)
                }, true);
            };
            /**
             * Removed media stream from entity
             * @param params - Additional query arguments
             */
            Entity.prototype.removeMedia = function (params) {
                return this.$service.executeRequest({
                    method: 'DELETE',
                    url: this.getMediaUrl(params).replace('/$value', ''),
                    headers: base.Service.getHeadersDefault(params, this.id)
                }, true);
            };
            /**
             * Gets count of foreign property by making odata $count request
             * @param propertyName - Foreign property to get $count for
             * @param params - Additional query arguments
             * @returns {Promise<number>}
             */
            Entity.prototype.getCount = function (propertyName, params) {
                if (this.$service === void (0)) {
                    throw new osa.error.ArgumentError('No service instance associated with entity.');
                }
                if (this.getDeferredMap()[propertyName] !== 'a') {
                    throw new osa.error.ArgumentError('Property "' + propertyName + '" does not support $count.');
                }
                return this.$service.getCount(propertyName, params, this);
            };
            /**
             * Returns true if navigational property is loaded, otherwise false.
             * @param name - property name
             */
            Entity.prototype.isLoaded = function (name) {
                return this[name] instanceof base.Entity || this[name] instanceof Array || this[name] === null;
            };
            return Entity;
        }(base.DataType));
        base.Entity = Entity;
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
(function (osa) {
    var base;
    (function (base) {
        var odata3;
        (function (odata3) {
            var Entity = /** @class */ (function (_super) {
                __extends(Entity, _super);
                function Entity() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                /**
                 * @inheritDoc
                 */
                Entity.prototype.getCount = function (propertyName, params) {
                    return _super.prototype.getCount.call(this, propertyName, params);
                };
                return Entity;
            }(base.Entity));
            odata3.Entity = Entity;
        })(odata3 = base.odata3 || (base.odata3 = {}));
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
(function (osa) {
    var base;
    (function (base) {
        var odata4;
        (function (odata4) {
            var Entity = /** @class */ (function (_super) {
                __extends(Entity, _super);
                function Entity() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                /**
                 * @inheritDoc
                 */
                Entity.prototype.getCount = function (propertyName, params) {
                    return _super.prototype.getCount.call(this, propertyName, params);
                };
                return Entity;
            }(base.Entity));
            odata4.Entity = Entity;
        })(odata4 = base.odata4 || (base.odata4 = {}));
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
/// <reference path="../base/Entity.ts"/>
var osa;
(function (osa) {
    var common;
    (function (common) {
        var DeltaDeletedEntryReason;
        (function (DeltaDeletedEntryReason) {
            /**
             * Entity is deleted (destroyed).
             */
            DeltaDeletedEntryReason["Deleted"] = "deleted";
            /**
             * Entity is removed from membership in the result(i.e., due to a data change)
             */
            DeltaDeletedEntryReason["Changed"] = "changed";
        })(DeltaDeletedEntryReason = common.DeltaDeletedEntryReason || (common.DeltaDeletedEntryReason = {}));
        /**
         * Represents a changed object.
         */
        var ChangedObject = /** @class */ (function () {
            function ChangedObject() {
            }
            return ChangedObject;
        }());
        /**
         * Represents a changed entity
         */
        var ChangedEntity = /** @class */ (function (_super) {
            __extends(ChangedEntity, _super);
            function ChangedEntity(id, context, props) {
                var _this = _super.call(this) || this;
                _this.id = id;
                _this.context = context;
                _this.props = props;
                return _this;
            }
            return ChangedEntity;
        }(ChangedObject));
        common.ChangedEntity = ChangedEntity;
        /**
         * The id of the entity from which the relationship is defined, which may be absolute or relative.
         */
        var DeletedEntity = /** @class */ (function (_super) {
            __extends(DeletedEntity, _super);
            function DeletedEntity(id, reason) {
                var _this = _super.call(this) || this;
                _this.id = id;
                _this.reason = reason;
                return _this;
            }
            return DeletedEntity;
        }(ChangedObject));
        common.DeletedEntity = DeletedEntity;
        var LinkBase = /** @class */ (function (_super) {
            __extends(LinkBase, _super);
            function LinkBase(
            /**
             * The name of the relationship property on the parent object.
             */
            relationship, 
            /**
             * The id of the entity from which the relationship is defined, which may be absolute or relative.
             */
            source, 
            /**
             * The id of the related entity, which may be absolute or relative.
             */
            target) {
                var _this = _super.call(this) || this;
                _this.relationship = relationship;
                _this.source = source;
                _this.target = target;
                return _this;
            }
            return LinkBase;
        }(ChangedObject));
        var CreatedLink = /** @class */ (function (_super) {
            __extends(CreatedLink, _super);
            function CreatedLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return CreatedLink;
        }(LinkBase));
        common.CreatedLink = CreatedLink;
        var DeletedLink = /** @class */ (function (_super) {
            __extends(DeletedLink, _super);
            function DeletedLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return DeletedLink;
        }(LinkBase));
        common.DeletedLink = DeletedLink;
        var DeltaLinkResult = /** @class */ (function () {
            function DeltaLinkResult(items, next, deltaLink, nextPageLink) {
                this.items = items;
                this.next = next;
                this.deltaLink = deltaLink;
                this.nextPageLink = nextPageLink;
            }
            Object.defineProperty(DeltaLinkResult.prototype, "changedEntities", {
                get: function () {
                    var changes = this.items.filter(function (entry) { return entry instanceof ChangedEntity; });
                    return changes;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DeltaLinkResult.prototype, "deletedEntities", {
                get: function () {
                    var changes = this.items.filter(function (entry) { return entry instanceof DeletedEntity; });
                    return changes;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DeltaLinkResult.prototype, "createdLinks", {
                get: function () {
                    var changes = this.items.filter(function (entry) { return entry instanceof CreatedLink; });
                    return changes;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DeltaLinkResult.prototype, "deletedLinks", {
                get: function () {
                    var changes = this.items.filter(function (entry) { return entry instanceof DeletedLink; });
                    return changes;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DeltaLinkResult.prototype, "hasNext", {
                get: function () {
                    return !!this.nextPageLink;
                },
                enumerable: false,
                configurable: true
            });
            return DeltaLinkResult;
        }());
        common.DeltaLinkResult = DeltaLinkResult;
    })(common = osa.common || (osa.common = {}));
})(osa || (osa = {}));
/// <reference path="DataType.ts"/>
/**
 * Base classes
 * @namespace
 */
var osa;
(function (osa) {
    var base;
    (function (base) {
        /**
         * Base class for complex types
         */
        var Complex = /** @class */ (function (_super) {
            __extends(Complex, _super);
            function Complex(data) {
                var _this = _super.call(this, data) || this;
                base.checkInstanceCreate(_this, Complex);
                return _this;
            }
            return Complex;
        }(base.DataType));
        base.Complex = Complex;
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var base;
    (function (base) {
        /**
        * Entity set implementation
        */
        var EntitySet = /** @class */ (function () {
            /**
             * Constructs instance of EntitySet
             * @param service - Service to which entity set belong to
             * @param name - Entity set name
             * @param _entityType - Entity type (constructor)
             * @param isDerived
             */
            function EntitySet(service, name, _entityType, isDerived) {
                if (isDerived === void 0) { isDerived = false; }
                this.service = service;
                this.name = name;
                this._entityType = _entityType;
                this.isDerived = isDerived;
            }
            Object.defineProperty(EntitySet.prototype, "entityType", {
                /**
                 * @internal
                 */
                get: function () {
                    return this._entityType;
                },
                enumerable: false,
                configurable: true
            });
            EntitySet.prototype.validateParams = function (params) {
                var actualParams = base.Service.toParams(this.service, params);
                if (!this.isDerived) {
                    return actualParams;
                }
                if (actualParams.typeFilter) {
                    throw osa.error.ArgumentError('Cannot use type filter with derived entity set.');
                }
                actualParams.typeFilter = this.entityType.odataType;
                return actualParams;
            };
            /**
             * Gets single entity by identifier or OData params
             * @param id - Entity identifier
             * @param params - Additional OData parameters
             */
            EntitySet.prototype.one = function (id, params) {
                var p = this.validateParams(params);
                p.id = id;
                return this.service.requestEntitySet(this.name, this.entityType.odataType, p);
            };
            /**
             * Gets multiple entities by OData params
             * @param params - Additional OData parameters
             */
            EntitySet.prototype.many = function (params) {
                return this.service.requestEntitySet(this.name, this.entityType.odataType, this.validateParams(params));
            };
            EntitySet.prototype.add = function (entity, params) {
                var _this = this;
                var entities = Array.isArray(entity) ? entity : [entity];
                var validParams = this.validateParams(params);
                var result = entities.map(function (e) {
                    if (!(e instanceof _this.entityType)) {
                        throw osa.error.ArgumentError('Entity to add must be of type "' + _this.entityType.odataType + '" or derived.');
                    }
                    return _this.service.updateEntitySet(_this.name, validParams, 'POST', e);
                });
                if (result.length === 1) {
                    return result[0];
                }
                else if (result.length === 0) {
                    return Promise.resolve();
                }
                return Promise.all(result);
            };
            EntitySet.prototype.update = function (entityOrArray, params) {
                return this.modifyEntities('PATCH', entityOrArray, this.validateParams(params));
            };
            EntitySet.prototype.replace = function (entityOrArray, params) {
                return this.modifyEntities('PUT', entityOrArray, this.validateParams(params));
            };
            EntitySet.prototype.remove = function () {
                var _this = this;
                var input = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    input[_i] = arguments[_i];
                }
                var removeInternal = function (args, params) {
                    var promises = [];
                    for (var i = 0; i < args.length; i++) {
                        var arg = args[i];
                        var id = void 0;
                        if (Array.isArray(arg)) {
                            return promises.concat(removeInternal(arg, params));
                        }
                        else if (arg instanceof base.Entity) {
                            id = arg.id;
                        }
                        else if (typeof arg === 'string') {
                            id = arg;
                        }
                        else {
                            throw osa.error.ArgumentError('Params must be last argument.');
                        }
                        var validParams = _this.validateParams(params);
                        var p = _this.service.updateEntitySet(_this.name, new osa.common.ODataParamsWithId(id, validParams), 'DELETE');
                        promises.push(p);
                    }
                    return promises;
                };
                function splitParams(args) {
                    if (args.length > 0) {
                        var last = args[args.length - 1];
                        if (typeof last === 'string' || last instanceof base.Entity || Array.isArray(last)) {
                            return [args, undefined];
                        }
                        else {
                            return [args.slice(0, -1), last];
                        }
                    }
                    return [[], undefined];
                }
                var _a = __read(splitParams(input), 2), args = _a[0], options = _a[1];
                switch (args.length) {
                    case 0: {
                        return Promise.resolve();
                    }
                    case 1: {
                        var result = removeInternal(args, options);
                        if (Array.isArray(args[0])) {
                            return Promise.all(result).then(function () { return undefined; });
                        }
                        return result[0];
                    }
                    default: {
                        return Promise.all(removeInternal(args, options)).then(function () { return undefined; });
                    }
                }
            };
            /**
             * Gets $count for entity set
             * @params
             */
            EntitySet.prototype.getCount = function (params) {
                return this.service.getCount(this.name, this.validateParams(params));
            };
            /**
             * Save media stream
             * @param content - Media Link Entry
             * @param bodyType - Content-Type header indicating its media type
             * @param params - Additional query arguments
             */
            EntitySet.prototype.addMedia = function (content, bodyType, params) {
                if (!this.entityType.$hasStream) {
                    throw osa.error.ArgumentError('Entity set does not support media streams.');
                }
                var p = this.validateParams(params);
                var headers = p.headers || {};
                var url = this.service.buildUrl(this.name, '', p, null);
                var requestContext = this.service.createRequestContext(this.entityType.odataType, false, p);
                return this.service.executeRequest({
                    method: 'POST',
                    url: url,
                    body: content,
                    bodyType: bodyType,
                    headers: headers,
                    requestContext: requestContext
                }, false);
            };
            /**
             * @internal
             */
            EntitySet.prototype.modifyEntities = function (method, entityOrArray, params) {
                var _this = this;
                var entities = Array.isArray(entityOrArray) ? entityOrArray : [entityOrArray];
                if (!!entities) {
                    var result = entities.map(function (e) {
                        if (!(e instanceof _this.entityType)) {
                            throw osa.error.ArgumentError('Expected entity of type "' + _this.entityType.odataType + '".');
                        }
                        return _this.service.updateEntitySet(null, params, method, e);
                    });
                    if (result.length === 1) {
                        return result[0];
                    }
                    else if (result.length === 0) {
                        return Promise.resolve(undefined);
                    }
                    return Promise.all(result);
                }
                return Promise.reject(entities);
            };
            return EntitySet;
        }());
        base.EntitySet = EntitySet;
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
(function (osa) {
    var base;
    (function (base) {
        var odata4;
        (function (odata4) {
            var EntitySet = /** @class */ (function (_super) {
                __extends(EntitySet, _super);
                function EntitySet(service, name, entityType, isDerived) {
                    if (isDerived === void 0) { isDerived = false; }
                    return _super.call(this, service, name, entityType, isDerived) || this;
                }
                EntitySet.prototype.derived = function (derivedType) {
                    if (!this.entityType.prototype.isPrototypeOf(derivedType.prototype)) {
                        throw osa.error.ArgumentError('Derived type must be derived from entity type.');
                    }
                    return new EntitySet(this.service, this.name, derivedType, true);
                };
                EntitySet.prototype.loadDelta = function (deltaUrl) {
                    return this.service.loadDelta(this.name, deltaUrl);
                };
                return EntitySet;
            }(base.EntitySet));
            odata4.EntitySet = EntitySet;
        })(odata4 = base.odata4 || (base.odata4 = {}));
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
(function (osa) {
    var base;
    (function (base) {
        var odata3;
        (function (odata3) {
            var EntitySet = /** @class */ (function (_super) {
                __extends(EntitySet, _super);
                function EntitySet(service, name, entityType, isDerived) {
                    if (isDerived === void 0) { isDerived = false; }
                    return _super.call(this, service, name, entityType, isDerived) || this;
                }
                EntitySet.prototype.derived = function (derivedType) {
                    if (!this.entityType.prototype.isPrototypeOf(derivedType.prototype)) {
                        throw osa.error.ArgumentError('Derived type must be derived from entity type.');
                    }
                    return new EntitySet(this.service, this.name, derivedType, true);
                };
                return EntitySet;
            }(base.EntitySet));
            odata3.EntitySet = EntitySet;
        })(odata3 = base.odata3 || (base.odata3 = {}));
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    /**
     * Sets the current authentication token handler
     * @param handler a new handler
     */
    function setAuthenticationFlow(handler) {
        osa.authenticationFlow = handler || new osa.security.ClientCredentialsFlow();
    }
    osa.setAuthenticationFlow = setAuthenticationFlow;
})(osa || (osa = {}));
(function (osa) {
    var security;
    (function (security) {
        /**
         * @internal
         */
        function getToken(context) {
            var token = typeof context.token === 'string' ? context.token : (context.token != null && typeof context.token === 'object' && 'content' in context.token
                ? context.token.content
                : void (0));
            return token;
        }
        security.getToken = getToken;
        /**
         * @internal
         */
        function applySecurityToken(context, options, token) {
            if (typeof token === 'string' && token != '') {
                var useHeaders = context.securityOptions.useHeaders || osa.common.TokenHeaders.UseSecurityToken;
                if (useHeaders === osa.common.TokenHeaders.UseBoth || useHeaders === osa.common.TokenHeaders.UseAuthorization) {
                    options.fetchOptions.headers['authorization'] = options.headers['Authorization'] = "Bearer " + token;
                }
                if (useHeaders === osa.common.TokenHeaders.UseBoth || useHeaders === osa.common.TokenHeaders.UseSecurityToken) {
                    options.fetchOptions.headers['securitytoken'] = options.headers['SecurityToken'] = token;
                }
            }
        }
        security.applySecurityToken = applySecurityToken;
        /**
         * @internal
         */
        function authenticate(context, requestOptions) {
            if (!context.securityOptions.useAuthenticationFlow) {
                return;
            }
            var handler = osa.authenticationFlow || (osa.authenticationFlow = new security.ClientCredentialsFlow());
            return handler.authenticate(context, requestOptions);
        }
        security.authenticate = authenticate;
    })(security = osa.security || (osa.security = {}));
})(osa || (osa = {}));
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var osa;
(function (osa) {
    var security;
    (function (security) {
        function btoa(s) {
            return Buffer.from(s, 'utf8').toString('base64');
        }
        function encodeScope(scope) {
            if (scope == null || scope.length === 0) {
                return '';
            }
            var scopes = typeof scope === 'string' ? [scope] : scope;
            return "&scope=" + encodeURIComponent(scopes.join(' '));
        }
        function createError(cause) {
            var error = new Error('Unexpected OIDC error');
            Reflect.set(error, 'cause', cause);
            return error;
        }
        /**
         * The OIDC client credentials flow handler.
         */
        var ClientCredentialsFlow = /** @class */ (function () {
            function ClientCredentialsFlow() {
                if (!osa.common.isNodeEnvironment()) {
                    throw new Error('Browser platform is not supported');
                }
            }
            Object.defineProperty(ClientCredentialsFlow.prototype, "lastResponse", {
                /**
                 * The last access token received from the OIDC server.
                 */
                get: function () {
                    if (this.storage == null) {
                        return null;
                    }
                    var _a = this.storage, dummy = _a.expirationTime, response = __rest(_a, ["expirationTime"]);
                    return response;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * @inheritDoc
             */
            ClientCredentialsFlow.prototype.authenticate = function (context, requestOptions) {
                var _this = this;
                var now = new Date();
                if (this.storage != null && this.storage.expirationTime.getTime() >= now.getTime()) {
                    return Promise.resolve(this.lastResponse.access_token);
                }
                return ClientCredentialsFlow.requestAccessToken(context.securityOptions.clientCredentialsFlow, requestOptions).then(function (response) {
                    var tokenType = String(response && response.token_type).toLowerCase();
                    if (tokenType !== 'bearer') {
                        throw new Error('Unsupported token type:' + response.token_type);
                    }
                    _this.saveResponse(response, now);
                    return response.access_token;
                });
            };
            ClientCredentialsFlow.prototype.saveResponse = function (response, now) {
                var offsetInMilliseconds = Math.round((response.expires_in * 1000) * 0.9);
                var expirationTime = new Date(now.getTime() + offsetInMilliseconds);
                this.storage = __assign(__assign({}, response), { expirationTime: expirationTime });
            };
            /**
             * Request access token. Makes a fetch request to the OIDC service with the provided params.
             * @param request a request parameters object
             * @param options
             * @return the json returned by the OIDC server
             */
            ClientCredentialsFlow.requestAccessToken = function (request, options) {
                if (request == null || request.url == null || request.key == null || request.secret == null) {
                    throw new TypeError('Invalid options for the oidc call');
                }
                var fetch = (options === null || options === void 0 ? void 0 : options.fetch) || osa.fetch;
                var url = request.url, scope = request.scope, key = request.key, secret = request.secret;
                var init = {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                        'accept': 'application/json',
                        'authorization': "Basic " + btoa(key + ':' + secret),
                    },
                    body: "grant_type=client_credentials" + (encodeScope(scope))
                };
                return fetch(url, init).then(function (x) {
                    if (x.ok) {
                        return x.json();
                    }
                    throw x;
                }).catch(function (error) {
                    throw createError(error);
                });
            };
            return ClientCredentialsFlow;
        }());
        security.ClientCredentialsFlow = ClientCredentialsFlow;
    })(security = osa.security || (osa.security = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var base;
    (function (base_1) {
        var appendQueryString = osa.common.appendQueryString;
        var lowerCaseHeaders = osa.common.lowerCaseHeaders;
        var getToken = osa.security.getToken;
        var applySecurityToken = osa.security.applySecurityToken;
        var BatchSymbol = osa.common.BatchSymbol;
        var MetaFlags = osa.common.MetaFlags;
        var BuiltRequestSymbol = osa.common.BuiltRequestSymbol;
        /**
         * Base class for domain services
         * @event makeUrl
         * @event beforeRequest
         * @event afterRequest
         * @event requestFinished
         */
        var Service = /** @class */ (function (_super) {
            __extends(Service, _super);
            /**
             * Constructs instance of Service
             * @param context - Service specific configuration
             * @constructor
             */
            function Service(context) {
                var _this = _super.call(this) || this;
                if (context === osa.context) {
                    throw osa.error.GeneralError('Global context should not be used for new service instances.');
                }
                _this.$entitySets = {};
                _this.context = osa.common.Context.cast(context);
                Object.defineProperty(_this, '$context', {
                    configurable: false,
                    enumerable: false,
                    value: new osa.common.CompiledContext(_this)
                });
                return _this;
            }
            Object.defineProperty(Service.prototype, "protocolVersion", {
                /**
                 * Gets supported protocol version
                 */
                get: function () {
                    // OSA2 supports ODATA 2.0 which is compatible to ODATA 3.0
                    return osa.common.odata.Version.V3;
                },
                enumerable: false,
                configurable: true
            });
            ;
            Service.prototype.protocol = function () {
                return new osa.common.odata.ProtocolOdata3(this);
            };
            Object.defineProperty(Service.prototype, "name", {
                /**
                 * Gets service name
                 */
                get: function () {
                    return this.domain.name;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Service.prototype, "batchMode", {
                /**
                 * Gets batch mode status
                 */
                get: function () {
                    return !!this.$batch;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * Init HTTP headers
             * @param params - Query arguments
             * @param id - Id
             * @internal
             */
            Service.getHeadersDefault = function (params, id) {
                var headers = (params || {}).headers || {};
                headers[osa.constants.AcceptHeaderName] = headers[osa.constants.AcceptHeaderName] || '*/*';
                return Service.getSlugHeader(headers, id);
            };
            /**
             * Encodes entity identifier
             * @param id - Entity id
             * @deprecated Use either osa.common.encodeUri or osa.common.encodeString
             */
            Service.encodeEntityId = function (id) {
                return osa.common.encodeUri(id).replace(/'/g, "''");
            };
            /**
             * Build up name along with id
             * @param name - Resource name
             * @param id - Resource id
             * @private
             */
            Service.buildIdLink = function (name, id) {
                return name + "('" + Service.encodeEntityId(id) + "')";
            };
            /**
             * @internal
             */
            Service.combineUrl = function (base, relative) {
                var rest = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    rest[_i - 2] = arguments[_i];
                }
                var segments = [];
                base = base || '';
                relative = relative || '';
                if (relative.toUpperCase().indexOf(base.toUpperCase()) !== 0) {
                    segments.push(base);
                }
                segments.push(relative);
                return segments.concat(rest)
                    .filter(function (x) { return !!x; })
                    .join(base.lastIndexOf('/') === (base.length - 1) ? '' : '/');
            };
            /**
             * @param headers - Http headers
             * @param id - Id
             * @internal
             */
            Service.getSlugHeader = function (headers, id) {
                if (id) {
                    headers['slug'] = "Id(" + Service.encodeEntityId(id) + ")";
                }
                return headers;
            };
            /**
             * Starts Batch request mode
             */
            Service.prototype.initBatch = function () {
                var _this = this;
                if (this.batchMode) {
                    throw new osa.error.GeneralError('Batch mode already initiated.');
                }
                this.$batch = new osa.common.Batch();
                return this.$batch.ready.then(function () { return _this; });
            };
            /**
             * Execute pending requests
             * @param continueBatch - Keep batch mode (default: false)
             */
            Service.prototype.execBatch = function (continueBatch) {
                if (continueBatch === void 0) { continueBatch = false; }
                var batch = this.$batch;
                if (!this.batchMode || !batch) {
                    return Promise.reject(new osa.error.GeneralError('Batch mode is not initiated.'));
                }
                this.$batch = undefined;
                if (continueBatch) {
                    this.initBatch();
                }
                return this.execBatchInternal(batch);
            };
            /**
             * @internal
             */
            Service.prototype.execBatchInternal = function (batch) {
                var _a;
                return this.executeRequest((_a = {
                        method: 'POST',
                        url: this.buildUrl('$batch', null, null, null),
                        batch: batch.options
                    },
                    _a[BatchSymbol] = null,
                    _a), true)
                    .then(function (responses) {
                    return batch.response(responses);
                })
                    .catch(function (err) {
                    return batch.cancel(err)
                        .then(function () {
                        throw err;
                    });
                });
            };
            /**
             * Cancels pending batch requests
             */
            Service.prototype.cancelBatch = function () {
                if (this.$batch && !this.batchMode) {
                    return Promise.reject(new osa.error.GeneralError('Batch mode is not initiated.'));
                }
                var batch = this.$batch;
                this.$batch = undefined;
                return batch.cancel();
            };
            /**
             * Attach entity to this service instance
             * @param entity - Entity to attach
             */
            Service.prototype.attachEntity = function (entity) {
                if (!!entity) {
                    entity.$service = this;
                }
                return entity;
            };
            /**
             * Build URL for specified service resource
             * @param name - Resource name
             * @param tail - Resource tail
             * @param params - Additional query arguments
             * @param entity - Context entity
             * @internal
             * @eventsource makeUrl
             */
            Service.prototype.buildUrl = function (name, tail, params, entity) {
                var p = Service.toParams(this, params);
                this.trigger('makeUrl', name, p, entity, this);
                var url;
                if (entity instanceof base_1.Entity) {
                    var entitySet = Service.resolveEntitySet(this, entity);
                    if (!entitySet) {
                        throw new osa.error.GeneralError("Entity set for entity " + entity.constructor.name + " not found.");
                    }
                    var urlBase = entity.$url || this.buildUrl(entitySet.name, '', new osa.common.Params({ id: entity.id }), null);
                    url = name === null ? urlBase : Service.combineUrl(urlBase, name);
                }
                else {
                    if (p.id != null) {
                        name = Service.buildIdLink(name, p.id);
                    }
                    url = Service.combineUrl(this.$context.url, name);
                }
                url = p.typeFilter == null ? url : Service.combineUrl(url, p.typeFilter);
                url = (tail == null || tail === '') ? url : Service.combineUrl(url, tail);
                return appendQueryString(url, p.toQueryString());
            };
            /**
             * Executes raw OSA request
             * @param requestOptions - request options
             * @param rawHttpResult - allow raw http result
             * @event beforeRequest
             * @event afterRequest
             * @event resultLoaded
             * @event requestFinished
             */
            Service.prototype.executeRequest = function (requestOptions, rawHttpResult) {
                var options = this.buildRequest(requestOptions);
                // warning: batch issue - this event can throw exceptions outside the promise chain
                this.trigger('beforeRequest', options, this);
                // warning: batch issue - this call has to be outside the promise chain
                var promise = this.getHttpResult(options);
                return this.executeRequestTail(promise, options, rawHttpResult);
            };
            /**
             * @internal
             */
            Service.prototype.executeRequestTail = function (promise, options, rawHttpResult) {
                var _this = this;
                var httpResult;
                return Promise.resolve(promise).then(function (result) {
                    httpResult = result;
                    _this.trigger('afterRequest', httpResult, options, _this);
                    return result;
                }, function (err) {
                    httpResult = new osa.error.GeneralError('Network error', err);
                    err.correlationId = httpResult.correlationId = osa.common.getCorrelationId(options, httpResult);
                    _this.trigger('afterRequest', httpResult, options, _this);
                    return Promise.reject(err);
                }).then(function (result) {
                    var protocol = _this.protocol();
                    return protocol.loadResult(options, rawHttpResult)(result);
                }).then(function (result) {
                    _this.trigger('resultLoaded', result, options, _this);
                    _this.trigger('requestFinished', httpResult, result, options, _this);
                    return result;
                }, function (err) {
                    err.correlationId = osa.common.getCorrelationId(options, httpResult);
                    _this.trigger('requestFinished', httpResult, err, options, _this);
                    return Promise.reject(err);
                });
            };
            /**
             * Removes entity link
             * @param entity - Entity object
             * @param propertyName - Property
             * @param value - Entity object to remove (required for removal from collection)
             */
            Service.prototype.removeEntityLink = function (entity, propertyName, value) {
                return this.updateEntityLink(entity, propertyName, 'DELETE', value);
            };
            /**
             * Adds entity to a collection
             * @param entity - Entity object
             * @param propertyName - Property
             * @param value - Other entity to add into collection
             */
            Service.prototype.addEntityLink = function (entity, propertyName, value) {
                return this.updateEntityLink(entity, propertyName, 'POST', value);
            };
            /**
             * Sets or removes link between entities
             * @param entity - Entity object
             * @param propertyName - Property
             * @param value - Property value to set
             */
            Service.prototype.setEntityLink = function (entity, propertyName, value) {
                return this.updateEntityLink(entity, propertyName, 'PUT', value);
            };
            /**
             * Updates links between entities
             * @param entity
             * @param propertyName
             * @param method
             * @param value
             * @returns {Promise<common.HttpResult>}
             */
            Service.prototype.updateEntityLink = function (entity, propertyName, method, value) {
                var url = this.protocol().buildReferenceUrl(entity, propertyName, method === 'DELETE' ? value : null);
                var options = {
                    method: method,
                    url: url
                };
                if (value instanceof base_1.Entity && method !== 'DELETE') {
                    options.data = this.protocol().serialize(value, { reference: true });
                }
                return this.executeRequest(options, true);
            };
            /**
             * Resolve deferred property
             * @param entity - context entity
             * @param name - property name
             * @param params - Additional query arguments
             */
            Service.prototype.requestEntityProperty = function (entity, name, params) {
                var clazz = Object.getPrototypeOf(entity).constructor;
                var type = base_1.DataType.getPropertyMetadata(clazz, name);
                var isCollection = (type.f & MetaFlags.Array) === MetaFlags.Array;
                var odataType = type.r;
                return this.executeRequest({
                    method: 'GET',
                    url: this.buildUrl(name, '', params, entity),
                    headers: (params || {})['headers'],
                    requestContext: this.createRequestContext(odataType, isCollection, params)
                });
            };
            /**
             * @internal
             */
            Service.prototype.requestDeferred = function (url, requestContext, params) {
                var p = Service.toParams(this, params);
                var u = appendQueryString(url, p.toQueryString());
                var headers = p.headers || {};
                return this.executeRequest({
                    method: 'GET',
                    url: u,
                    headers: headers,
                    requestContext: requestContext
                });
            };
            /**
             * Remove/update/replace entity
             * @param name
             * @param params
             * @param method
             * @param entity
             * @internal
             */
            Service.prototype.updateEntitySet = function (name, params, method, entity) {
                var p = Service.toParams(this, params);
                var isPost = method === 'POST';
                var type = base_1.DataType.resolveOdataType(entity);
                var requestContext = this.createRequestContext(type, false, params);
                var headers = p.headers || {};
                var options = {
                    method: method || 'GET',
                    url: this.buildUrl(name, '', p, isPost ? void (0) : entity),
                    data: entity,
                    headers: headers,
                    includeNavigational: isPost,
                    requestContext: requestContext
                };
                var rawHttpResult = method === 'DELETE';
                return this.executeRequest(options, rawHttpResult);
            };
            /**
             * Retrieves one/many entities
             * @param name
             * @param type
             * @param params
             */
            Service.prototype.requestEntitySet = function (name, type, params) {
                var p = Service.toParams(this, params);
                var isCollection = p.id == null;
                var requestContext = this.createRequestContext(type, isCollection, p);
                var headers = p.headers || {};
                var options = {
                    method: 'GET',
                    url: this.buildUrl(name, '', p, null),
                    headers: headers,
                    requestContext: requestContext
                };
                return this.executeRequest(options);
            };
            /**
             * @internal
             */
            Service.prototype.createRequestContext = function (type, isCollection, params) {
                return new osa.common.odata.RequestContext(type, isCollection, params === null || params === void 0 ? void 0 : params.typeFilter);
            };
            /**
             * @internal
             */
            Service.createOperationRequestContext = function (name, context, params) {
                if (context == null) {
                    // an osa 2.7 compatibility - the domain definition does not contain the operation context
                    return null;
                }
                return new osa.common.odata.OperationContext(context.type, context.isCollection, context.voidOperation, params === null || params === void 0 ? void 0 : params.typeFilter, name);
            };
            /**
             * Get entity set for specified entity type
             * @param svc
             * @param entity
             * @internal
             */
            Service.resolveEntitySet = function (svc, entity) {
                var svcClazz = svc instanceof Service ? Object.getPrototypeOf(svc).constructor : svc;
                var entityClazz = entity instanceof base_1.Entity ? Object.getPrototypeOf(entity).constructor : entity;
                var entitySet = base_1.DataType.walk(entityClazz, function (type) {
                    if (svcClazz.$entitySetMap[type.odataType] !== void (0)) {
                        var entitySetName = svcClazz.$entitySetMap[type.odataType];
                        return svc[entitySetName];
                    }
                });
                if (entitySet == null) {
                    throw new Error("Entity set for type " + entityClazz.odataType + " is not found");
                }
                return entitySet;
            };
            /**
             * @param name
             * @param params
             * @param entity
             */
            Service.prototype.getCount = function (name, params, entity) {
                var p = Service.toParams(this, params);
                var headers = p.headers || {};
                return this.executeRequest({
                    method: 'GET',
                    url: this.buildUrl(name, '$count', p, entity),
                    headers: headers
                }, true)
                    .then(function (result) { return result.text; })
                    .then(parseInt);
            };
            /**
             * @internal
             */
            Service.prototype.trigger = function (name) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                _super.prototype.trigger.apply(this, arguments);
                this.$context.trigger(arguments);
            };
            /**
             * An http client
             * @param options - Request options
             * @returns {Promise<common.HttpResult>>} - Http result
             */
            Service.prototype.getHttpResult = function (options) {
                var batch = options[BatchSymbol];
                if (batch && !options.batch) {
                    // not an http request, just a batch request part
                    return batch.request(options);
                }
                var httpRequest = this.protocol().getHttpRequest(this.$context);
                return httpRequest.send(options);
            };
            /**
             * build request
             * @internal
             */
            Service.prototype.buildRequest = function (options) {
                var e_12, _a;
                if (options[BuiltRequestSymbol]) {
                    return options;
                }
                var context = this.$context;
                var headerNameDelimiter = context.headerNameDelimiter || osa.common.HeaderNameDelimiter.Dot;
                options[BatchSymbol] = options[BatchSymbol] || this.$batch || null;
                options.headers = __assign(__assign({}, context.headers), options.headers);
                var clientInfo = osa.common.extend(osa.common.getDefaultClientInfo(this.domain), context.clientInfo || {});
                try {
                    for (var _b = __values(Object.getOwnPropertyNames(clientInfo)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var ciName = _c.value;
                        options.headers[['ClientInfo', osa.common.capitalize(ciName)].join(headerNameDelimiter)] = clientInfo[ciName];
                    }
                }
                catch (e_12_1) { e_12 = { error: e_12_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_12) throw e_12.error; }
                }
                if (options.headers[osa.constants.CorrelationIdName] === void (0)) {
                    var correlationIdHeader = {};
                    correlationIdHeader[osa.constants.CorrelationIdName] = osa.common.uuid();
                    osa.common.extend(options.headers, correlationIdHeader);
                }
                var requestProtocol = this.protocol();
                if (options.batch) {
                    options.headers[osa.constants.AcceptHeaderName] = 'multipart/mixed';
                }
                if (osa.constants.AcceptHeaderName in options.headers) {
                    // options.headers[osa.constants.AcceptHeaderName] = [
                    // 	options.headers[osa.constants.AcceptHeaderName],
                    // 	requestProtocol.acceptHeader
                    // ].join(';');
                }
                else {
                    options.headers[osa.constants.AcceptHeaderName] = "application/json;" + requestProtocol.acceptHeader;
                }
                options.headers[requestProtocol.versionMaxHeader] =
                    options.headers[requestProtocol.versionHeader] = requestProtocol.version + ".0";
                var isGetMethod = options.method.toLowerCase() === 'get';
                if (options.data) {
                    if (isGetMethod) {
                        var p = osa.common.ODataParams.cast(options.data);
                        options.url = appendQueryString(options.url, p.toQueryString(requestProtocol));
                        delete options.data;
                    }
                    else {
                        var args = {
                            includeNavigational: options.includeNavigational,
                            allProperties: options.method !== 'PATCH'
                        };
                        options.body = stringifyPayload(requestProtocol.serialize(options.data, args), requestProtocol.version);
                        options.bodyType = requestProtocol.contentType;
                    }
                }
                else if (options.batch) {
                    var batchRequest = requestProtocol.serializeBatch(options.batch);
                    options.body = batchRequest.body;
                    options.bodyType = batchRequest.type;
                }
                if (isGetMethod && context.appendTimestamp) {
                    options.url = appendQueryString(options.url, ['_ts', new Date().getTime()].join('='));
                }
                if (options.body) {
                    options.headers[osa.constants.ContentTypeHeaderName] = options.bodyType ||
                        options.headers[osa.constants.ContentTypeHeaderName] ||
                        options.headers[osa.constants.ContentTypeHeaderName.toLowerCase()] ||
                        'application/octet-stream';
                }
                if (options.headers['Permissions'] === void (0) && context.permissions !== void (0)) {
                    options.headers['Permissions'] = context.permissions;
                }
                var fetchOptions = osa.common.extend({ credentials: 'include' }, context.fetchOptions);
                options.fetchOptions = osa.common.extend(fetchOptions, {
                    method: options.method,
                    headers: lowerCaseHeaders(options.headers),
                    body: options.body
                });
                var token = getToken(context);
                applySecurityToken(context, options, token);
                return options;
            };
            /**
             * Make function call
             * @param method - HTTP method
             * @param name - function name
             * @param data - data to send in body
             * @param params - Additional query arguments
             * @param operationContext - Operation response context
             * @internal
             */
            Service.prototype.requestFunction = function (method, name, data, params, operationContext) {
                var p = Service.toParams(this, params);
                var requestContext = Service.createOperationRequestContext(name, operationContext, p);
                var headers = p.headers || {};
                method = p.method || method;
                return this.executeRequest({
                    method: method,
                    url: this.buildUrl(name, '', p, null),
                    data: data,
                    headers: headers,
                    requestContext: requestContext
                })
                    .then(function (result) {
                    if (typeof result === 'object'
                        && !(result instanceof base.DataType)
                        && Object.keys(result).length === 1
                        && name in result) {
                        return result[name];
                    }
                    return result;
                });
            };
            /**
             * Get function stream
             * @param method - http method
             * @param name - function name
             * @param data - data to send in query
             * @param params - Additional query arguments
             * @internal
             */
            Service.prototype.requestFunctionAsStream = function (method, name, data, params) {
                var p = Service.toParams(this, params);
                method = p.method || method;
                return this.executeRequest({
                    method: method,
                    url: this.buildUrl(name, '$value', p, null),
                    data: data,
                    headers: Service.getHeadersDefault(p)
                }, true);
            };
            /**
             * @internal
             * @param self a service bound to the current context
             * @param params a query parameters expression or parameters object
             */
            Service.toParams = function (self, params) {
                function isQuery(q) {
                    return typeof q === 'function';
                }
                if (isQuery(params)) {
                    var query_1 = self.protocol().queryBuilder(params);
                    return query_1.toParams();
                }
                return osa.common.ODataParams.cast(params);
            };
            /**
             * @internal
             */
            Service.EntitySet = base_1.EntitySet;
            return Service;
        }(osa.common.EventEmitter));
        base_1.Service = Service;
        /**
         * @internal
         */
        function stringifyPayload(payload, version) {
            function encodePayload(body) {
                return body.replace(/[\u007F-\uFFFF]/g, function (chr) {
                    return '\\u' + chr.charCodeAt(0).toString(16).padStart(4, '0');
                });
            }
            var body = JSON.stringify(payload);
            if (version < osa.common.odata.Version.V4) {
                return encodePayload(body);
            }
            return body;
        }
        base_1.stringifyPayload = stringifyPayload;
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
/// <reference path="../osa.ts" />
var osa;
(function (osa) {
    var base;
    (function (base) {
        var Osa2CompatibilityModeKey = osa.common.Osa2CompatibilityModeKey;
        var appendQueryString = osa.common.appendQueryString;
        /**
         * OData 4 domain service
         */
        var ServiceOdata3 = /** @class */ (function (_super) {
            __extends(ServiceOdata3, _super);
            function ServiceOdata3() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(ServiceOdata3.prototype, "protocolVersion", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return osa.common.odata.Version.V3;
                },
                enumerable: false,
                configurable: true
            });
            ;
            ServiceOdata3.prototype.protocol = function () {
                return new osa.common.odata.ProtocolOdata3(this);
            };
            /**
             * @inheritDoc
             * @internal
             */
            ServiceOdata3.prototype.buildUrl = function (name, tail, params, entity) {
                var _a;
                if (tail === void 0) { tail = ''; }
                function fallbackEntitySetName(compatMode, params) {
                    if (params.typeFilter == null || !compatMode) {
                        return null;
                    }
                    var _a = __read(params.typeFilter.split('.'), 2), _ = _a[0], typeName = _a[1];
                    return osa.Plurals.INSTANCE.toPlural(typeName);
                }
                if (false == this.$context[Osa2CompatibilityModeKey]) {
                    return _super.prototype.buildUrl.call(this, name, tail, params, entity);
                }
                var p = base.Service.toParams(this, params);
                var compatMode = this.$context[Osa2CompatibilityModeKey];
                this.trigger('makeUrl', name, p, entity, this);
                var url;
                if (entity instanceof base.Entity) {
                    var entitySetName = fallbackEntitySetName(compatMode, p) || ((_a = base.Service.resolveEntitySet(this, entity)) === null || _a === void 0 ? void 0 : _a.name);
                    if (entitySetName == null) {
                        throw new osa.error.GeneralError("Entity set for entity " + entity.constructor.name + " not found.");
                    }
                    var urlBase = entity.$url || this.buildUrl(entitySetName, '', new osa.common.Params({ id: entity.id }), null);
                    url = name == null ? urlBase : base.Service.combineUrl(urlBase, name);
                }
                else {
                    if (this[osa.common.uncapitalize(name)] instanceof base.EntitySet) {
                        name = fallbackEntitySetName(compatMode, p) || name;
                    }
                    if (p.id != null) {
                        name = base.Service.buildIdLink(name, p.id);
                    }
                    url = base.Service.combineUrl(this.$context.url, name);
                }
                url = (tail == null || tail === '') ? url : base.Service.combineUrl(url, tail);
                return appendQueryString(url, p.toQueryString());
            };
            /**
             * @internal
             */
            ServiceOdata3.EntitySet = base.odata3.EntitySet;
            return ServiceOdata3;
        }(base.Service));
        base.ServiceOdata3 = ServiceOdata3;
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
(function (osa) {
    var base;
    (function (base) {
        var odata3;
        (function (odata3) {
            /**
             * @inheritDoc
             */
            var Service = /** @class */ (function (_super) {
                __extends(Service, _super);
                function Service() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return Service;
            }(osa.base.ServiceOdata3));
            odata3.Service = Service;
        })(odata3 = base.odata3 || (base.odata3 = {}));
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
/// <reference path="../osa.ts" />
var osa;
(function (osa) {
    var base;
    (function (base) {
        /**
         * OData 4 domain service
         */
        var ServiceOdata4 = /** @class */ (function (_super) {
            __extends(ServiceOdata4, _super);
            function ServiceOdata4() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(ServiceOdata4.prototype, "protocolVersion", {
                /**
                 * @inheritDoc
                 */
                get: function () {
                    return osa.common.odata.Version.V4;
                },
                enumerable: false,
                configurable: true
            });
            ;
            ServiceOdata4.prototype.protocol = function () {
                return new osa.common.odata.ProtocolOdata4(this);
            };
            /**
             * @inheritDoc
             * @internal
             */
            ServiceOdata4.prototype.requestFunction = function (m, name, data, params, operationContext) {
                var p = base.Service.toParams(this, params);
                var method = p.method || m;
                var requestContext = base.Service.createOperationRequestContext(name, operationContext, p);
                var operationUrl = this.protocol().buildOperationUrl(name, p.method || method, data, params);
                var aliasData = method === 'GET' ? this.protocol().toUrlData(data) : data;
                return _super.prototype.requestFunction.call(this, method, operationUrl, aliasData, p, requestContext);
            };
            /**
             * @inheritDoc
             * @internal
             */
            ServiceOdata4.prototype.requestFunctionAsStream = function (method, name, data, params) {
                var p = base.Service.toParams(this, params);
                var operationUrl = this.protocol().buildOperationUrl(name, p.method || method, data);
                return _super.prototype.requestFunctionAsStream.call(this, method, operationUrl, data, p);
            };
            ServiceOdata4.prototype.loadDelta = function (name, deltaUrl) {
                var deltaQueryContext = new osa.common.odata.DeltaQueryContext(name);
                var options = {
                    method: 'GET',
                    url: deltaUrl.toString(),
                    requestContext: deltaQueryContext,
                };
                return this.executeRequest(options);
            };
            /**
             * @internal
             */
            ServiceOdata4.EntitySet = base.odata4.EntitySet;
            return ServiceOdata4;
        }(base.Service));
        base.ServiceOdata4 = ServiceOdata4;
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
(function (osa) {
    var base;
    (function (base) {
        var odata4;
        (function (odata4) {
            /**
             * @inheritDoc
             */
            var Service = /** @class */ (function (_super) {
                __extends(Service, _super);
                function Service() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return Service;
            }(osa.base.ServiceOdata4));
            odata4.Service = Service;
        })(odata4 = base.odata4 || (base.odata4 = {}));
    })(base = osa.base || (osa.base = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var error;
    (function (error) {
        error.GeneralError = function (message, inner) {
            var me = Error(message || 'General error.');
            me.name = 'GeneralError';
            me.inner = inner;
            return me;
        };
    })(error = osa.error || (osa.error = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var error;
    (function (error) {
        error.NotImpl = function (message) {
            var me = Error(message || 'Not implemented.');
            me.name = 'NotImpl';
            return me;
        };
    })(error = osa.error || (osa.error = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var error;
    (function (error) {
        error.ArgumentError = function (message) {
            var me = Error(message || 'Argument error.');
            me.name = 'ArgumentError';
            return me;
        };
    })(error = osa.error || (osa.error = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var error;
    (function (error) {
        error.RequestError = function (status, message) {
            var me = Error(message || 'Request error.');
            me.name = 'RequestError';
            me.status = status;
            return me;
        };
    })(error = osa.error || (osa.error = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var error;
    (function (error) {
        error.OdataError = function (errorJson, result) {
            var collect = function (err, cb) {
                if (!!err) {
                    var list = collect(err.innererror || err.internalexception, cb) || [];
                    var it = cb(err);
                    if (!!it && (list.length === 0 || list[0] != it)) {
                        list.unshift(it);
                    }
                    return list;
                }
            };
            var me = Error(collect(errorJson, function (err) { return (err.message || {}).value || err.message; }).join(' -> ') || 'oData error.');
            me.name = errorJson.type || 'OdataError';
            me.fault = result.fault || (errorJson.innererror || {}).fault;
            me.stack = collect(errorJson, function (err) { return err.stacktrace || err.stack; }).join('\r\n\r\n')
                || (me.fault || {}).stackTrace;
            me.code = errorJson.code || (errorJson.innererror || {}).type;
            me.status = result.status;
            return me;
        };
    })(error = osa.error || (osa.error = {}));
})(osa || (osa = {}));
/**
 * @namespace
 * @private
 */
var osa;
(function (osa) {
    var decorators;
    (function (decorators) {
        /**
         * @internal
         */
        function compat_2_7(module, propertyMap) {
            var e_13, _a;
            // @ts-ignore
            var isOsa2Domain = module.common && module.common.capabilities != null;
            if (!isOsa2Domain) {
                return;
            }
            var typeMap = module.domain.typeMap;
            var _loop_2 = function (key) {
                var property = propertyMap[key];
                if (property.r != null && property.r2 == null) {
                    // OSA2 uses string moniker for type, OSA3 uses ctor
                    var moduleName = module.domain.name.toLowerCase();
                    var common_1 = moduleName + '.' + 'common' + '.';
                    var typeKey_1 = property.r.indexOf(common_1) === 0 ? property.r.slice(moduleName.length + 1) : property.r;
                    property.r2 = function () {
                        return typeMap[typeKey_1];
                    };
                }
                else if (property.t === 4 && key.endsWith('Value')) {
                    // OSA2 has trailing 'Value' in enum names
                    var newKey = key.slice(0, -'Value'.length); // trim trailing 'Value'
                    delete propertyMap[key];
                    propertyMap[newKey] = property;
                }
            };
            try {
                for (var _b = __values(Object.keys(propertyMap)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _loop_2(key);
                }
            }
            catch (e_13_1) { e_13 = { error: e_13_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_13) throw e_13.error; }
            }
        }
        decorators.compat_2_7 = compat_2_7;
    })(decorators = osa.decorators || (osa.decorators = {}));
})(osa || (osa = {}));
/**
 * @namespace
 * @private
 */
var osa;
(function (osa) {
    var decorators;
    (function (decorators) {
        /**
         * Decorator for complex types
         * @param module - domain module reference
         * @param type - OData type name
         * @param propertyMap - property map for serialization
         * @private
         */
        function ComplexType(module, type, propertyMap) {
            decorators.compat_2_7(module, propertyMap);
            // Class decorator
            return function (target) {
                module.domain.defineType(target, type, propertyMap);
            };
        }
        decorators.ComplexType = ComplexType;
    })(decorators = osa.decorators || (osa.decorators = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var decorators;
    (function (decorators) {
        /**
         * Decorator for entity types
         * @param module - domain module reference
         * @param type - OData type name
         * @param propertyMap - property map for serialization
         * @private
         */
        function EntityType(module, type, propertyMap) {
            decorators.compat_2_7(module, propertyMap);
            // Class decorator
            return function (target) {
                module.domain.defineType(target, type, propertyMap);
                target.$module = module;
            };
        }
        decorators.EntityType = EntityType;
    })(decorators = osa.decorators || (osa.decorators = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var decorators;
    (function (decorators) {
        /**
         * Decorator for OData entity set
         * @param name - entity set name within service
         * @param entityType - underline entity type
         * @private
         */
        function EntitySet(name, entityType) {
            return (function (targetPrototype, propertyKey, descriptor) {
                var clazz = targetPrototype.constructor;
                clazz.$entitySetMap = clazz.$entitySetMap || {};
                clazz.$entitySetMap[entityType.odataType] = propertyKey;
                descriptor.get = function () {
                    return this.$entitySets[propertyKey] || (this.$entitySets[propertyKey]
                        = new clazz.EntitySet(this, name, entityType));
                };
                return descriptor;
            });
        }
        decorators.EntitySet = EntitySet;
    })(decorators = osa.decorators || (osa.decorators = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var decorators;
    (function (decorators) {
        /**
         * @internal
         */
        function paramsToData(params, args) {
            var data;
            for (var i = 0; i < args.length; i++) {
                var value = params.shift();
                if (value !== void (0)) {
                    var name_1 = typeof args[i] === 'string' ? args[i] : args[i].name;
                    if (args[i].type !== void (0)
                        && typeof value === 'object'
                        && !(value instanceof args[i].type)) {
                        var Ctor = args[i].type;
                        value = Ctor.new(value);
                    }
                    (data || (data = {}))[name_1] = value;
                }
            }
            return data;
        }
        /**
         * Service function decorator
         * @param method - HTTP method
         * @param name - Function name
         * @param args - List of argument names
         * @param returnType - Operation return type context
         * @private
         */
        function ServiceFunction(method, name, args, returnType) {
            return (function (proto, key, descriptor) {
                var clazz = proto.constructor;
                (clazz.$httpMethodMap || (clazz.$httpMethodMap = {}))[name] = method;
                var operationMetadata = clazz.$operationMetadata || (clazz.$operationMetadata = {});
                var shortName = name.split('_')[1];
                var metadata = {
                    name: name,
                    method: method.toUpperCase(),
                    args: args,
                    returnType: returnType,
                    key: key,
                };
                if (operationMetadata[name] == null) {
                    operationMetadata[name] = [];
                }
                if (operationMetadata[shortName] == null) {
                    operationMetadata[shortName] = [];
                }
                operationMetadata[name].push(metadata);
                operationMetadata[shortName].push(metadata);
                descriptor.value = function () {
                    var params = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        params[_i] = arguments[_i];
                    }
                    var data = paramsToData(params, args);
                    return this.requestFunction(clazz.$httpMethodMap[name] || method, name, data, params.shift(), returnType);
                };
                return descriptor;
            });
        }
        decorators.ServiceFunction = ServiceFunction;
        /**
         * Service function as stream decorator
         * @param method - HTTP method
         * @param name - Function name
         * @param args - List of argument names
         * @private
         */
        function ServiceFunctionAsStream(method, name, args) {
            return (function (proto, key, descriptor) {
                descriptor.value = function () {
                    var params = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        params[_i] = arguments[_i];
                    }
                    var data = paramsToData(params, args);
                    return this.requestFunctionAsStream(method, name, data, params.shift());
                };
                return descriptor;
            });
        }
        decorators.ServiceFunctionAsStream = ServiceFunctionAsStream;
    })(decorators = osa.decorators || (osa.decorators = {}));
})(osa || (osa = {}));
/// <reference path="../osa.ts" />
var osa;
(function (osa) {
    var decorators;
    (function (decorators) {
        /**
         * Decorator for domain service class
         * @param module - domain module reference
         * @param serviceCtor - service class
         * @private
         */
        function DomainService(module, serviceCtor) {
            serviceCtor.prototype.domain = module.domain;
            return function (target) {
                Object.defineProperty(module, 'service', {
                    get: (function () {
                        var single;
                        return function () {
                            return single || (single = new serviceCtor());
                        };
                    })(),
                    enumerable: true,
                    configurable: false
                });
            };
        }
        decorators.DomainService = DomainService;
    })(decorators = osa.decorators || (osa.decorators = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var decorators;
    (function (decorators) {
        var OdataBindSymbol = osa.common.odata.OdataBindSymbol;
        function checkService(self) {
            if (self.$service === void (0)) {
                throw new osa.error.ArgumentError('No service instance associated with entity.');
            }
        }
        function checkBind(entity, localName) {
            var odataBind = entity[OdataBindSymbol];
            if (odataBind && odataBind[localName] != null) {
                throw new osa.error.ArgumentError("Relation " + localName + " has been already bound");
            }
        }
        function checkAttach(entity, localName) {
            if (entity[localName] != null) {
                throw new osa.error.ArgumentError("Relation " + localName + " has been already inlined");
            }
        }
        function bind(entity, localName, refs) {
            checkService(entity);
            var bind = createBind(entity.$service, refs);
            entity[OdataBindSymbol] = this[OdataBindSymbol] == null ? {} : entity[OdataBindSymbol];
            entity[OdataBindSymbol][localName] = bind;
        }
        function createBind(service, linkOrList) {
            if (Array.isArray(linkOrList)) {
                return linkOrList.map(function (x) { return service.buildUrl(null, '', void (0), x); });
            }
            return service.buildUrl(null, '', void (0), linkOrList);
        }
        function DeferredProperty(nameOrIsArray, arrayOrNothing) {
            // @ts-ignore
            return (function (targetPrototype, propertyKey, descriptor) {
                // OSA2 explicitly propagates odata name and OSA3 does not
                var odataName = typeof nameOrIsArray === 'string' ? nameOrIsArray : propertyKey[0].toUpperCase() + propertyKey.slice(1);
                var array = typeof nameOrIsArray === 'boolean' ? nameOrIsArray : arrayOrNothing;
                var localName = typeof nameOrIsArray === 'string' ? nameOrIsArray[0].toLowerCase() + nameOrIsArray.slice(1) : propertyKey;
                (targetPrototype.constructor['deferredMap'] || (targetPrototype.constructor['deferredMap'] = {}))[odataName] = !!array ? 'a' : 's';
                function requestFunction(params) {
                    checkService(this);
                    return this.$service.requestEntityProperty(this, odataName, params);
                }
                if (descriptor != null && typeof descriptor.value === 'function') {
                    // OSA2 sets DeferredProperty on method `requestNavigationProperty`
                    descriptor.value = requestFunction;
                }
                else {
                    // OSA2 sets DeferredProperty on property `navigationProperty`
                    targetPrototype['request' + odataName] = requestFunction;
                }
                targetPrototype['get' + odataName] = function (params) {
                    var _this_1 = this;
                    checkService(this);
                    if (this[localName] instanceof osa.base.Entity
                        || this[localName] instanceof Array
                        || this[localName] === null) {
                        return Promise.resolve(this[localName]);
                    }
                    return this['request' + odataName](params)
                        .then(function (value) {
                        _this_1[localName] = value;
                        return value;
                    });
                };
                if (!!array) {
                    targetPrototype['add' + odataName] = function (entity) {
                        checkService(this);
                        return this.$service.addEntityLink(this, odataName, entity);
                    };
                    targetPrototype['remove' + odataName] = function (entity) {
                        checkService(this);
                        if (!(entity instanceof osa.base.Entity)) {
                            throw new osa.error.ArgumentError('Entity argument is required.');
                        }
                        return this.$service.removeEntityLink(this, odataName, entity);
                    };
                }
                else {
                    targetPrototype['set' + odataName] = function (entity) {
                        checkService(this);
                        var _this = this;
                        if (!!entity) {
                            return this.$service.setEntityLink(this, odataName, entity)
                                .then(function (result) {
                                _this[localName] = entity;
                                return result;
                            });
                        }
                        return this.$service.removeEntityLink(this, odataName)
                            .then(function (result) {
                            delete _this[localName];
                            return result;
                        });
                    };
                }
                targetPrototype['attach' + odataName] = function (entities) {
                    checkBind(this, localName);
                    this[localName] = entities;
                };
                targetPrototype['bind' + odataName] = function (refs) {
                    checkAttach(this, localName);
                    bind(this, localName, refs);
                };
            });
        }
        decorators.DeferredProperty = DeferredProperty;
    })(decorators = osa.decorators || (osa.decorators = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var decorators;
    (function (decorators) {
        /**
         * Decorator for streamable entity types
         * @private
         */
        function HasStream() {
            // Stream class decorator
            return function (target) {
                target.$hasStream = true;
            };
        }
        decorators.HasStream = HasStream;
    })(decorators = osa.decorators || (osa.decorators = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var decorators;
    (function (decorators) {
        /**
         * Decorator for deprecated operations
         * @param message - runtime message
         * @private
         */
        function Deprecated(message) {
            if (message === void 0) { message = ''; }
            return function (target, propertyKey, descriptor) {
                var originalFn = descriptor.value;
                var warning = "Method " + propertyKey + " is deprecated." + message;
                descriptor.value = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    console.warn(warning);
                    return originalFn.apply(this, args);
                };
                return descriptor;
            };
        }
        decorators.Deprecated = Deprecated;
    })(decorators = osa.decorators || (osa.decorators = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    /**
     * Sets the default context
     */
    function setContext(ctx) {
        osa.context = ctx;
    }
    osa.setContext = setContext;
    var defaultContext;
    Object.defineProperty(osa, 'context', {
        enumerable: true,
        configurable: false,
        get: function () {
            if (defaultContext == void 0) {
                defaultContext = new osa.common.Context();
                defaultContext.clientInfo = {
                    frameworkVersion: osa.version
                };
                defaultContext.fetchOptions = {
                    credentials: 'include'
                };
            }
            return defaultContext;
        },
        set: function (value) {
            defaultContext = osa.context.extend(value);
        }
    });
})(osa || (osa = {}));
/// <reference path="common/CommonTypes.ts"/>
var osa;
(function (osa) {
    /**
     * Setup OSA domain in OSAJS environment
     * @param module - OSA domain module
     * @param name - domain name
     * @param version - Domain version
     * @private
     */
    function attachDomain(module, name, version) {
        var domainContext;
        Object.defineProperties(module, {
            version: {
                value: version,
                enumerable: true,
                configurable: false,
                writable: false
            },
            domain: {
                value: new osa.common.Domain(module, name),
                enumerable: true,
                configurable: false,
                writable: false
            },
            context: {
                enumerable: true,
                configurable: false,
                get: function () {
                    return domainContext || (domainContext = new osa.common.Context({
                        clientInfo: {
                            domainVersion: version
                        }
                    }));
                },
                set: function (value) {
                    if (value instanceof osa.common.Context) {
                        domainContext = value;
                    }
                    else {
                        module.context.extend(value);
                    }
                }
            }
        });
        osa.domains.push(module.domain);
    }
    osa.attachDomain = attachDomain;
    /**
     * Loaded OSA domains
     * @const
     */
    osa.domains = [];
})(osa || (osa = {}));
var osa;
(function (osa) {
    /**
     * Sets the fetch implementation
     * @deprecated Use context.fetch instead
     */
    function setFetch(impl) {
        osa.fetch = impl;
    }
    osa.setFetch = setFetch;
    Object.defineProperty(osa, 'fetch', (function () {
        var $fetch;
        return {
            enumerable: true,
            configurable: false,
            get: function () {
                if ($fetch != null) {
                    return $fetch;
                }
                if (osa.common.isNodeEnvironment()) {
                    $fetch = resolveNodeFetch();
                }
                else {
                    $fetch = resolveWindowFetch();
                }
                return $fetch;
            },
            set: function (value) {
                $fetch = value;
            }
        };
    })());
    function resolveWindowFetch() {
        var windowFetch = osa.common.getWindow().fetch;
        if (windowFetch == null) {
            throw new osa.error.NotImpl('Fetch API is not supported in the browser, please use window.fetch polyfill.');
        }
        return windowFetch;
    }
    function resolveNodeFetch() {
        var nodeFetch = require('node-fetch');
        if (typeof nodeFetch === 'function') {
            return nodeFetch;
        }
        if (typeof nodeFetch.default === 'function') {
            return nodeFetch.default;
        }
        throw new Error("Unable to resolve 'node-fetch'. Check the project bundling strategy and version of 'node-fetch'");
    }
})(osa || (osa = {}));
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var osa;
(function (osa) {
    var query;
    (function (query_2) {
        /**
         * An order of the sorting
         */
        var Order;
        (function (Order) {
            Order["Asc"] = "asc";
            Order["Desc"] = "desc";
        })(Order = query_2.Order || (query_2.Order = {}));
        /**
         * @internal
         */
        var Query = /** @class */ (function () {
            function Query() {
                this.parent = null;
                this.$expand = {};
                this.$select = [];
                this.$orderBy = [];
                this.$custom = [];
                this.$alias = [];
            }
            Query.cast = function (query, parent) {
                if (query instanceof Query) {
                    return query;
                }
                if (!query || typeof query !== 'object') {
                    return null;
                }
                var keys = Object.keys(query);
                var instance = Query.getInstance();
                instance.parent = parent;
                keys.forEach(function (key) { return instance[key](query[key]); });
                return instance;
            };
            Query.getInstance = function () {
                var ctor = this.constructor;
                return new ctor();
            };
            Query.prototype.id = function (id) {
                this.$id = id;
                return this;
            };
            Query.prototype.top = function (top) {
                this.$top = top;
                return this;
            };
            Query.prototype.skip = function (skip) {
                this.$skip = skip;
                return this;
            };
            Query.prototype.select = function (property) {
                this.$select.push(property);
                return this;
            };
            Query.prototype.orderBy = function (propertyOrPath, order) {
                var path = OrderByQuery.from(propertyOrPath);
                this.$orderBy.push([path, order]);
                return this;
            };
            Query.prototype.custom = function (key, value) {
                this.$custom.push([key, value]);
                return this;
            };
            Query.prototype.alias = function (alias, query) {
                this.$alias.push([alias, query(new Alias()).toString()]);
                return this;
            };
            Query.prototype.expand = function (expand, subQuery) {
                if (Array.isArray(expand) && subQuery) {
                    throw new Error('Array of expanded nodes with subquery is forbidden. Use expand() with subquery for each node');
                }
                if (!subQuery) {
                    this.buildExpand(expand);
                    return this;
                }
                var queryBuilder = this.getExpandInstance(this);
                var query = subQuery(queryBuilder);
                this.buildExpand(expand, query);
                return this;
            };
            Query.prototype.toString = function (options) {
                if (options === void 0) { options = { encode: false }; }
                var params = this.toParams();
                return params.toQueryString(null, options);
            };
            Query.prototype.buildExpand = function (expand, query) {
                var expandQuery = this.getExpandInstance(this);
                if (expand.indexOf('/') === -1) {
                    this.$expand[expand] = Query.cast(query, this) || expandQuery;
                }
                else {
                    var expanded = expand.indexOf('/');
                    var first = expand.slice(0, expanded);
                    expandQuery.expand(expand.slice(expanded + 1), query);
                    this.$expand[first] = expandQuery;
                }
            };
            return Query;
        }());
        query_2.Query = Query;
        /**
         * @internal
         */
        var OrderByQuery = /** @class */ (function () {
            function OrderByQuery() {
            }
            OrderByQuery.from = function (propertyOrPath) {
                if (typeof propertyOrPath === 'string') {
                    return propertyOrPath;
                }
                if (typeof propertyOrPath === 'function') {
                    var query_3 = propertyOrPath(new OrderByQuery());
                    return query_3.toString();
                }
            };
            OrderByQuery.prototype.path = function () {
                var segments = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    segments[_i] = arguments[_i];
                }
                this._path = PathOrSegment.from.apply(PathOrSegment, __spreadArray([], __read(segments)));
                return this;
            };
            OrderByQuery.prototype.toString = function () {
                return this._path.toString();
            };
            return OrderByQuery;
        }());
        query_2.OrderByQuery = OrderByQuery;
        /**
         * @internal
         */
        var PathOrSegment = /** @class */ (function () {
            function PathOrSegment(_path) {
                this._path = _path;
            }
            PathOrSegment.prototype.toString = function () {
                return this._path;
            };
            /**
             * @internal
             */
            PathOrSegment.toString = function (propertyOrPath) {
                if (typeof propertyOrPath === 'string') {
                    return propertyOrPath;
                }
                if (PathOrSegment.isPath(propertyOrPath)) {
                    return propertyOrPath._path;
                }
                throw new Error('A path expression must be a string or an instance of PathOrSegment');
            };
            /**
             * @internal
             */
            PathOrSegment.isPath = function (a) {
                return a instanceof PathOrSegment;
            };
            PathOrSegment.from = function () {
                var segments = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    segments[_i] = arguments[_i];
                }
                return new osa.query.PathOrSegment(segments.join('/'));
            };
            return PathOrSegment;
        }());
        query_2.PathOrSegment = PathOrSegment;
        /**
         * @internal
         */
        var Alias = /** @class */ (function () {
            function Alias() {
            }
            Alias.prototype.json = function (x) {
                this.expression = JSON.stringify(x);
                return this;
            };
            Alias.prototype.toString = function () {
                return this.expression;
            };
            return Alias;
        }());
        query_2.Alias = Alias;
    })(query = osa.query || (osa.query = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var query;
    (function (query) {
        var encodeString = osa.common.encodeString;
        var EdmDate = osa.common.odata.types.EdmDate;
        var DateTimeOffset = osa.common.odata.types.DateTimeOffset;
        var EdmDuration = osa.common.odata.types.EdmDuration;
        /**
         * A filter query language for the building of the query string
         * Query example:
         * ```
         * query
         *     .filter(q => q.eq(q.path('LastName'), 'Smith'))
         * ```
         * Request example:
         * ```
         * $filter=LastName eq 'Smith'
         * ```
         */
        var FilterExpression = /** @class */ (function () {
            function FilterExpression() {
                /**
                 * A current instance of the resource identified by the resource path
                 * Query example:
                 * ```
                 * query.filter(q => q.endsWith(q.$it, '.com'))
                 * ```
                 * Request example:
                 * ```
                 * $filter=endswith($it, '.com')
                 * ```
                 */
                this.$it = '$it';
                /**
                 * Specifies the Timestamp value
                 */
                this.aTimestamp = this.aDateTimeOffset;
                /**
                 * Specifies the URI value. The value will be escaped automatically according to OData rules
                 */
                this.anURI = this.aString;
            }
            FilterExpression.prototype.toSimple = function () {
                var _this = this;
                var rules = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    rules[_i] = arguments[_i];
                }
                var toBuiltIn = function (a) {
                    if (a == null) {
                        return _this.null();
                    }
                    if (typeof a === 'function') {
                        return a;
                    }
                    switch (typeof a) {
                        case 'string':
                            return _this.aString(a);
                        case 'number':
                            return _this.aDouble(a);
                        case 'bigint':
                            return _this.aBigInt(a);
                        case 'boolean':
                            return _this.aBoolean(a);
                    }
                    if (query.PathOrSegment.isPath(a)) {
                        return function () { return a.toString(); };
                    }
                    if (a instanceof EdmDuration) {
                        return _this.aTime(a);
                    }
                    if (a instanceof EdmDate) {
                        return _this.aDate(a);
                    }
                    if (a instanceof DateTimeOffset) {
                        return _this.aDateTimeOffset(a);
                    }
                    throw new Error('Unsupported case, only known unambiguous types are supported');
                };
                if (rules.length === 1) {
                    return toBuiltIn(rules[0]);
                }
                else if (rules.length === 2 || rules.length === 3) {
                    return rules.map(function (x) { return toBuiltIn(x); });
                }
                throw new Error('Unsupported case, only 1 or 2 arguments or 3 arguments are supported');
            };
            FilterExpression.toSimpleRule = function (a) {
                var ctor = this;
                return new ctor().toSimple(a);
            };
            /**
             * A null value
             */
            FilterExpression.prototype.null = function () {
                return function () { return 'null'; };
            };
            FilterExpression.prototype.path = function () {
                var segments = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    segments[_i] = arguments[_i];
                }
                return query.PathOrSegment.from.apply(query.PathOrSegment, __spreadArray([], __read(segments)));
            };
            /**
             * An equal operator
             * @param x left hand side
             * @param y right hand side
             */
            FilterExpression.prototype.eq = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " eq " + b(); };
            };
            /**
             * A not equal operator
             * @param x left hand side
             * @param y right hand side
             */
            FilterExpression.prototype.ne = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " ne " + b(); };
            };
            /**
             * A less than operator
             * @param x left hand side
             * @param y right hand side
             */
            FilterExpression.prototype.lt = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " lt " + b(); };
            };
            /**
             * A greater than operator
             * @param x left hand side
             * @param y right hand side
             */
            FilterExpression.prototype.gt = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " gt " + b(); };
            };
            /**
             * A less than or equal operator
             * @param x left hand side
             * @param y right hand side
             */
            FilterExpression.prototype.le = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " le " + b(); };
            };
            /**
             * A greater than or equal operator
             * @param x left hand side
             * @param y right hand side
             */
            FilterExpression.prototype.ge = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " ge " + b(); };
            };
            /**
             * A multiply operator
             * @param x a multiplicand
             * @param y a multiplier
             */
            FilterExpression.prototype.mul = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " mul " + b(); };
            };
            /**
             * A divide operator
             * @param x a dividend
             * @param y a divisor
             */
            FilterExpression.prototype.div = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " div " + b(); };
            };
            /**
             * A divide by modulo operator
             * @param x a dividend
             * @param y a divisor
             */
            FilterExpression.prototype.mod = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " mod " + b(); };
            };
            /**
             * An add operator
             * @param x an augend
             * @param y an addend
             */
            FilterExpression.prototype.add = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " add " + b(); };
            };
            /**
             * A subtract operator
             * @param x a minuend
             * @param y a subtrahend
             */
            FilterExpression.prototype.sub = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " sub " + b(); };
            };
            /**
             * A value of a primitive type
             * @param a a value
             */
            FilterExpression.prototype.value = function (a) {
                return this.toSimple(a);
            };
            /**
             * A logical and operator
             * @param x a left hand side
             * @param y a right hand side
             */
            FilterExpression.prototype.and = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " and " + b(); };
            };
            /**
             * A logical or operator
             * @param x a left hand side
             * @param y a right hand side
             */
            FilterExpression.prototype.or = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return a() + " or " + b(); };
            };
            /**
             * A grouping operator
             * @param rest a list of rules
             */
            FilterExpression.prototype.group = function () {
                var _this = this;
                var rest = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    rest[_i] = arguments[_i];
                }
                return function () { return "(" + rest.map(function (x) {
                    var a = _this.toSimple(x);
                    return a();
                }).join(',') + ")"; };
            };
            /**
             * A negation operator
             * @param x a value
             */
            FilterExpression.prototype.minus = function (x) {
                var a = this.toSimple(x);
                return function () { return "-" + a(); };
            };
            ;
            /**
             * A logical not operator
             * @param x a value
             */
            FilterExpression.prototype.not = function (x) {
                var a = this.toSimple(x);
                var v = a();
                if (v.startsWith('(')) {
                    return function () { return "not" + v; };
                }
                else {
                    return function () { return "not " + v; };
                }
            };
            /**
             * Rounds the input numeric parameter up to the nearest numeric value with no decimal component
             * @param x a value
             */
            FilterExpression.prototype.ceiling = function (x) {
                var a = this.toSimple(x);
                return function () { return "ceiling(" + a() + ")"; };
            };
            /**
             * Rounds the input numeric parameter down to the nearest numeric value with no decimal component
             * @param x a value
             */
            FilterExpression.prototype.floor = function (x) {
                var a = this.toSimple(x);
                return function () { return "floor(" + a() + ")"; };
            };
            /**
             * Rounds the input numeric parameter to the nearest integer
             * @param x a value
             */
            FilterExpression.prototype.round = function (x) {
                var a = this.toSimple(x);
                return function () { return "round(" + a() + ")"; };
            };
            /**
             * Returns a string that appends the second parameter string value to the first
             * @param x a first parameter
             * @param y a second parameter
             */
            FilterExpression.prototype.concat = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return "concat(" + a() + "," + b() + ")"; };
            };
            /**
             * Returns true if the first string starts with the second string, otherwise it returns false
             * @param x
             * @param y
             */
            FilterExpression.prototype.startsWith = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return "startswith(" + a() + "," + b() + ")"; };
            };
            /**
             * Returns true if the first string ends with the second string, otherwise it returns false
             * @param x a first parameter
             * @param y a second parameter
             */
            FilterExpression.prototype.endsWith = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return "endswith(" + a() + "," + b() + ")"; };
            };
            /**
             * Returns the zero-based index of the first occurrence of the second parameter in the first parameter
             * @param x a first parameter
             * @param y a second parameter
             */
            FilterExpression.prototype.indexOf = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return "indexof(" + a() + "," + b() + ")"; };
            };
            /**
             * Returns the length of the string or collection
             * @param x a string or collection
             */
            FilterExpression.prototype.length = function (x) {
                var a = this.toSimple(x);
                return function () { return "length(" + a() + ")"; };
            };
            /**
             * Replaces the first occurrence of the second parameter in the first parameter with the third parameter
             * @param x a first parameter
             * @param y a second parameter
             * @param z a third parameter
             */
            FilterExpression.prototype.replace = function (x, y, z) {
                var _a = __read(this.toSimple(x, y, z), 3), a = _a[0], b = _a[1], c = _a[2];
                return function () { return "replace(" + a() + "," + b() + "," + c() + ")"; };
            };
            /**
             * Returns a string in the lower case
             * @param x a string
             */
            FilterExpression.prototype.toLower = function (x) {
                var a = this.toSimple(x);
                return function () { return "tolower(" + a() + ")"; };
            };
            /**
             * Returns a string in the upper case
             * @param x a string
             */
            FilterExpression.prototype.toUpper = function (x) {
                var a = this.toSimple(x);
                return function () { return "toupper(" + a() + ")"; };
            };
            /**
             * Returns a string without leading and trailing spaces
             * @param x a string
             */
            FilterExpression.prototype.trim = function (x) {
                var a = this.toSimple(x);
                return function () { return "trim(" + a() + ")"; };
            };
            /**
             * Returns a substring of the first parameter starting at the index specified by the second parameter and with the length specified by the third parameter
             * @param x a first parameter
             * @param y a second parameter
             * @param z a length
             */
            FilterExpression.prototype.substring = function (x, y, z) {
                var _a = __read(this.toSimple(x, y, z), 3), a = _a[0], b = _a[1], c = _a[2];
                if (c != null) {
                    return function () { return "substring(" + a() + "," + b() + "," + c() + ")"; };
                }
                return function () { return "substring(" + a() + "," + b() + ")"; };
            };
            /**
             * Returns true if the first parameter is a substring of the second parameter, otherwise it returns false
             * @param x a first parameter
             * @param y a second parameter
             */
            FilterExpression.prototype.substringOf = function (x, y) {
                var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                return function () { return "substringof(" + a() + "," + b() + ")"; };
            };
            /**
             * A year component of a date
             * @param x a date
             */
            FilterExpression.prototype.year = function (x) {
                var a = this.toSimple(x);
                return function () { return "year(" + a() + ")"; };
            };
            /**
             * A month component of a date
             * @param x a date
             */
            FilterExpression.prototype.month = function (x) {
                var a = this.toSimple(x);
                return function () { return "month(" + a() + ")"; };
            };
            /**
             * A day component of a date
             * @param x a date
             */
            FilterExpression.prototype.day = function (x) {
                var a = this.toSimple(x);
                return function () { return "day(" + a() + ")"; };
            };
            /**
             * An hour component of a time
             * @param x a time
             */
            FilterExpression.prototype.hour = function (x) {
                var a = this.toSimple(x);
                return function () { return "hour(" + a() + ")"; };
            };
            /**
             * A minute component of a time
             * @param x a time
             */
            FilterExpression.prototype.minute = function (x) {
                var a = this.toSimple(x);
                return function () { return "minute(" + a() + ")"; };
            };
            /**
             * A second component of a time
             * @param x a time
             */
            FilterExpression.prototype.second = function (x) {
                var a = this.toSimple(x);
                return function () { return "second(" + a() + ")"; };
            };
            FilterExpression.prototype.cast = function (x, y) {
                var type;
                if (y == null) {
                    type = typeof x === 'string' ? x : x['odataType'];
                    return function () { return "cast('" + type + "')"; };
                }
                var a = this.toSimple(x);
                type = typeof y === 'string' ? y : y['odataType'];
                return function () { return "cast(" + a() + ",'" + type + "')"; };
            };
            FilterExpression.prototype.isOf = function (x, y) {
                var type;
                if (y == null) {
                    type = typeof x === 'string' ? x : x['odataType'];
                    return function () { return "isof('" + type + "')"; };
                }
                var a = this.toSimple(x);
                type = typeof y === 'string' ? y : y['odataType'];
                return function () { return "isof(" + a() + ",'" + type + "')"; };
            };
            /**
             * Specifies the qualified name and value of the enumeration member
             * @param ns a qualified name of the enumeration type
             * @param value a member name
             */
            FilterExpression.prototype.anEnum = function (ns, value) {
                return function () { return ns + "'" + value + "'"; };
            };
            /**
             * Specifies the boolean value
             * @param value a boolean value
             */
            FilterExpression.prototype.aBoolean = function (value) {
                return function () { return value ? 'true' : 'false'; };
            };
            /**
             * Specifies the date value
             * @param value a date value
             */
            FilterExpression.prototype.aDate = function (value) {
                if (value instanceof Date) {
                    value = EdmDate.from(value);
                }
                return function () { return String(value); };
            };
            /**
             * Specifies the DateTimeOffset value
             * @param value a DateTimeOffset value
             */
            FilterExpression.prototype.aDateTimeOffset = function (value) {
                if (value instanceof Date) {
                    value = DateTimeOffset.from(value);
                }
                return function () { return String(value); };
            };
            /**
             * Returns the time value
             * @param value a time value
             */
            FilterExpression.prototype.aTime = function (value) {
                return function () { return "duration'" + value + "'"; };
            };
            /**
             * Specifies the decimal value
             * @warning at the moment OSAjs uses type `number` for decimal values
             * @param value a decimal value
             */
            FilterExpression.prototype.aDecimal = function (value) {
                return function () { return String(value); };
            };
            /**
             * Specifies the double value
             * @param value a double value
             */
            FilterExpression.prototype.aDouble = function (value) {
                return function () {
                    if (value === Infinity) {
                        return 'INF';
                    }
                    if (value === -Infinity) {
                        return '-INF';
                    }
                    return String(value);
                };
            };
            /**
             * Specifies the bigint value
             * @warning at the moment OSAjs uses type `number` for bigint values
             * @param value a bigint value
             */
            FilterExpression.prototype.aBigInt = function (value) {
                return function () { return String(value); };
            };
            ;
            /**
             * Specifies the guid/uuid value
             * @param value a guid/uuid value
             */
            FilterExpression.prototype.aGuid = function (value) {
                return function () { return value; };
            };
            /**
             * Specifies the integer value
             * @warning at the moment OSAjs uses type `number` for integer values
             * @param value an integer value
             */
            FilterExpression.prototype.anInt = function (value) {
                return function () { return String(value); };
            };
            /**
             * Specifies the long integer value
             * @warning at the moment OSAjs uses type `number` for long integer values
             * @param value a long integer value
             */
            FilterExpression.prototype.aLong = function (value) {
                return function () { return String(value); };
            };
            /**
             * Specifies the string value. The value will be escaped automatically according to OData rules
             * @param value a string value
             */
            FilterExpression.prototype.aString = function (value) {
                return function () { return encodeString(value); };
            };
            return FilterExpression;
        }());
        query.FilterExpression = FilterExpression;
    })(query = osa.query || (osa.query = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var query;
    (function (query) {
        var odata3;
        (function (odata3) {
            /**
             * @inheritDoc
             */
            var FilterExpression = /** @class */ (function (_super) {
                __extends(FilterExpression, _super);
                function FilterExpression() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    /**
                     * The OSA dsl primitives for odata3
                     */
                    _this.basetypes = basetypes;
                    return _this;
                }
                return FilterExpression;
            }(osa.query.FilterExpression));
            odata3.FilterExpression = FilterExpression;
            var basetypes = {
                Boolean: 'Edm.Boolean',
                Date: 'Edm.DateTime',
                DateTimeOffset: 'Edm.DateTimeOffset',
                Timestamp: 'Edm.DateTimeOffset',
                Decimal: 'Edm.Decimal',
                Double: 'Edm.Double',
                Time: 'Edm.Time',
                Guid: 'Edm.Guid',
                Int: 'Edm.Int32',
                Long: 'Edm.Int64',
                BigInt: 'Edm.Int64',
                String: 'Edm.String',
                URI: 'Edm.String',
            };
        })(odata3 = query.odata3 || (query.odata3 = {}));
    })(query = osa.query || (osa.query = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var query;
    (function (query_4) {
        var odata4;
        (function (odata4) {
            /**
             * @inheritDoc
             */
            var FilterExpression = /** @class */ (function (_super) {
                __extends(FilterExpression, _super);
                function FilterExpression() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    /**
                     * The OSA dsl primitives for odata4
                     */
                    _this.basetypes = basetypes;
                    _this.lambdaVariable = 'a'.charCodeAt(0);
                    /**
                     * Specifies a $count segment of path
                     * Query example:
                     * ```
                     * query.filter(f => f.eq(f.path(Items, f.$count), 5))
                     * ```
                     * Request example:
                     * ```
                     * $filter=Items/$count eq 5
                     * ```
                     */
                    _this.$count = '$count';
                    return _this;
                }
                FilterExpression.prototype.nextLambdaVariableName = function () {
                    return String.fromCharCode(this.lambdaVariable++);
                };
                FilterExpression.prototype.path = function () {
                    var segments = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        segments[_i] = arguments[_i];
                    }
                    return this.pathInternal(segments);
                };
                FilterExpression.prototype.pathInternal = function (segments) {
                    var value = segments.map(function (s) { return s instanceof LambdaQuery ? s.variableName : s; });
                    return query_4.PathOrSegment.from.apply(query_4.PathOrSegment, __spreadArray([], __read(value)));
                };
                /**
                 * Checks if the left operand is a member of the right operand
                 * @param x left operand
                 * @param y right operand
                 */
                FilterExpression.prototype.in = function (x, y) {
                    var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                    return function () { return a() + " in " + b(); };
                };
                /**
                 * Checks if the right operand is an enumeration value whose flag(s) are set on the left operand
                 * @param x left operand
                 * @param y right operand
                 */
                FilterExpression.prototype.has = function (x, y) {
                    var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                    return function () { return a() + " has " + b(); };
                };
                FilterExpression.prototype.collection = function () {
                    var _this = this;
                    var rest = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        rest[_i] = arguments[_i];
                    }
                    return function () { return "[" + rest.map(function (x) {
                        var a = _this.toSimple(x);
                        return a();
                    }).join(',') + "]"; };
                };
                /**
                 * Check if the second string is a substring of the first string
                 * @param x left operand
                 * @param y right operand
                 */
                FilterExpression.prototype.contains = function (x, y) {
                    var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                    return function () { return "contains(" + a() + "," + b() + ")"; };
                };
                /**
                 * Specifies a current date and time
                 */
                FilterExpression.prototype.now = function () {
                    return function () { return 'now()'; };
                };
                /**
                 * A fractional seconds component of a time value
                 * @param x a time value
                 */
                FilterExpression.prototype.fractionalSeconds = function (x) {
                    var a = this.toSimple(x);
                    return function () { return "fractionalseconds(" + a() + ")"; };
                };
                /**
                 * A total number of seconds in a time value since the earliest possible time
                 * @param x a time value
                 */
                FilterExpression.prototype.totalSeconds = function (x) {
                    var a = this.toSimple(x);
                    return function () { return "totalseconds(" + a() + ")"; };
                };
                /**
                 * A date component of a date-time value
                 * @param x a date-time value
                 */
                FilterExpression.prototype.date = function (x) {
                    var a = this.toSimple(x);
                    return function () { return "date(" + a() + ")"; };
                };
                /**
                 * A time component of a date-time value
                 * @param x a date-time value
                 */
                FilterExpression.prototype.time = function (x) {
                    var a = this.toSimple(x);
                    return function () { return "time(" + a() + ")"; };
                };
                /**
                 * An offset component of a date-time value
                 * @param x a date-time value
                 */
                FilterExpression.prototype.totalOffsetMinutes = function (x) {
                    var a = this.toSimple(x);
                    return function () { return "totaloffsetminutes(" + a() + ")"; };
                };
                /**
                 * The earliest possible date and time value
                 */
                FilterExpression.prototype.minDateTime = function () {
                    return function () { return 'mindatetime()'; };
                };
                /**
                 * The latest possible date and time value
                 */
                FilterExpression.prototype.maxDateTime = function () {
                    return function () { return 'maxdatetime()'; };
                };
                FilterExpression.prototype.lambdaInternal = function (pathRule, kind, query) {
                    var path = pathRule.toString();
                    var lambdaQuery = new LambdaQuery(this);
                    if (query == null && kind === 'any') {
                        return function () { return path + "/any()"; };
                    }
                    var z = query(lambdaQuery);
                    var a = this.toSimple(z);
                    var varName = lambdaQuery.variableName;
                    return function () { return path + "/" + kind + "(" + varName + ":" + a() + ")"; };
                };
                /**
                 * Checks if any element of the collection satisfies the condition
                 * Empty collection satisfies the condition
                 * Query example:
                 * ```
                 * query.filter(f => f.any(f.path('Items'), x => f.eq(f.path(x,'Discount'), 5)))
                 * ```
                 * Request example:
                 * ```
                 * $filter=Items/any(a:a/Discount eq 5)
                 * ```
                 * @param path a path to a collection
                 * @param query a query to check. If not specified, checks if the collection is not empty
                 */
                FilterExpression.prototype.any = function (path, query) {
                    return this.lambdaInternal(path, 'any', query);
                };
                /**
                 * Checks if all elements of the collection satisfy the condition
                 * ```
                 * query.filter(f => f.all(f.path('Items'), x => f.eq(f.path(x,'Discount'), 5)))
                 * ```
                 * Request example:
                 * ```
                 * $filter=Items/all(a:a/Discount eq 5)
                 * ```
                 * @param path a path to a collection
                 * @param y a query to check
                 */
                FilterExpression.prototype.all = function (path, y) {
                    return this.lambdaInternal(path, 'all', y);
                };
                return FilterExpression;
            }(osa.query.FilterExpression));
            odata4.FilterExpression = FilterExpression;
            var basetypes = {
                Boolean: 'Edm.Boolean',
                Date: 'Edm.Date',
                DateTimeOffset: 'Edm.DateTimeOffset',
                Timestamp: 'Edm.DateTimeOffset',
                Decimal: 'Edm.Decimal',
                Double: 'Edm.Double',
                Time: 'Edm.Duration',
                Guid: 'Edm.Guid',
                Int: 'Edm.Int32',
                Long: 'Edm.Int64',
                BigInt: 'Edm.Int64',
                String: 'Edm.String',
                URI: 'Edm.String',
            };
            /**
             * A lambda expression language
             * A variable should be used as a path segment in the query.
             * Query example:
             * ```
             * query.filter(f => f.any(f.path('Items'), x => f.eq(f.path(x,'Discount'), 5)))
             * ```
             * Request example:
             * ```
             * $filter=Items/any(a:a/Discount eq 5)
             * ```
             */
            var LambdaQuery = /** @class */ (function (_super) {
                __extends(LambdaQuery, _super);
                function LambdaQuery(parent) {
                    var _this = _super.call(this) || this;
                    _this.parent = parent;
                    _this.variableName = _this.nextLambdaVariableName();
                    return _this;
                }
                LambdaQuery.prototype.nextLambdaVariableName = function () {
                    // @ts-ignore
                    return this.parent.nextLambdaVariableName();
                };
                return LambdaQuery;
            }(FilterExpression));
            odata4.LambdaQuery = LambdaQuery;
        })(odata4 = query_4.odata4 || (query_4.odata4 = {}));
    })(query = osa.query || (osa.query = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var query;
    (function (query_5) {
        /**
         * @internal
         */
        var Compiler = /** @class */ (function () {
            function Compiler() {
            }
            Compiler.prototype.compile = function (query) {
                var e_14, _a, e_15, _b;
                var _this = this;
                var result = {};
                if (query.$select.length) {
                    result.$select = query.$select.join(',');
                }
                if (query.$orderBy.length) {
                    result.$orderby = query.$orderBy.map(function (x) { return _this.buildOrderBy(x); }).join(',');
                }
                if (query.$top || query.$top === 0) {
                    result.$top = query.$top;
                }
                if (query.$skip || query.$skip === 0) {
                    result.$skip = query.$skip;
                }
                this.visitCount(query, result);
                if (query.$filter) {
                    result.$filter = query.$filter();
                }
                if (query.$id) {
                    result.$id = query.$id;
                }
                if (query.$custom.length > 0) {
                    try {
                        for (var _c = __values(query.$custom), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                            result[key] = value;
                        }
                    }
                    catch (e_14_1) { e_14 = { error: e_14_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_14) throw e_14.error; }
                    }
                }
                if (query.$alias.length > 0) {
                    try {
                        for (var _f = __values(query.$alias), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var _h = __read(_g.value, 2), key = _h[0], value = _h[1];
                            result['@' + key] = value;
                        }
                    }
                    catch (e_15_1) { e_15 = { error: e_15_1 }; }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                        }
                        finally { if (e_15) throw e_15.error; }
                    }
                }
                if (Object.keys(query.$expand).length > 0) {
                    result.$expand = this.visitExpand(query);
                }
                return result;
            };
            Compiler.prototype.buildOrderBy = function (orderBy) {
                var _a = __read(orderBy, 2), value = _a[0], order = _a[1];
                return (value + " " + (order || '')).trim();
            };
            return Compiler;
        }());
        query_5.Compiler = Compiler;
    })(query = osa.query || (osa.query = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var query;
    (function (query_6) {
        var odata3;
        (function (odata3) {
            /**
             * @internal
             */
            var Query = /** @class */ (function (_super) {
                __extends(Query, _super);
                function Query() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.version = "odata3" /* ODATA3 */;
                    _this.$expand = {};
                    return _this;
                }
                Query.prototype.filter = function (fn) {
                    var anyRule = fn(new odata3.FilterExpression());
                    this.$filter = odata3.FilterExpression.toSimpleRule(anyRule);
                    return this;
                };
                Query.prototype.expand = function (expand) {
                    return _super.prototype.expand.call(this, expand);
                };
                Query.prototype.count = function () {
                    this.$inlineCount = true;
                    return this;
                };
                Query.prototype.toParams = function (init) {
                    var params = new odata3.Compiler().compile(this);
                    return new osa.common.Params(__assign(__assign({}, init), params));
                };
                Query.prototype.getExpandInstance = function (options) {
                    return new Expand();
                };
                return Query;
            }(osa.query.Query));
            odata3.Query = Query;
            /**
             * @internal
             */
            var Expand = /** @class */ (function (_super) {
                __extends(Expand, _super);
                function Expand() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return Expand;
            }(Query));
            odata3.Expand = Expand;
        })(odata3 = query_6.odata3 || (query_6.odata3 = {}));
    })(query = osa.query || (osa.query = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var query;
    (function (query_7) {
        var odata3;
        (function (odata3) {
            /**
             * @internal
             */
            var Compiler = /** @class */ (function (_super) {
                __extends(Compiler, _super);
                function Compiler() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Compiler.prototype.visitCount = function (query, result) {
                    if (query.$inlineCount) {
                        result.$inlinecount = 'allpages';
                    }
                };
                Compiler.prototype.visitExpand = function (query) {
                    var result = [];
                    var iterator = function (o, path) {
                        if (path === void 0) { path = []; }
                        if (!o || typeof o !== 'object') {
                            return result.push(path);
                        }
                        var expand = o.$expand;
                        var keys = Object.keys(expand);
                        if (!keys.length) {
                            return result.push(path);
                        }
                        return keys.forEach(function (key) { return iterator(expand[key], path.concat(key)); });
                    };
                    iterator(query);
                    return result.map(function (v) { return v.join('/'); }).join(',');
                };
                return Compiler;
            }(osa.query.Compiler));
            odata3.Compiler = Compiler;
        })(odata3 = query_7.odata3 || (query_7.odata3 = {}));
    })(query = osa.query || (osa.query = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var query;
    (function (query) {
        var odata4;
        (function (odata4) {
            /**
             * @internal
             */
            var Query = /** @class */ (function (_super) {
                __extends(Query, _super);
                function Query(parent) {
                    var _this = _super.call(this) || this;
                    _this.parent = parent;
                    _this.version = "odata4" /* ODATA4 */;
                    _this.$expand = {};
                    return _this;
                }
                Query.prototype.filter = function (fn) {
                    var anyRule = fn(new odata4.FilterExpression());
                    this.$filter = odata4.FilterExpression.toSimpleRule(anyRule);
                    return this;
                };
                Query.prototype.expand = function (expand, subQuery) {
                    return _super.prototype.expand.call(this, expand, subQuery);
                };
                Query.prototype.search = function (fn) {
                    var anyRule = fn(new odata4.SearchExpression());
                    this.$search = odata4.SearchExpression.toSimpleRule(anyRule);
                    return this;
                };
                Query.prototype.count = function () {
                    this.$count = true;
                    return this;
                };
                Query.prototype.toParams = function (init) {
                    var params = new odata4.Compiler().compile(this);
                    return new osa.common.Params(__assign(__assign({}, init), params));
                };
                Query.prototype.getExpandInstance = function (parent) {
                    return new Expand(parent);
                };
                return Query;
            }(osa.query.Query));
            odata4.Query = Query;
            /**
             * @internal
             */
            var Expand = /** @class */ (function (_super) {
                __extends(Expand, _super);
                function Expand(parent) {
                    return _super.call(this, parent) || this;
                }
                Expand.prototype.levels = function (level) {
                    this.$levels = level;
                    return this;
                };
                return Expand;
            }(Query));
            odata4.Expand = Expand;
        })(odata4 = query.odata4 || (query.odata4 = {}));
    })(query = osa.query || (osa.query = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var query;
    (function (query_8) {
        var odata4;
        (function (odata4) {
            /**
             * @internal
             */
            var Compiler = /** @class */ (function (_super) {
                __extends(Compiler, _super);
                function Compiler() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Compiler.prototype.visitExpand = function (query) {
                    var e_16, _a;
                    var expand = Object.entries(query.$expand);
                    var props = [];
                    try {
                        for (var expand_1 = __values(expand), expand_1_1 = expand_1.next(); !expand_1_1.done; expand_1_1 = expand_1.next()) {
                            var _b = __read(expand_1_1.value, 2), key = _b[0], value = _b[1];
                            var result = this.compile(value);
                            var entries = Object.entries(result);
                            if (entries.length > 0) {
                                var params = Object.entries(result).map(function (_a) {
                                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                    return key + "=" + value;
                                }).join(';');
                                props.push(key + "(" + params + ")");
                            }
                            else {
                                props.push(key);
                            }
                        }
                    }
                    catch (e_16_1) { e_16 = { error: e_16_1 }; }
                    finally {
                        try {
                            if (expand_1_1 && !expand_1_1.done && (_a = expand_1.return)) _a.call(expand_1);
                        }
                        finally { if (e_16) throw e_16.error; }
                    }
                    return props.join(query.parent == null ? ',' : ';');
                };
                Compiler.prototype.visitCount = function (query, result) {
                    if (query.$count) {
                        result.$count = 'true';
                    }
                };
                Compiler.prototype.compile = function (query) {
                    var result = _super.prototype.compile.call(this, query);
                    if (query.$search) {
                        result.$search = query.$search();
                    }
                    if (query instanceof odata4.Expand && query.$levels) {
                        result.$levels = query.$levels;
                    }
                    if (Object.keys(query.$expand).length > 0) {
                        result.$expand = this.visitExpand(query);
                    }
                    return result;
                };
                return Compiler;
            }(osa.query.Compiler));
            odata4.Compiler = Compiler;
        })(odata4 = query_8.odata4 || (query_8.odata4 = {}));
    })(query = osa.query || (osa.query = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var query;
    (function (query) {
        var odata4;
        (function (odata4) {
            /**
             * A search expression language for the building of the search expression string
             */
            var SearchExpression = /** @class */ (function () {
                function SearchExpression() {
                }
                SearchExpression.prototype.toSimple = function () {
                    var _this = this;
                    var rules = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        rules[_i] = arguments[_i];
                    }
                    var toBuiltIn = function (a) {
                        if (a == null) {
                            throw new Error("Invalid argument: null");
                        }
                        if (typeof a === 'function') {
                            return a;
                        }
                        switch (typeof a) {
                            case 'string':
                                return _this.value(a);
                        }
                        throw new Error('Unsupported case, only known unambiguous types are supported');
                    };
                    if (rules.length === 1) {
                        return toBuiltIn(rules[0]);
                    }
                    else if (rules.length === 2) {
                        return rules.map(function (x) { return toBuiltIn(x); });
                    }
                    throw new Error('Unsupported case, only 1 or 2 arguments are supported');
                };
                SearchExpression.toSimpleRule = function (expression) {
                    return new SearchExpression().toSimple(expression);
                };
                /**
                 * A given value combinator
                 * Query example:
                 * ```
                 * query.search(s => s.value('Jane'))
                 * ```
                 * Request example:
                 * ```
                 * $search=Jane
                 * ```
                 */
                SearchExpression.prototype.value = function (x) {
                    if (x.indexOf(' ') >= 0) {
                        return function () { return "\"" + x + "\""; };
                    }
                    return function () { return x; };
                };
                /**
                 * An AND expression combinator
                 * @param x the left hand side
                 * @param y the right hand side
                 * Query example:
                 * ```
                 * query.search(s => s.and('Jane', 'Doe'))
                 * ```
                 * Request example:
                 * ```
                 * $search=Jane AND Doe
                 * ```
                 */
                SearchExpression.prototype.and = function (x, y) {
                    var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                    return function () { return a() + " AND " + b(); };
                };
                /**
                 * An OR expression combinator
                 * @param x the left hand side
                 * @param y the right hand side
                 * Query example:
                 * ```
                 * query.search(s => s.or('Jane', 'Doe'))
                 * ```
                 * Request example:
                 * ```
                 * $search=Jane OR Doe
                 * ```
                 */
                SearchExpression.prototype.or = function (x, y) {
                    var _a = __read(this.toSimple(x, y), 2), a = _a[0], b = _a[1];
                    return function () { return a() + " OR " + b(); };
                };
                /**
                 * A group expression combinator
                 * Query example:
                 * ```
                 * query.search(s => s.group(s => s.and('Jane', 'Doe')))
                 * ```
                 * Request example:
                 * ```
                 * $search=(Jane AND Doe)
                 * ```
                 * @param x a rule
                 */
                SearchExpression.prototype.group = function (x) {
                    var a = this.toSimple(x);
                    return function () { return "(" + a() + ")"; };
                };
                /**
                 * A NOT expression combinator
                 * Query example:
                 * ```
                 * query.search(s => s.not('Jane'))
                 * ```
                 * Request example:
                 * ```
                 * $search=NOT Jane
                 * ```
                 * @param x a rule
                 */
                SearchExpression.prototype.not = function (x) {
                    var a = this.toSimple(x);
                    var v = a();
                    if (v.startsWith('(')) {
                        return function () { return "NOT" + v; };
                    }
                    else {
                        return function () { return "NOT " + v; };
                    }
                };
                return SearchExpression;
            }());
            odata4.SearchExpression = SearchExpression;
        })(odata4 = query.odata4 || (query.odata4 = {}));
    })(query = osa.query || (osa.query = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var Character = /** @class */ (function () {
        function Character() {
        }
        Character.isUpperCase = function (x) {
            return Character.isLetter(x) && x.toUpperCase() === x;
        };
        Character.toUpperCase = function (s) {
            return s.toUpperCase();
        };
        Character.toLowerCase = function (s) {
            return s.toLowerCase();
        };
        Character.isLetter = function (s) {
            return Character.isLetterRegex.test(s);
        };
        Character.isLetterRegex = new RegExp('[a-zA-Z]');
        return Character;
    }());
    var Plurals = /** @class */ (function () {
        function Plurals() {
            var e_17, _a;
            this.dictionary = new Map();
            this.reverseDictionary = new Map();
            // to test that this class only initializes once uncomment next line
            // System.Web.HttpContext.Current.Response.Write("initializing singleton <br>");
            // irregular plurals
            this.dictionary.set("afterlife", "afterlives");
            this.dictionary.set("alga", "algae");
            this.dictionary.set("alumna", "alumnae");
            this.dictionary.set("alumnus", "alumni");
            this.dictionary.set("analysis", "analyses");
            this.dictionary.set("antenna", "antennae");
            this.dictionary.set("appendix", "appendices");
            this.dictionary.set("axis", "axes");
            this.dictionary.set("bacillus", "bacilli");
            this.dictionary.set("basis", "bases");
            this.dictionary.set("Bedouin", "Bedouin");
            this.dictionary.set("cactus", "cacti");
            this.dictionary.set("calf", "calves");
            this.dictionary.set("cherub", "cherubim");
            this.dictionary.set("child", "children");
            this.dictionary.set("cod", "cod");
            this.dictionary.set("cookie", "cookies");
            this.dictionary.set("criterion", "criteria");
            this.dictionary.set("curriculum", "curricula");
            this.dictionary.set("datum", "data");
            this.dictionary.set("deer", "deer");
            this.dictionary.set("diagnosis", "diagnoses");
            this.dictionary.set("die", "dice");
            this.dictionary.set("dormouse", "dormice");
            this.dictionary.set("elf", "elves");
            this.dictionary.set("elk", "elk");
            this.dictionary.set("erratum", "errata");
            this.dictionary.set("esophagus", "esophagi");
            this.dictionary.set("fauna", "faunae");
            this.dictionary.set("fish", "fish");
            this.dictionary.set("flora", "florae");
            this.dictionary.set("focus", "foci");
            this.dictionary.set("foot", "feet");
            this.dictionary.set("formula", "formulae");
            this.dictionary.set("fundus", "fundi");
            this.dictionary.set("fungus", "fungi");
            this.dictionary.set("genie", "genii");
            this.dictionary.set("genus", "genera");
            this.dictionary.set("goose", "geese");
            this.dictionary.set("grouse", "grouse");
            this.dictionary.set("hake", "hake");
            this.dictionary.set("half", "halves");
            this.dictionary.set("headquarters", "headquarters");
            this.dictionary.set("hippo", "hippos");
            this.dictionary.set("hippopotamus", "hippopotami");
            this.dictionary.set("hoof", "hooves");
            this.dictionary.set("housewife", "housewives");
            this.dictionary.set("hypothesis", "hypotheses");
            this.dictionary.set("id", "ids");
            this.dictionary.set("index", "indices");
            this.dictionary.set("jackknife", "jackknives");
            this.dictionary.set("knife", "knives");
            this.dictionary.set("labium", "labia");
            this.dictionary.set("larva", "larvae");
            this.dictionary.set("leaf", "leaves");
            this.dictionary.set("life", "lives");
            this.dictionary.set("loaf", "loaves");
            this.dictionary.set("louse", "lice");
            this.dictionary.set("magus", "magi");
            this.dictionary.set("man", "men");
            this.dictionary.set("memorandum", "memoranda");
            this.dictionary.set("midwife", "midwives");
            this.dictionary.set("millennium", "millennia");
            this.dictionary.set("moose", "moose");
            this.dictionary.set("mouse", "mice");
            this.dictionary.set("nebula", "nebulae");
            this.dictionary.set("neurosis", "neuroses");
            this.dictionary.set("nova", "novas");
            this.dictionary.set("nucleus", "nuclei");
            this.dictionary.set("oesophagus", "oesophagi");
            this.dictionary.set("offspring", "offspring");
            this.dictionary.set("ovum", "ova");
            this.dictionary.set("ox", "oxen");
            this.dictionary.set("papyrus", "papyri");
            this.dictionary.set("passerby", "passersby");
            this.dictionary.set("penknife", "penknives");
            this.dictionary.set("person", "people");
            this.dictionary.set("phenomenon", "phenomena");
            this.dictionary.set("placenta", "placentae");
            this.dictionary.set("pocketknife", "pocketknives");
            this.dictionary.set("pupa", "pupae");
            this.dictionary.set("radius", "radii");
            this.dictionary.set("reindeer", "reindeer");
            this.dictionary.set("retina", "retinae");
            this.dictionary.set("rhinoceros", "rhinoceros");
            this.dictionary.set("roe", "roe");
            this.dictionary.set("salmon", "salmon");
            this.dictionary.set("scarf", "scarves");
            this.dictionary.set("self", "selves");
            this.dictionary.set("seraph", "seraphim");
            this.dictionary.set("series", "series");
            this.dictionary.set("sheaf", "sheaves");
            this.dictionary.set("sheep", "sheep");
            this.dictionary.set("shelf", "shelves");
            this.dictionary.set("species", "species");
            this.dictionary.set("spectrum", "spectra");
            this.dictionary.set("stimulus", "stimuli");
            this.dictionary.set("stratum", "strata");
            this.dictionary.set("supernova", "supernovas");
            this.dictionary.set("swine", "swine");
            this.dictionary.set("terminus", "termini");
            this.dictionary.set("thesaurus", "thesauri");
            this.dictionary.set("thesis", "theses");
            this.dictionary.set("thief", "thieves");
            this.dictionary.set("trout", "trout");
            this.dictionary.set("vulva", "vulvae");
            this.dictionary.set("wife", "wives");
            this.dictionary.set("wildebeest", "wildebeest");
            this.dictionary.set("wolf", "wolves");
            this.dictionary.set("woman", "women");
            this.dictionary.set("yen", "yen");
            try {
                for (var _b = __values(this.dictionary.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                    this.reverseDictionary.set(value, key);
                }
            }
            catch (e_17_1) { e_17 = { error: e_17_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_17) throw e_17.error; }
            }
        }
        Plurals.prototype.toPlural = function (word) {
            var lastDot = word.lastIndexOf('.');
            var prefix = word.substring(0, lastDot + 1);
            var postfix = word.substring(lastDot + 1);
            var capMap = this.getCapitalizationMap(postfix);
            var postfixPluralized = this.applyCapitalizationMap(this.toPluralInternal(postfix), capMap);
            var retVal = prefix + postfixPluralized;
            return retVal;
        };
        /**
         * @param word
         * @return bitset with 1's at positions corresponding to capital letters
         */
        Plurals.prototype.getCapitalizationMap = function (word) {
            var capMap = new Array(word.length);
            for (var i = 0; i < word.length; ++i) {
                capMap[i] = Character.isUpperCase(word.charAt(i));
            }
            return capMap;
        };
        Plurals.prototype.applyCapitalizationMap = function (word, capMap) {
            var builder = new Array();
            for (var i = 0; i < word.length; ++i) {
                if (!Character.isLetter(word.charAt(i))) {
                    builder.push(word.charAt(i));
                    continue;
                }
                var isCurrentUpper = capMap[i < capMap.length ? i : (capMap.length - 1)];
                if (isCurrentUpper) {
                    builder.push(Character.toUpperCase(word.charAt(i)));
                }
                else {
                    builder.push(Character.toLowerCase(word.charAt(i)));
                }
            }
            return builder.join('');
        };
        /**
         * Call this method to get the properly pluralized
         * English version of the word.
         * @param word The word needing conditional pluralization.
         * @return The pluralized word
         */
        Plurals.prototype.toPluralInternal = function (word) {
            if (this.isPlural(word) == true) {
                return word; //it's already a plural
            }
            else if (this.dictionary.has(word.toLowerCase())) 
            //it's an irregular plural, use the word from the dictionary
            {
                return this.dictionary.get(word.toLowerCase());
            }
            if (word.length <= 2) {
                return word; //not a word that can be pluralised!
            }
            //1. If the word ends in a consonant plus -y, change the -y into
            //-ie and add an -s to form the plural
            //e.g. enemy--enemies baby--babies
            switch (word.substring(word.length - 2)) {
                case "by":
                case "cy":
                case "dy":
                case "fy":
                case "gy":
                case "hy":
                case "jy":
                case "ky":
                case "ly":
                case "my":
                case "ny":
                case "py":
                case "ry":
                case "sy":
                case "ty":
                case "vy":
                case "wy":
                case "xy":
                case "zy": {
                    return word.substring(0, word.length - 1) + "ies";
                }
                //2. For words that end in -is, change the -is to -es to make the plural form.
                //synopsis--synopses
                //thesis--theses
                case "is": {
                    return word.substring(0, word.length - 1) + "es";
                }
                //3. For words that end in a "hissing" sound (s,z,x,ch,sh), add an -es to form the plural.
                //box--boxes
                //church--churches
                case "ch":
                case "sh": {
                    return word + "es";
                }
                default: {
                    switch (word.substring(word.length - 1)) {
                        case "s":
                        case "z":
                        case "x": {
                            return word + "es";
                        }
                        default: {
                            //4. Assume add an -s to form the plural of most words.
                            return word + "s";
                        }
                    }
                }
            }
        };
        /**
         * Call this method to get the singular
         * version of a plural English word.
         * @param word The word to turn into a singular
         * @return The singular word
         */
        Plurals.prototype.toSingular = function (word) {
            word = word.toLowerCase();
            if (this.reverseDictionary.has(word)) {
                return this.reverseDictionary.get(word);
            }
            if (word.substring(word.length - 1) !== "s") {
                return word; // not a plural word if it doesn't end in S
            }
            if (word.length <= 2) {
                return word; // not a word that can be made singular if only two letters!
            }
            if (word.length >= 4) {
                //1. If the word ends in a consonant plus -y, change the -y into -ie and add an -s to form the plural – so reverse engineer it to get the singular
                // e.g. enemy--enemies baby--babies family--families
                switch (word.substring(word.length - 4)) {
                    case "bies":
                    case "cies":
                    case "dies":
                    case "fies":
                    case "gies":
                    case "hies":
                    case "jies":
                    case "kies":
                    case "lies":
                    case "mies":
                    case "nies":
                    case "pies":
                    case "ries":
                    case "sies":
                    case "ties":
                    case "vies":
                    case "wies":
                    case "xies":
                    case "zies": {
                        return word.substring(0, word.length - 3) + "y";
                    }
                    //3. For words that end in a "hissing" sound (s,z,x,ch,sh), add an -es to form the plural.
                    //church--churches
                    case "ches":
                    case "shes": {
                        return word.substring(0, word.length - 2);
                    }
                }
            }
            if (word.length >= 3) {
                switch (word.substring(word.length - 3)) {
                    //box--boxes
                    case "ses":
                    //NOTE some false positives here - For words that end in -is, change the -is to -es to make the plural form.
                    //synopsis--synopses
                    //thesis--theses
                    case "zes":
                    case "xes": {
                        return word.substring(0, word.length - 2);
                    }
                }
            }
            if (word.length >= 3) {
                switch (word.substring(word.length - 2)) {
                    case "es": {
                        return word.substring(0, word.length - 1) + "is";
                    }
                    //4. Assume add an -s to form the plural of most words.
                    default: {
                        return word.substring(0, word.length - 1);
                    }
                }
            }
            return word;
        };
        /**
         * test if a word is plural
         * @param word word to test
         * @returns true if a word is plural
         */
        Plurals.prototype.isPlural = function (word) {
            word = word.toLowerCase();
            if (word.length <= 2) {
                return false; // not a word that can be made singular if only two letters!
            }
            if (this.reverseDictionary.has(word.toLowerCase())) {
                return true; //it's definitely already a plural
            }
            if (word.length >= 4) {
                // 1. If the word ends in a consonant plus -y, change the -y into -ie and add an -s to form the plural
                // e.g. enemy--enemies baby--babies family--families
                switch (word.substring(word.length - 4)) {
                    case "bies":
                    case "cies":
                    case "dies":
                    case "fies":
                    case "gies":
                    case "hies":
                    case "jies":
                    case "kies":
                    case "lies":
                    case "mies":
                    case "nies":
                    case "pies":
                    case "ries":
                    case "sies":
                    case "ties":
                    case "vies":
                    case "wies":
                    case "xies":
                    case "zies":
                    case "ches":
                    case "shes": {
                        return true;
                    }
                }
            }
            if (word.length >= 3) {
                switch (word.substring(word.length - 3)) {
                    //box--boxes
                    case "ses":
                    case "zes":
                    case "xes": {
                        return true;
                    }
                }
            }
            if (word.length >= 3) {
                switch (word.substring(word.length - 2)) {
                    case "es": {
                        return true;
                    }
                }
            }
            if (word.substring(word.length - 1) !== "s") {
                return false; // not a plural word if it doesn't end in S
            }
            return true;
        };
        Plurals.INSTANCE = new Plurals();
        return Plurals;
    }());
    osa.Plurals = Plurals;
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        function create(svc, fn) {
            var head = new request.builders.ServiceBuilderImpl(svc);
            var tail = fn(head);
            return tail.createRequest();
        }
        request.create = create;
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            /**
             * @internal
             */
            var BuilderBase = /** @class */ (function () {
                function BuilderBase(_prev) {
                    this._prev = _prev;
                }
                BuilderBase.prototype.options = function (options) {
                    this.expectNull(this._headers, 'headers');
                    return this.createSelf(function (x) { return x._headers = options.headers; });
                };
                BuilderBase.prototype.query = function (expr) {
                    this.expectNull(this._query, 'query');
                    return this.createSelf(function (x) { return x._query = expr; });
                };
                BuilderBase.prototype.createRequest = function () {
                    return new request.RegularRequestImpl(this);
                };
                BuilderBase.prototype.build = function (ro) {
                    var options = __assign(__assign({}, ro), { method: this._method || ro.method || null, headers: this._headers || ro.headers || null });
                    return options;
                };
                BuilderBase.prototype.createSelf = function (setter) {
                    var self = Object.assign(new this.constructor, this);
                    setter(self);
                    return self;
                };
                BuilderBase.prototype.expectNull = function (value, name) {
                    if (value != null) {
                        throw new Error("Unexpected error during request build: " + name + " is not null");
                    }
                };
                BuilderBase.build = function (tail) {
                    var segments = [];
                    var current = tail;
                    while (current != null) {
                        segments.unshift(current);
                        current = current._prev;
                    }
                    var ro = segments.reduce(function (acc, item) { return item.build(acc); }, {});
                    var svc = segments[0].resolveService();
                    var query = tail._query;
                    ro.url = svc.buildUrl(ro.url, '', query, null);
                    ro.method = ro.method || "GET" /* GET */;
                    ro.headers = ro.headers || {};
                    return [svc, ro,];
                };
                BuilderBase.prototype.resolveService = function () {
                    return this._prev.resolveService();
                };
                BuilderBase.resolveDataType = function (clazz, propertyKey) {
                    var r2 = clazz.getDataTypePropertyMetadata(clazz, propertyKey).r2;
                    return r2();
                };
                return BuilderBase;
            }());
            builders.BuilderBase = BuilderBase;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            /**
             * @internal
             */
            var BatchBuilderImpl = /** @class */ (function (_super) {
                __extends(BatchBuilderImpl, _super);
                function BatchBuilderImpl(prev, parts) {
                    var _this = _super.call(this, prev) || this;
                    _this.parts = parts;
                    return _this;
                }
                BatchBuilderImpl.prototype.createRequest = function () {
                    return new request.BatchRequestImpl(this);
                };
                BatchBuilderImpl.prototype.build = function (ro) {
                    var url = Service.combineUrl(ro.url, '$batch');
                    var method = "POST" /* POST */;
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { url: url,
                        method: method, requestContext: null }));
                };
                BatchBuilderImpl.prototype.toBatch = function () {
                    return this;
                };
                return BatchBuilderImpl;
            }(builders.BuilderBase));
            builders.BatchBuilderImpl = BatchBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            /**
             * @internal
             */
            var CountBuilderImpl = /** @class */ (function (_super) {
                __extends(CountBuilderImpl, _super);
                function CountBuilderImpl(prev) {
                    return _super.call(this, prev) || this;
                }
                CountBuilderImpl.prototype.build = function (ro) {
                    var _a;
                    var url = Service.combineUrl(ro.url, '$count');
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: "GET" /* GET */, url: url, headers: (_a = {},
                            _a[osa.constants.AcceptHeaderName] = 'text/plain',
                            _a), requestContext: null }));
                };
                CountBuilderImpl.prototype.createRequest = function () {
                    return new request.CountRequestImpl(this);
                };
                return CountBuilderImpl;
            }(builders.BuilderBase));
            builders.CountBuilderImpl = CountBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            /**
             * @internal
             */
            var RawBuilderImpl = /** @class */ (function (_super) {
                __extends(RawBuilderImpl, _super);
                function RawBuilderImpl(prev, _options) {
                    var _this = _super.call(this, prev) || this;
                    _this._options = _options;
                    return _this;
                }
                RawBuilderImpl.prototype.toRaw = function () {
                    return this;
                };
                RawBuilderImpl.prototype.build = function (ro) {
                    var _a = this._options, url = _a.url, method = _a.method, query = _a.query, payload = _a.payload, headers = _a.headers, options = _a.options;
                    return _super.prototype.build.call(this, __assign(__assign(__assign({}, ro), { url: url,
                        method: method,
                        headers: headers }), payload));
                };
                RawBuilderImpl.prototype.createRequest = function () {
                    return new request.RawRequestImpl(this);
                };
                return RawBuilderImpl;
            }(builders.BuilderBase));
            builders.RawBuilderImpl = RawBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            /**
             * @internal
             */
            var ValueBuilderImpl = /** @class */ (function (_super) {
                __extends(ValueBuilderImpl, _super);
                function ValueBuilderImpl(prev) {
                    return _super.call(this, prev) || this;
                }
                ValueBuilderImpl.prototype.build = function (ro) {
                    var _a;
                    var url = Service.combineUrl(ro.url, '$value');
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: "GET" /* GET */, url: url, headers: __assign(__assign({}, ro.headers), (_a = {}, _a[osa.constants.AcceptHeaderName] = 'text/plain;charset=utf-8', _a)), requestContext: null }));
                };
                ValueBuilderImpl.prototype.createRequest = function () {
                    return new request.ValueRequestImpl(this);
                };
                return ValueBuilderImpl;
            }(builders.BuilderBase));
            builders.ValueBuilderImpl = ValueBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            /**
             * @internal
             */
            var MediaBuilderImpl = /** @class */ (function (_super) {
                __extends(MediaBuilderImpl, _super);
                function MediaBuilderImpl(prev) {
                    return _super.call(this, prev) || this;
                }
                MediaBuilderImpl.prototype.toMedia = function () {
                    return this;
                };
                MediaBuilderImpl.prototype.build = function (ro) {
                    var _a;
                    var url = Service.combineUrl(ro.url, '$value');
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { url: url, headers: __assign(__assign({}, ro.headers), (_a = {}, _a[osa.constants.AcceptHeaderName] = '*/*', _a)), requestContext: null }));
                };
                MediaBuilderImpl.prototype.createRequest = function () {
                    return new osa.request.MediaRequestImpl(this);
                };
                return MediaBuilderImpl;
            }(builders.BuilderBase));
            builders.MediaBuilderImpl = MediaBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            /**
             * @internal
             */
            var PutMediaBuilderImpl = /** @class */ (function (_super) {
                __extends(PutMediaBuilderImpl, _super);
                function PutMediaBuilderImpl(prev, _content, _mimeType) {
                    var _this = _super.call(this, prev) || this;
                    _this._content = _content;
                    _this._mimeType = _mimeType;
                    return _this;
                }
                PutMediaBuilderImpl.prototype.build = function (ro) {
                    var method = "PUT" /* PUT */;
                    var url = Service.combineUrl(ro.url, '$value');
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { url: url,
                        method: method, body: this._content, bodyType: this._mimeType }));
                };
                return PutMediaBuilderImpl;
            }(builders.BuilderBase));
            builders.PutMediaBuilderImpl = PutMediaBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            /**
             * @internal
             */
            var ReplaceBuilderImpl = /** @class */ (function (_super) {
                __extends(ReplaceBuilderImpl, _super);
                function ReplaceBuilderImpl(prev, _entity) {
                    var _this = _super.call(this, prev) || this;
                    _this._entity = _entity;
                    return _this;
                }
                ReplaceBuilderImpl.prototype.build = function (ro) {
                    var method = "PUT" /* PUT */;
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: method, data: this._entity, requestContext: new osa.common.odata.VoidResultContext() }));
                };
                return ReplaceBuilderImpl;
            }(builders.BuilderBase));
            builders.ReplaceBuilderImpl = ReplaceBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            /**
             * @internal
             */
            var RemoveBuilderImpl = /** @class */ (function (_super) {
                __extends(RemoveBuilderImpl, _super);
                function RemoveBuilderImpl(prev) {
                    return _super.call(this, prev) || this;
                }
                RemoveBuilderImpl.prototype.build = function (ro) {
                    var method = "DELETE" /* DELETE */;
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: method, requestContext: new osa.common.odata.VoidResultContext() }));
                };
                return RemoveBuilderImpl;
            }(builders.BuilderBase));
            builders.RemoveBuilderImpl = RemoveBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            /**
             * @internal
             */
            var UpdateBuilderImpl = /** @class */ (function (_super) {
                __extends(UpdateBuilderImpl, _super);
                function UpdateBuilderImpl(prev, _entity) {
                    var _this = _super.call(this, prev) || this;
                    _this._entity = _entity;
                    return _this;
                }
                UpdateBuilderImpl.prototype.build = function (ro) {
                    var method = "PATCH" /* PATCH */;
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: method, data: this._entity, requestContext: new osa.common.odata.VoidResultContext() }));
                };
                return UpdateBuilderImpl;
            }(builders.BuilderBase));
            builders.UpdateBuilderImpl = UpdateBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            var GeneralError = osa.error.GeneralError;
            /**
             * @internal
             */
            var PropertyBuilderImpl = /** @class */ (function (_super) {
                __extends(PropertyBuilderImpl, _super);
                function PropertyBuilderImpl(_prev, metadata) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    _this.metadata = metadata;
                    return _this;
                }
                PropertyBuilderImpl.prototype.build = function (ro) {
                    var name = this.metadata.odataName;
                    var url = Service.combineUrl(ro.url, name);
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: "GET" /* GET */, url: url, requestContext: this.createRequestContext() }));
                };
                PropertyBuilderImpl.prototype.createRequestContext = function () {
                    return new osa.common.odata.PropertyContext(this.metadata, this.metadata.isArray());
                };
                PropertyBuilderImpl.create = function (prev, name, ownerType) {
                    var propertyInfo = ownerType.getPropertyMetadata(ownerType, name);
                    var service = prev.resolveService();
                    var protocol = service.protocol();
                    var metadata = protocol.getPropertyMetadata(propertyInfo, name);
                    if (metadata.isPrimitive()) {
                        return new PrimitivePropertyBuilderImpl(prev, metadata);
                    }
                    if (metadata.isEnum()) {
                        return new EnumPropertyBuilderImpl(prev, metadata);
                    }
                    if (metadata.isComplex()) {
                        return new ComplexPropertyBuilderImpl(prev, metadata);
                    }
                    throw new GeneralError("Unexpected property " + name + " metadata, expected primitive, enum or complex type");
                };
                return PropertyBuilderImpl;
            }(builders.BuilderBase));
            builders.PropertyBuilderImpl = PropertyBuilderImpl;
            /**
             * @internal
             */
            var PrimitivePropertyBuilderImpl = /** @class */ (function (_super) {
                __extends(PrimitivePropertyBuilderImpl, _super);
                function PrimitivePropertyBuilderImpl(_prev, metadata) {
                    var _this = _super.call(this, _prev, metadata) || this;
                    _this._prev = _prev;
                    return _this;
                }
                PrimitivePropertyBuilderImpl.prototype.property = function (regularProperty) {
                    throw new Error("Primitive value cannot have a property(" + regularProperty + ")");
                };
                PrimitivePropertyBuilderImpl.prototype.value = function () {
                    return new builders.ValueBuilderImpl(this);
                };
                return PrimitivePropertyBuilderImpl;
            }(PropertyBuilderImpl));
            /**
             * @internal
             */
            var EnumPropertyBuilderImpl = /** @class */ (function (_super) {
                __extends(EnumPropertyBuilderImpl, _super);
                function EnumPropertyBuilderImpl(_prev, metadata) {
                    var _this = _super.call(this, _prev, metadata) || this;
                    _this._prev = _prev;
                    return _this;
                }
                EnumPropertyBuilderImpl.prototype.property = function (regularProperty) {
                    throw new Error("Enum value cannot have a property(" + regularProperty + ")");
                };
                EnumPropertyBuilderImpl.prototype.value = function () {
                    return new builders.ValueBuilderImpl(this);
                };
                return EnumPropertyBuilderImpl;
            }(PropertyBuilderImpl));
            /**
             * @internal
             */
            var ComplexPropertyBuilderImpl = /** @class */ (function (_super) {
                __extends(ComplexPropertyBuilderImpl, _super);
                function ComplexPropertyBuilderImpl(_prev, metadata) {
                    var _this = _super.call(this, _prev, metadata) || this;
                    _this._prev = _prev;
                    return _this;
                }
                ComplexPropertyBuilderImpl.prototype.property = function (regularProperty) {
                    var ownerType = this.metadata.referenceTypeCtor;
                    return PropertyBuilderImpl.create(this, regularProperty, ownerType);
                };
                ComplexPropertyBuilderImpl.prototype.value = function () {
                    throw new Error("$value is not allowed for complex property " + this.metadata.odataName);
                };
                return ComplexPropertyBuilderImpl;
            }(PropertyBuilderImpl));
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            /**
             * @internal
             */
            var ManyBuilderImpl = /** @class */ (function (_super) {
                __extends(ManyBuilderImpl, _super);
                function ManyBuilderImpl(prev, _name, _typeFilter, _type) {
                    var _this = _super.call(this, prev) || this;
                    _this._name = _name;
                    _this._typeFilter = _typeFilter;
                    _this._type = _type;
                    return _this;
                }
                ManyBuilderImpl.prototype.count = function () {
                    return new builders.CountBuilderImpl(this);
                };
                ManyBuilderImpl.prototype.ref = function () {
                    return new builders.ManyRefBuilderImpl(this);
                };
                ManyBuilderImpl.prototype.build = function (ro) {
                    var url = Service.combineUrl(ro.url, this._name, this._typeFilter);
                    var type = this._type.odataType;
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { url: url, method: "GET" /* GET */, requestContext: new osa.common.odata.RequestContext(type, true, this._typeFilter) }));
                };
                return ManyBuilderImpl;
            }(builders.BuilderBase));
            builders.ManyBuilderImpl = ManyBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var encodeString = osa.common.encodeString;
            var Service = osa.base.Service;
            /**
             * @internal
             */
            var OneOfBuilderImpl = /** @class */ (function (_super) {
                __extends(OneOfBuilderImpl, _super);
                function OneOfBuilderImpl(_prev, _name, _key, _typeCast, _type) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    _this._name = _name;
                    _this._key = _key;
                    _this._typeCast = _typeCast;
                    _this._type = _type;
                    return _this;
                }
                OneOfBuilderImpl.prototype.getMedia = function () {
                    return new builders.MediaBuilderImpl(this);
                };
                OneOfBuilderImpl.prototype.many = function (manyNavigation, typeFilter) {
                    var type = builders.BuilderBase.resolveDataType(this._type, manyNavigation);
                    return new builders.ManyBuilderImpl(this, manyNavigation, typeFilter === null || typeFilter === void 0 ? void 0 : typeFilter.odataType, type);
                };
                OneOfBuilderImpl.prototype.property = function (regularProperty) {
                    return builders.PropertyBuilderImpl.create(this, regularProperty, this._type);
                };
                OneOfBuilderImpl.prototype.ref = function () {
                    return new builders.OneOfRefBuilderImpl(this);
                };
                OneOfBuilderImpl.prototype.single = function (singleNavigation, typeCast) {
                    var type = builders.BuilderBase.resolveDataType(this._type, singleNavigation);
                    return new builders.SingleBuilderImpl(this, singleNavigation, typeCast === null || typeCast === void 0 ? void 0 : typeCast.odataType, type);
                };
                OneOfBuilderImpl.prototype.oneOf = function (manyNavigation, id, typeCast) {
                    var type = builders.BuilderBase.resolveDataType(this._type, manyNavigation);
                    return new OneOfBuilderImpl(this, manyNavigation, id, typeCast === null || typeCast === void 0 ? void 0 : typeCast.odataType, type);
                };
                OneOfBuilderImpl.prototype.build = function (ro) {
                    var key = encodeString(this._key);
                    var name = this._name + "(" + key + ")";
                    var url = Service.combineUrl(ro.url, name, this._typeCast);
                    var method = "GET" /* GET */;
                    var type = this._type.odataType;
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: method,
                        url: url, requestContext: new osa.common.odata.RequestContext(type, false, this._typeCast) }));
                };
                return OneOfBuilderImpl;
            }(builders.BuilderBase));
            builders.OneOfBuilderImpl = OneOfBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            /**
             * @internal
             */
            var SingleBuilderImpl = /** @class */ (function (_super) {
                __extends(SingleBuilderImpl, _super);
                function SingleBuilderImpl(_prev, _name, _typeCast, _type) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    _this._name = _name;
                    _this._typeCast = _typeCast;
                    _this._type = _type;
                    return _this;
                }
                SingleBuilderImpl.prototype.getMedia = function () {
                    return new builders.MediaBuilderImpl(this);
                };
                SingleBuilderImpl.prototype.many = function (manyNavigation, typeFilter) {
                    var type = builders.BuilderBase.resolveDataType(this._type, manyNavigation);
                    return new builders.ManyBuilderImpl(this, manyNavigation, typeFilter === null || typeFilter === void 0 ? void 0 : typeFilter.odataType, type);
                };
                SingleBuilderImpl.prototype.oneOf = function (manyNavigation, id, typeCast) {
                    var type = builders.BuilderBase.resolveDataType(this._type, manyNavigation);
                    return new builders.OneOfBuilderImpl(this, manyNavigation, id, typeCast === null || typeCast === void 0 ? void 0 : typeCast.odataType, type);
                };
                SingleBuilderImpl.prototype.property = function (regularProperty) {
                    return builders.PropertyBuilderImpl.create(this, regularProperty, this._type);
                };
                SingleBuilderImpl.prototype.ref = function () {
                    return new builders.SingleRefBuilderImpl(this);
                };
                SingleBuilderImpl.prototype.single = function (singleNavigation, typeCast) {
                    var type = builders.BuilderBase.resolveDataType(this._type, singleNavigation);
                    return new SingleBuilderImpl(this, singleNavigation, typeCast === null || typeCast === void 0 ? void 0 : typeCast.odataType, type);
                };
                SingleBuilderImpl.prototype.build = function (ro) {
                    var url = Service.combineUrl(ro.url, this._name, this._typeCast);
                    var type = this._type.odataType;
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { url: url, method: "GET" /* GET */, requestContext: new osa.common.odata.RequestContext(type, false, this._typeCast) }));
                };
                return SingleBuilderImpl;
            }(builders.BuilderBase));
            builders.SingleBuilderImpl = SingleBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            var encodeString = osa.common.encodeString;
            /**
             * @internal
             */
            var EntityBuilderImpl = /** @class */ (function (_super) {
                __extends(EntityBuilderImpl, _super);
                function EntityBuilderImpl(_prev, _entity) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    _this._entity = _entity;
                    _this._type = Object.getPrototypeOf(_this._entity).constructor;
                    return _this;
                }
                EntityBuilderImpl.prototype.getMedia = function () {
                    return new builders.MediaBuilderImpl(this);
                };
                EntityBuilderImpl.prototype.many = function (manyNavigation, typeFilter) {
                    var type = builders.BuilderBase.resolveDataType(this._type, manyNavigation);
                    return new builders.ManyBuilderImpl(this, manyNavigation, typeFilter === null || typeFilter === void 0 ? void 0 : typeFilter.odataType, type);
                };
                EntityBuilderImpl.prototype.oneOf = function (singleNavigation, id, typeCast) {
                    var type = builders.BuilderBase.resolveDataType(this._type, singleNavigation);
                    return new builders.OneOfBuilderImpl(this, singleNavigation, id, typeCast === null || typeCast === void 0 ? void 0 : typeCast.odataType, type);
                };
                EntityBuilderImpl.prototype.property = function (regularProperty) {
                    return builders.PropertyBuilderImpl.create(this, regularProperty, this._type);
                };
                EntityBuilderImpl.prototype.single = function (singleNavigation, typeCast) {
                    var type = builders.BuilderBase.resolveDataType(this._type, singleNavigation);
                    return new builders.SingleBuilderImpl(this, singleNavigation, typeCast === null || typeCast === void 0 ? void 0 : typeCast.odataType, type);
                };
                EntityBuilderImpl.prototype.putMedia = function (content, mimeType) {
                    return new builders.PutMediaBuilderImpl(this, content, mimeType);
                };
                EntityBuilderImpl.prototype.remove = function () {
                    return new builders.RemoveBuilderImpl(this);
                };
                EntityBuilderImpl.prototype.replace = function () {
                    return new builders.ReplaceBuilderImpl(this, this._entity);
                };
                EntityBuilderImpl.prototype.update = function () {
                    return new builders.UpdateBuilderImpl(this, this._entity);
                };
                EntityBuilderImpl.prototype.build = function (ro) {
                    if (!this._entity.id) {
                        throw new Error('The entity must have an id');
                    }
                    var entitySet = Service.resolveEntitySet(this._prev._svc, this._entity);
                    var key = encodeString(this._entity.id);
                    var name = entitySet.name + "(" + key + ")";
                    var url = Service.combineUrl(ro.url, name);
                    var type = this._type.odataType;
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { url: url, method: "GET" /* GET */, requestContext: new osa.common.odata.RequestContext(type) }));
                };
                return EntityBuilderImpl;
            }(builders.BuilderBase));
            builders.EntityBuilderImpl = EntityBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            /**
             * @internal
             */
            var EntitySetBuilderImpl = /** @class */ (function (_super) {
                __extends(EntitySetBuilderImpl, _super);
                function EntitySetBuilderImpl(prev, _entitySet, _typeFilter) {
                    var _this = _super.call(this, prev) || this;
                    _this._entitySet = _entitySet;
                    _this._typeFilter = _typeFilter;
                    return _this;
                }
                EntitySetBuilderImpl.prototype.add = function (entity) {
                    return new AddBuilderImpl(this, entity);
                };
                EntitySetBuilderImpl.prototype.addMedia = function (content, mimeType) {
                    return new AddMediaBuilderImpl(this, content, mimeType);
                };
                EntitySetBuilderImpl.prototype.count = function () {
                    return new builders.CountBuilderImpl(this);
                };
                EntitySetBuilderImpl.prototype.build = function (ro) {
                    var url = Service.combineUrl(this._entitySet.name, this._typeFilter);
                    var method = "GET" /* GET */;
                    var type = this.resolveType();
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: method,
                        url: url, requestContext: new osa.common.odata.RequestContext(type, true, this._typeFilter) }));
                };
                EntitySetBuilderImpl.prototype.resolveType = function () {
                    return this._entitySet.entityType.odataType;
                };
                return EntitySetBuilderImpl;
            }(builders.BuilderBase));
            builders.EntitySetBuilderImpl = EntitySetBuilderImpl;
            /**
             * @internal
             */
            var AddBuilderImpl = /** @class */ (function (_super) {
                __extends(AddBuilderImpl, _super);
                function AddBuilderImpl(prev, _entity) {
                    var _this = _super.call(this, prev) || this;
                    _this._entity = _entity;
                    return _this;
                }
                AddBuilderImpl.prototype.build = function (ro) {
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { data: this._entity, method: "POST" /* POST */, requestContext: new osa.common.odata.RequestContext(osa.base.DataType.resolveOdataType(this._entity), false) }));
                };
                return AddBuilderImpl;
            }(builders.BuilderBase));
            /**
             * @internal
             */
            var AddMediaBuilderImpl = /** @class */ (function (_super) {
                __extends(AddMediaBuilderImpl, _super);
                function AddMediaBuilderImpl(_prev, _content, _mimeType) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    _this._content = _content;
                    _this._mimeType = _mimeType;
                    return _this;
                }
                AddMediaBuilderImpl.prototype.build = function (ro) {
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: "POST" /* POST */, body: this._content, bodyType: this._mimeType, requestContext: new osa.common.odata.RequestContext(this._prev.resolveType(), false) }));
                };
                return AddMediaBuilderImpl;
            }(builders.BuilderBase));
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Service = osa.base.Service;
            var encodeString = osa.common.encodeString;
            /**
             * @internal
             */
            var EntitySetOneOfBuilderImpl = /** @class */ (function (_super) {
                __extends(EntitySetOneOfBuilderImpl, _super);
                function EntitySetOneOfBuilderImpl(prev, _entitySet, _key, _typeCast) {
                    var _this = _super.call(this, prev) || this;
                    _this._entitySet = _entitySet;
                    _this._key = _key;
                    _this._typeCast = _typeCast;
                    return _this;
                }
                EntitySetOneOfBuilderImpl.prototype.getMedia = function () {
                    return new builders.MediaBuilderImpl(this);
                };
                EntitySetOneOfBuilderImpl.prototype.many = function (manyNavigation, typeFilter) {
                    var clazz = this._entitySet.entityType;
                    var type = builders.BuilderBase.resolveDataType(clazz, manyNavigation);
                    return new builders.ManyBuilderImpl(this, manyNavigation, typeFilter === null || typeFilter === void 0 ? void 0 : typeFilter.odataType, type);
                };
                EntitySetOneOfBuilderImpl.prototype.oneOf = function (singleNavigation, id, typeCast) {
                    var clazz = this._entitySet.entityType;
                    var type = builders.BuilderBase.resolveDataType(clazz, singleNavigation);
                    return new builders.OneOfBuilderImpl(this, singleNavigation, id, typeCast === null || typeCast === void 0 ? void 0 : typeCast.odataType, type);
                };
                EntitySetOneOfBuilderImpl.prototype.property = function (regularProperty) {
                    return builders.PropertyBuilderImpl.create(this, regularProperty, this._entitySet.entityType);
                };
                EntitySetOneOfBuilderImpl.prototype.remove = function () {
                    return new builders.RemoveBuilderImpl(this);
                };
                EntitySetOneOfBuilderImpl.prototype.replace = function (entity) {
                    return new builders.ReplaceBuilderImpl(this, entity);
                };
                EntitySetOneOfBuilderImpl.prototype.single = function (singleNavigation, typeCast) {
                    var clazz = this._entitySet.entityType;
                    var type = builders.BuilderBase.resolveDataType(clazz, singleNavigation);
                    return new builders.SingleBuilderImpl(this, singleNavigation, typeCast === null || typeCast === void 0 ? void 0 : typeCast.odataType, type);
                };
                EntitySetOneOfBuilderImpl.prototype.update = function (entity) {
                    return new builders.UpdateBuilderImpl(this, entity);
                };
                EntitySetOneOfBuilderImpl.prototype.putMedia = function (content, mimeType) {
                    return new builders.PutMediaBuilderImpl(this, content, mimeType);
                };
                EntitySetOneOfBuilderImpl.prototype.build = function (ro) {
                    var key = encodeString(this._key);
                    var oneOf = this._entitySet.name + "(" + key + ")";
                    var url = Service.combineUrl(oneOf, this._typeCast);
                    var method = "GET" /* GET */;
                    var type = this.resolveType().odataType;
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: method,
                        url: url, requestContext: new osa.common.odata.RequestContext(type, false, this._typeCast) }));
                };
                EntitySetOneOfBuilderImpl.prototype.resolveType = function () {
                    return this._entitySet.entityType;
                };
                return EntitySetOneOfBuilderImpl;
            }(builders.BuilderBase));
            builders.EntitySetOneOfBuilderImpl = EntitySetOneOfBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            var Complex = osa.base.Complex;
            var Service = osa.base.Service;
            /**
             * @internal
             */
            var OperationBuilderImpl = /** @class */ (function (_super) {
                __extends(OperationBuilderImpl, _super);
                function OperationBuilderImpl(_service, _name, _arg, _typeFilter) {
                    var _this = _super.call(this, _service) || this;
                    _this._service = _service;
                    _this._name = _name;
                    _this._arg = _arg;
                    _this._typeFilter = _typeFilter;
                    return _this;
                }
                OperationBuilderImpl.prototype.get = function () {
                    this.expectNull(this._method, 'method');
                    return this.createSelf(function (x) { return x._method = "GET" /* GET */; });
                };
                OperationBuilderImpl.prototype.getMedia = function () {
                    return new builders.MediaBuilderImpl(this);
                };
                OperationBuilderImpl.prototype.build = function (ro) {
                    var method = this._method || "POST" /* POST */;
                    var data = this._arg instanceof Complex ? { request: this._arg } : this._arg;
                    var service = this._service._svc;
                    var protocol = service.protocol();
                    var meta = OperationBuilderImpl.resolveMetadata(service, this._name);
                    var url = Service.combineUrl(protocol.buildOperationUrl(meta.name, method, data), this._typeFilter);
                    var aliasData = method === "GET" /* GET */ ? protocol.toUrlData(data) : data;
                    var requestContext = Service.createOperationRequestContext(meta.name, meta.returnType);
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: method,
                        url: url, data: aliasData, requestContext: requestContext }));
                };
                OperationBuilderImpl.resolveMetadata = function (svc, name) {
                    var clazz = svc.constructor;
                    var meta = clazz.$operationMetadata[name];
                    if (meta == null) {
                        throw new Error("Operation " + name + " not found");
                    }
                    if (meta.length != 1) {
                        throw new Error("Operation " + name + " has more than one resolution");
                    }
                    return meta[0];
                };
                return OperationBuilderImpl;
            }(builders.BuilderBase));
            builders.OperationBuilderImpl = OperationBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            /**
             * @internal
             */
            var ServiceBuilderImpl = /** @class */ (function (_super) {
                __extends(ServiceBuilderImpl, _super);
                function ServiceBuilderImpl(_svc) {
                    var _this = _super.call(this, null) || this;
                    _this._svc = _svc;
                    return _this;
                }
                ServiceBuilderImpl.prototype.batch = function () {
                    var parts = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        parts[_i] = arguments[_i];
                    }
                    return new builders.BatchBuilderImpl(this, parts);
                };
                ServiceBuilderImpl.prototype.entitySet = function (entitySet, typeCast) {
                    return new builders.EntitySetBuilderImpl(this, entitySet, typeCast === null || typeCast === void 0 ? void 0 : typeCast.odataType);
                };
                ServiceBuilderImpl.prototype.oneOf = function (entitySet, key, typeCast) {
                    return new builders.EntitySetOneOfBuilderImpl(this, entitySet, key, typeCast === null || typeCast === void 0 ? void 0 : typeCast.odataType);
                };
                ServiceBuilderImpl.prototype.operation = function (name, arg, typeFilter) {
                    if (arguments.length == 2) {
                        if (typeof arg === 'function') {
                            typeFilter = arg;
                            arg = undefined;
                        }
                    }
                    return new builders.OperationBuilderImpl(this, name, arg, typeFilter === null || typeFilter === void 0 ? void 0 : typeFilter.odataType);
                };
                ServiceBuilderImpl.prototype.raw = function (options) {
                    return new builders.RawBuilderImpl(this, options);
                };
                ServiceBuilderImpl.prototype.with = function (entity) {
                    return new builders.EntityBuilderImpl(this, entity);
                };
                ServiceBuilderImpl.prototype.build = function (ro) {
                    return _super.prototype.build.call(this, {
                        method: null,
                        url: ''
                    });
                };
                ServiceBuilderImpl.prototype.resolveService = function () {
                    return this._svc;
                };
                return ServiceBuilderImpl;
            }(builders.BuilderBase));
            builders.ServiceBuilderImpl = ServiceBuilderImpl;
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var builders;
        (function (builders) {
            /**
             * @internal
             */
            var SingleRefBuilderImpl = /** @class */ (function (_super) {
                __extends(SingleRefBuilderImpl, _super);
                function SingleRefBuilderImpl(_prev) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    return _this;
                }
                SingleRefBuilderImpl.prototype.set = function (ref) {
                    if (ref != null) {
                        return new SetSingleBuilderImpl(this, ref);
                    }
                    return new UnsetSingleBuilderImpl(this);
                };
                SingleRefBuilderImpl.prototype.build = function (ro) {
                    var url = buildReferenceUrl(this.resolveService(), ro.url);
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { url: url, method: "GET" /* GET */, requestContext: new osa.common.odata.ReferenceContext(false, false) }));
                };
                return SingleRefBuilderImpl;
            }(builders.BuilderBase));
            builders.SingleRefBuilderImpl = SingleRefBuilderImpl;
            function buildReferenceUrl(svc, url) {
                var protocol = svc.protocol();
                if (protocol.version === osa.common.odata.Version.V4) {
                    return osa.base.Service.combineUrl(url, '$ref');
                }
                var lastSegmentPos = url.lastIndexOf('/');
                return osa.base.Service.combineUrl(url.slice(0, lastSegmentPos), '$links', url.slice(lastSegmentPos + 1));
            }
            var SetSingleBuilderImpl = /** @class */ (function (_super) {
                __extends(SetSingleBuilderImpl, _super);
                function SetSingleBuilderImpl(_prev, _ref) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    _this._ref = _ref;
                    return _this;
                }
                SetSingleBuilderImpl.prototype.build = function (ro) {
                    var svc = this.resolveService();
                    var protocol = svc.protocol();
                    var data = protocol.serialize(this._ref, { reference: true });
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: "PUT" /* PUT */, data: data, requestContext: new osa.common.odata.ReferenceContext(false, true) }));
                };
                return SetSingleBuilderImpl;
            }(builders.BuilderBase));
            var UnsetSingleBuilderImpl = /** @class */ (function (_super) {
                __extends(UnsetSingleBuilderImpl, _super);
                function UnsetSingleBuilderImpl(_prev) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    return _this;
                }
                UnsetSingleBuilderImpl.prototype.build = function (ro) {
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: "DELETE" /* DELETE */, requestContext: new osa.common.odata.ReferenceContext(false, true) }));
                };
                return UnsetSingleBuilderImpl;
            }(builders.BuilderBase));
            /**
             * @internal
             */
            var OneOfRefBuilderImpl = /** @class */ (function (_super) {
                __extends(OneOfRefBuilderImpl, _super);
                function OneOfRefBuilderImpl(_prev) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    return _this;
                }
                OneOfRefBuilderImpl.prototype.remove = function () {
                    return new RemoveOneOfRefBuilderImpl(this);
                };
                OneOfRefBuilderImpl.prototype.build = function (ro) {
                    var url = buildReferenceUrl(this.resolveService(), ro.url);
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { url: url, method: "GET" /* GET */, requestContext: new osa.common.odata.ReferenceContext(false, false) }));
                };
                return OneOfRefBuilderImpl;
            }(builders.BuilderBase));
            builders.OneOfRefBuilderImpl = OneOfRefBuilderImpl;
            var RemoveOneOfRefBuilderImpl = /** @class */ (function (_super) {
                __extends(RemoveOneOfRefBuilderImpl, _super);
                function RemoveOneOfRefBuilderImpl(_prev) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    return _this;
                }
                RemoveOneOfRefBuilderImpl.prototype.build = function (ro) {
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: "DELETE" /* DELETE */, requestContext: new osa.common.odata.ReferenceContext(false, true) }));
                };
                return RemoveOneOfRefBuilderImpl;
            }(builders.BuilderBase));
            /**
             * @internal
             */
            var ManyRefBuilderImpl = /** @class */ (function (_super) {
                __extends(ManyRefBuilderImpl, _super);
                function ManyRefBuilderImpl(_prev) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    return _this;
                }
                ManyRefBuilderImpl.prototype.add = function (ref) {
                    return new AddManyRefBuilderImpl(this, ref);
                };
                ManyRefBuilderImpl.prototype.replace = function (ref) {
                    return new ReplaceManyRefBuilderImpl(this, ref);
                };
                ManyRefBuilderImpl.prototype.build = function (ro) {
                    var url = buildReferenceUrl(this.resolveService(), ro.url);
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { url: url, method: "GET" /* GET */, requestContext: new osa.common.odata.ReferenceContext(true, false) }));
                };
                return ManyRefBuilderImpl;
            }(builders.BuilderBase));
            builders.ManyRefBuilderImpl = ManyRefBuilderImpl;
            var AddManyRefBuilderImpl = /** @class */ (function (_super) {
                __extends(AddManyRefBuilderImpl, _super);
                function AddManyRefBuilderImpl(_prev, _ref) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    _this._ref = _ref;
                    return _this;
                }
                AddManyRefBuilderImpl.prototype.build = function (ro) {
                    var svc = this.resolveService();
                    var protocol = svc.protocol();
                    var data = protocol.serialize(this._ref, { reference: true });
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: "POST" /* POST */, data: data, requestContext: new osa.common.odata.ReferenceContext(false, true) }));
                };
                return AddManyRefBuilderImpl;
            }(builders.BuilderBase));
            var ReplaceManyRefBuilderImpl = /** @class */ (function (_super) {
                __extends(ReplaceManyRefBuilderImpl, _super);
                function ReplaceManyRefBuilderImpl(_prev, _ref) {
                    var _this = _super.call(this, _prev) || this;
                    _this._prev = _prev;
                    _this._ref = _ref;
                    return _this;
                }
                ReplaceManyRefBuilderImpl.prototype.build = function (ro) {
                    var svc = this.resolveService();
                    var protocol = svc.protocol();
                    var data = protocol.serialize(this._ref || [], { reference: true });
                    return _super.prototype.build.call(this, __assign(__assign({}, ro), { method: "PUT" /* PUT */, data: data, requestContext: new osa.common.odata.ReferenceContext(false, true) }));
                };
                return ReplaceManyRefBuilderImpl;
            }(builders.BuilderBase));
        })(builders = request.builders || (request.builders = {}));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var HttpRequest = osa.common.HttpTransport;
        var AsyncHttpRequest = osa.common.AsyncHttpRequest;
        /**
         * @internal
         */
        var AsyncRequestHandler = /** @class */ (function () {
            function AsyncRequestHandler(svc, requestOptions, options) {
                this.svc = svc;
                this.requestOptions = requestOptions;
                this.options = options;
                var transport = HttpRequest.from(svc.$context);
                this.asyncRequest = AsyncHttpRequest.from(transport, requestOptions, options === null || options === void 0 ? void 0 : options.async);
            }
            AsyncRequestHandler.prototype.send = function (requestOptions, options) {
                this.svc.trigger('beforeRequest', requestOptions, this.svc);
                var transport = HttpRequest.from(this.svc.$context);
                var asyncRequest = AsyncHttpRequest.from(transport, requestOptions, options === null || options === void 0 ? void 0 : options.async);
                var promise = asyncRequest.send();
                return this.executeRequestTail(promise, requestOptions);
            };
            AsyncRequestHandler.prototype.poll = function () {
                var _this = this;
                return Promise.resolve().then(function () {
                    if (_this.asyncRequest == null) {
                        throw new Error('Cannot poll after polling has completed');
                    }
                    _this.svc.trigger('beforeRequest', _this.requestOptions, _this.svc);
                    return _this.asyncRequest.poll().then(function (_a) {
                        var done = _a.done, httpResult = _a.httpResult, location = _a.location;
                        if (done) {
                            return _this.executeRequestTail(httpResult, _this.requestOptions).then(function (result) {
                                _this.complete();
                                return {
                                    done: true,
                                    result: result,
                                    httpResult: httpResult,
                                    location: null,
                                };
                            });
                        }
                        return {
                            done: false,
                            result: null,
                            httpResult: httpResult,
                            location: location,
                        };
                    });
                });
            };
            AsyncRequestHandler.prototype.complete = function () {
                this.asyncRequest = null;
            };
            return AsyncRequestHandler;
        }());
        request.AsyncRequestHandler = AsyncRequestHandler;
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request) {
        var BuilderBase = osa.request.builders.BuilderBase;
        var ContentTypeHeaderName = osa.constants.ContentTypeHeaderName;
        /**
         * @internal
         */
        var RegularRequestImpl = /** @class */ (function () {
            function RegularRequestImpl(_tail) {
                this._tail = _tail;
            }
            RegularRequestImpl.prototype.transformResult = function (result, raw) {
                return result;
            };
            RegularRequestImpl.prototype.differenceWith = function (other) {
                if (other == null) {
                    return ['other is null'];
                }
                if (other === this) {
                    return [];
                }
                var _a = __read(this.build(), 2), _ = _a[0], thisOne = _a[1];
                var _b = __read(other.build(), 2), __ = _b[0], thatOne = _b[1];
                return compareRequestsInternal(thisOne, thatOne);
            };
            RegularRequestImpl.prototype.send = function (options) {
                var _a = __read(this.build(options), 2), svc = _a[0], requestOptions = _a[1];
                var raw = (options === null || options === void 0 ? void 0 : options.receive) === 'raw';
                return this.executeRequest(svc, requestOptions, raw);
            };
            RegularRequestImpl.prototype.executeRequest = function (svc, options, raw) {
                var _this = this;
                return svc.executeRequest(options, raw).then(function (result) {
                    return _this.transformResult(result, raw);
                });
            };
            RegularRequestImpl.prototype.sendAsync = function (options) {
                var _a = __read(this.build(options), 2), svc = _a[0], requestOptions = _a[1];
                var asyncRequestHandler = new RegularAsyncRequestHandler(svc, requestOptions, options);
                if ((options === null || options === void 0 ? void 0 : options.receive) === 'poll') {
                    return Promise.resolve({
                        poll: function () {
                            return asyncRequestHandler.poll();
                        },
                    });
                }
                return asyncRequestHandler.send(requestOptions, options);
            };
            RegularRequestImpl.prototype.build = function (options) {
                var _a;
                var headers = (_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : {};
                var _b = __read(BuilderBase.build(this._tail), 2), svc = _b[0], requestOptions = _b[1];
                var newRequestOptions = __assign(__assign({}, requestOptions), { headers: __assign(__assign({}, requestOptions.headers), headers) });
                var fullOptions = svc.buildRequest(newRequestOptions);
                return [svc, fullOptions];
            };
            RegularRequestImpl.prototype.toJSON = function () {
                var _a = __read(this.build(), 2), svc = _a[0], requestOptions = _a[1];
                return RegularRequestImpl.toJSON(requestOptions);
            };
            RegularRequestImpl.toJSON = function (requestOptions) {
                return {
                    method: requestOptions.method,
                    url: requestOptions.url,
                    headers: requestOptions.headers,
                    payload: {
                        body: requestOptions.body,
                        bodyType: requestOptions.headers[ContentTypeHeaderName],
                    },
                };
            };
            return RegularRequestImpl;
        }());
        request.RegularRequestImpl = RegularRequestImpl;
        /**
         * @internal
         */
        var RawRequestImpl = /** @class */ (function (_super) {
            __extends(RawRequestImpl, _super);
            function RawRequestImpl() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            RawRequestImpl.prototype.executeRequest = function (svc, options, raw) {
                return _super.prototype.executeRequest.call(this, svc, options, true);
            };
            return RawRequestImpl;
        }(RegularRequestImpl));
        request.RawRequestImpl = RawRequestImpl;
        /**
         * @internal
         */
        var MediaRequestImpl = /** @class */ (function (_super) {
            __extends(MediaRequestImpl, _super);
            function MediaRequestImpl() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            MediaRequestImpl.prototype.executeRequest = function (svc, options, raw) {
                return _super.prototype.executeRequest.call(this, svc, options, true);
            };
            return MediaRequestImpl;
        }(RegularRequestImpl));
        request.MediaRequestImpl = MediaRequestImpl;
        /**
         * @internal
         */
        var CountRequestImpl = /** @class */ (function (_super) {
            __extends(CountRequestImpl, _super);
            function CountRequestImpl() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            CountRequestImpl.prototype.executeRequest = function (svc, options, raw) {
                var _this = this;
                return svc.executeRequest(options, true).then(function (result) {
                    return _this.transformResult(result, raw);
                });
            };
            CountRequestImpl.prototype.transformResult = function (result, raw) {
                if (raw) {
                    return result;
                }
                return result.text.then(function (x) {
                    return Number(x);
                });
            };
            return CountRequestImpl;
        }(RegularRequestImpl));
        request.CountRequestImpl = CountRequestImpl;
        /**
         * @internal
         */
        var ValueRequestImpl = /** @class */ (function (_super) {
            __extends(ValueRequestImpl, _super);
            function ValueRequestImpl() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            ValueRequestImpl.prototype.executeRequest = function (svc, options, raw) {
                var _this = this;
                return svc.executeRequest(options, true).then(function (result) {
                    return _this.transformResult(result, raw);
                });
            };
            ValueRequestImpl.prototype.transformResult = function (result, raw) {
                if (raw) {
                    return result;
                }
                return result.text.then(function (x) {
                    return x.charAt(0) === '\ufeff' ? x.slice(1) : x;
                });
            };
            return ValueRequestImpl;
        }(RegularRequestImpl));
        request.ValueRequestImpl = ValueRequestImpl;
        /**
         * @internal
         */
        function compareRequestsInternal(thisOne, thatOne) {
            var _a, _b;
            if (thisOne === thatOne) {
                return [];
            }
            if (thisOne == null && thatOne == null) {
                return [];
            }
            if (oneIsNull(thisOne, thatOne)) {
                return ["one of the values is null"];
            }
            var difference = [];
            if (thisOne.method !== thatOne.method) {
                difference.push("[method] difference: " + thisOne.method + " !== " + thatOne.method);
            }
            if (thisOne.url !== thatOne.url) {
                difference.push("[url] difference: " + thisOne.url + " !== " + thatOne.url);
            }
            if (thisOne.body !== thatOne.body) {
                difference.push("[body] difference: " + thisOne.body + " !== " + thatOne.body);
            }
            var headersEquality = compareObjects(thisOne.headers, thatOne.headers);
            if (headersEquality.length > 0) {
                difference.push.apply(difference, __spreadArray([], __read(headersEquality.map(function (x) { return "[headers] " + x; }))));
            }
            var thisOneBatch = (_a = thisOne.batch) !== null && _a !== void 0 ? _a : [];
            var thatOneBatch = (_b = thatOne.batch) !== null && _b !== void 0 ? _b : [];
            var length = Math.max(thisOneBatch.length, thatOneBatch.length);
            var _loop_3 = function (i) {
                var batchEquality = compareRequestsInternal(thisOneBatch[i], thatOneBatch[i]);
                if (batchEquality.length > 0) {
                    difference.push.apply(difference, __spreadArray([], __read(batchEquality.map(function (x) { return "[batch] [" + i + "] " + x; }))));
                }
            };
            for (var i = 0; i < length; i++) {
                _loop_3(i);
            }
            var fetchOptionsEquality = compareObjects(thisOne.fetchOptions, thatOne.fetchOptions);
            if (fetchOptionsEquality.length > 0) {
                difference.push.apply(difference, __spreadArray([], __read(fetchOptionsEquality.map(function (x) { return "[fetchOptions] " + x; }))));
            }
            return difference;
        }
        request.compareRequestsInternal = compareRequestsInternal;
        function oneIsNull(thisOne, thatOne) {
            return (thisOne == null && thatOne != null) || (thisOne != null && thatOne == null);
        }
        function typesAreDifferent(thisOne, thatOne) {
            return Object.prototype.toString.call(thisOne) !== Object.prototype.toString.call(thatOne);
        }
        /**
         * @internal
         */
        function compareObjects(thisOne, thatOne) {
            var e_18, _a;
            var difference = [];
            if (thisOne == null && thatOne == null) {
                return [];
            }
            if (oneIsNull(thisOne, thatOne)) {
                return ["one of the values is null"];
            }
            var properties = Object.getOwnPropertyNames(thisOne);
            var _loop_4 = function (property) {
                if (oneIsNull(thisOne[property], thatOne[property])) {
                    difference.push("[" + property.toLowerCase() + "] one of the values is null");
                    return "continue";
                }
                if (typesAreDifferent(thisOne[property], thatOne[property])) {
                    difference.push("[" + property.toLowerCase() + "] type difference");
                    return "continue";
                }
                if (typeof thisOne[property] === "object") {
                    var result = compareObjects(thisOne[property], thatOne[property]);
                    if (result.length > 0) {
                        difference.push.apply(difference, __spreadArray([], __read(result.map(function (x) { return "[" + property.toLowerCase() + "] " + x; }))));
                    }
                    return "continue";
                }
                if (thisOne[property] !== thatOne[property]) {
                    difference.push("[" + property.toLowerCase() + "] difference: " + thisOne[property] + " !== " + thatOne[property]);
                }
            };
            try {
                for (var properties_2 = __values(properties), properties_2_1 = properties_2.next(); !properties_2_1.done; properties_2_1 = properties_2.next()) {
                    var property = properties_2_1.value;
                    _loop_4(property);
                }
            }
            catch (e_18_1) { e_18 = { error: e_18_1 }; }
            finally {
                try {
                    if (properties_2_1 && !properties_2_1.done && (_a = properties_2.return)) _a.call(properties_2);
                }
                finally { if (e_18) throw e_18.error; }
            }
            return difference;
        }
        request.compareObjects = compareObjects;
        var RegularAsyncRequestHandler = /** @class */ (function (_super) {
            __extends(RegularAsyncRequestHandler, _super);
            function RegularAsyncRequestHandler() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            RegularAsyncRequestHandler.prototype.executeRequestTail = function (promise, requestOptions) {
                return this.svc.executeRequestTail(promise, requestOptions, false);
            };
            return RegularAsyncRequestHandler;
        }(request.AsyncRequestHandler));
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
var osa;
(function (osa) {
    var request;
    (function (request_1) {
        var BuilderBase = osa.request.builders.BuilderBase;
        var BuiltRequestSymbol = osa.common.BuiltRequestSymbol;
        var HttpTransport = osa.common.HttpTransport;
        /**
         * @internal
         */
        var BatchRequestImpl = /** @class */ (function () {
            function BatchRequestImpl(_tail) {
                this._tail = _tail;
            }
            BatchRequestImpl.prototype.sendAsync = function (options) {
                var _a = __read(this.build(options), 2), svc = _a[0], requestOptions = _a[1];
                var asyncRequestHandler = new BatchAsyncRequestHandler(svc, requestOptions, options);
                for (var i = 0; i < requestOptions.batch.length; i++) {
                    svc.trigger('beforeRequest', requestOptions.batch[i], svc);
                }
                if ((options === null || options === void 0 ? void 0 : options.receive) === 'poll') {
                    return Promise.resolve({
                        poll: function () {
                            return asyncRequestHandler.poll();
                        }
                    });
                }
                return asyncRequestHandler.send(requestOptions, options);
            };
            BatchRequestImpl.prototype.differenceWith = function (other) {
                if (other == null) {
                    return ['other is null'];
                }
                if (other === this) {
                    return [];
                }
                var _a = __read(this.build(), 2), _ = _a[0], thisOne = _a[1];
                var _b = __read(other.build(), 2), __ = _b[0], thatOne = _b[1];
                return request_1.compareRequestsInternal(thisOne, thatOne);
            };
            BatchRequestImpl.prototype.send = function (options) {
                var _a = __read(this.build(options), 2), svc = _a[0], requestOptions = _a[1];
                svc.trigger('beforeRequest', requestOptions, svc);
                for (var i = 0; i < requestOptions.batch.length; i++) {
                    svc.trigger('beforeRequest', requestOptions.batch[i], svc);
                }
                var httpRequest = HttpTransport.from(svc.$context);
                return httpRequest.send(requestOptions).then(function (response) {
                    return BatchRequestImpl.executeRequestTail(svc, response, requestOptions);
                });
            };
            BatchRequestImpl.executeRequestTail = function (svc, promise, requestOptions) {
                return Promise.resolve(promise).then(function (response) {
                    return svc.executeRequestTail(response, requestOptions);
                }).then(function (parts) {
                    var promises = [];
                    for (var i = 0; i < requestOptions.batch.length; i++) {
                        var partOptions = requestOptions.batch[i];
                        var partResponse = parts[i];
                        var promise_1 = svc.executeRequestTail(Promise.resolve(partResponse), partOptions);
                        promises.push(promise_1);
                    }
                    return allSettled(promises);
                });
            };
            BatchRequestImpl.prototype.build = function (options) {
                var _a = __read(BuilderBase.build(this._tail), 2), svc = _a[0], requestOptions = _a[1];
                var headers = (options === null || options === void 0 ? void 0 : options.headers) || {};
                var parts = this._tail.parts.map(function (part) {
                    var request = part.createRequest();
                    var _a = __read(request.build(), 2), _ = _a[0], partOptions = _a[1];
                    return partOptions;
                });
                var fullOptions = svc.buildRequest(__assign(__assign({}, requestOptions), { headers: __assign(__assign({}, requestOptions.headers), headers), batch: parts }));
                fullOptions[BuiltRequestSymbol] = true;
                return [svc, fullOptions];
            };
            BatchRequestImpl.prototype.toJSON = function () {
                var _a = __read(this.build(), 2), svc = _a[0], requestOptions = _a[1];
                return osa.request.RegularRequestImpl.toJSON(requestOptions);
            };
            return BatchRequestImpl;
        }());
        request_1.BatchRequestImpl = BatchRequestImpl;
        var BatchAsyncRequestHandler = /** @class */ (function (_super) {
            __extends(BatchAsyncRequestHandler, _super);
            function BatchAsyncRequestHandler() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            BatchAsyncRequestHandler.prototype.executeRequestTail = function (promise, requestOptions) {
                return BatchRequestImpl.executeRequestTail(this.svc, promise, requestOptions);
            };
            return BatchAsyncRequestHandler;
        }(request_1.AsyncRequestHandler));
        /**
         * @internal
         * A backward compatible implementation of Promise.allSettled, used in node versions <12.9.0
         */
        function allSettled(promises) {
            if (Promise.allSettled) {
                return Promise.allSettled(promises);
            }
            var mappedPromises = promises.map(function (p) {
                return p.then(function (value) {
                    return {
                        status: 'fulfilled',
                        value: value,
                    };
                }).catch(function (reason) {
                    return {
                        status: 'rejected',
                        reason: reason,
                    };
                });
            });
            return Promise.all(mappedPromises);
        }
        request_1.allSettled = allSettled;
    })(request = osa.request || (osa.request = {}));
})(osa || (osa = {}));
/// <reference path="version.ts"/>
/// <reference path="error/ValidationError.ts"/>
/// <reference path="common/ContentType.ts"/>
/// <reference path="common/TextReader.ts"/>
/// <reference path="common/Metadata.ts"/>
/// <reference path="common/GenericMetadata.ts"/>
/// <reference path="common/MetadataOdata3.ts"/>
/// <reference path="common/MetadataOdata4.ts"/>
/// <reference path="common/Constants.ts"/>
/// <reference path="common/CommonTypes.ts"/>
/// <reference path="common/Util.ts"/>
/// <reference path="common/Deferred.ts"/>
/// <reference path="common/EventEmitter.ts"/>
/// <reference path="common/ClientInfo.ts"/>
/// <reference path="common/HttpResult.ts"/>
/// <reference path="common/Params.ts"/>
/// <reference path="common/ParamsWithId.ts"/>
/// <reference path="common/EntityArray.ts"/>
/// <reference path="common/OdataOptions.ts"/>
/// <reference path="common/Context.ts"/>
/// <reference path="common/SecurityConfig.ts"/>
/// <reference path="common/CompiledContext.ts"/>
/// <reference path="common/Domain.ts"/>
/// <reference path="common/odata/BoundMetadata.ts"/>
/// <reference path="common/odata/Protocol.ts"/>
/// <reference path="common/odata/ProtocolOdata2.ts"/>
/// <reference path="common/odata/ProtocolOdata3.ts"/>
/// <reference path="common/odata/ProtocolOdata4.ts"/>
/// <reference path="common/odata/RequestContext.ts"/>
/// <reference path="common/odata/Deserializer.ts"/>
/// <reference path="common/odata/DeserializerOdata3.ts"/>
/// <reference path="common/odata/DeserializerOdata4.ts"/>
/// <reference path="common/odata/types/DateTimeOffset.ts"/>
/// <reference path="common/odata/types/EdmDate.ts"/>
/// <reference path="common/odata/types/EdmDuration.ts"/>
/// <reference path="common/Batch.ts"/>
/// <reference path="common/HttpRequest.ts"/>
/// <reference path="common/Delta.ts"/>
/// <reference path="base/Complex.ts"/>
/// <reference path="base/DataType.ts"/>
/// <reference path="base/Entity.ts"/>
/// <reference path="base/EntitySet.ts"/>
/// <reference path="security/AuthenticationFlowHandler.ts"/>
/// <reference path="security/ClientCredentialsFlow.ts"/>
/// <reference path="base/Service.ts"/>
/// <reference path="base/ServiceOdata3.ts"/>
/// <reference path="base/ServiceOdata4.ts"/>
/// <reference path="error/GeneralError.ts"/>
/// <reference path="error/NotImpl.ts"/>
/// <reference path="error/ArgumentError.ts"/>
/// <reference path="error/RequestError.ts"/>
/// <reference path="error/OdataError.ts"/>
/// <reference path="decorators/compat.ts"/>
/// <reference path="decorators/ComplexType.ts"/>
/// <reference path="decorators/EntityType.ts"/>
/// <reference path="decorators/EntitySet.ts"/>
/// <reference path="decorators/ServiceFunction.ts"/>
/// <reference path="decorators/DomainService.ts"/>
/// <reference path="decorators/DeferredProperty.ts"/>
/// <reference path="decorators/HasStream.ts"/>
/// <reference path="decorators/Deprecated.ts"/>
/// <reference path="DefaultContext.ts"/>
/// <reference path="AttachDomain.ts"/>
/// <reference path="FetchAPI.ts"/>
/// <reference path="query/Query.ts"/>
/// <reference path="query/FilterExpression.ts"/>
/// <reference path="query/FilterExpression-odata3.ts"/>
/// <reference path="query/FilterExpression-odata4.ts"/>
/// <reference path="query/Compiler.ts"/>
/// <reference path="query/Query-odata3.ts"/>
/// <reference path="query/Compiler-odata3.ts"/>
/// <reference path="query/Query-odata4.ts"/>
/// <reference path="query/Compiler-odata4.ts"/>
/// <reference path="query/SearchExpression-odata4.ts"/>
/// <reference path="Plurals.ts"/>
/// <reference path="request/Request.ts"/>
/// <reference path="request/builders/BuilderBase.ts"/>
/// <reference path="request/builders/Batch.ts"/>
/// <reference path="request/builders/Count.ts"/>
/// <reference path="request/builders/Raw.ts"/>
/// <reference path="request/builders/Value.ts"/>
/// <reference path="request/builders/Media.ts"/>
/// <reference path="request/builders/PutMedia.ts"/>
/// <reference path="request/builders/Replace.ts"/>
/// <reference path="request/builders/Remove.ts"/>
/// <reference path="request/builders/Update.ts"/>
/// <reference path="request/builders/Property.ts"/>
/// <reference path="request/builders/Many.ts"/>
/// <reference path="request/builders/OneOf.ts"/>
/// <reference path="request/builders/Single.ts"/>
/// <reference path="request/builders/Entity.ts"/>
/// <reference path="request/builders/EntitySet.ts"/>
/// <reference path="request/builders/EntitySetOneOf.ts"/>
/// <reference path="request/builders/Operation.ts"/>
/// <reference path="request/builders/Service.ts"/>
/// <reference path="request/builders/Ref.ts"/>
/// <reference path="request/AsyncRequestHandler.ts"/>
/// <reference path="request/RegularRequestImpl.ts"/>
/// <reference path="request/BatchRequestImpl.ts"/>
/**
 * Support ES6 default export
 * @internal
 */
osa['default'] = osa;
/**
 * Support commonjs export
 * @internal
 */
module.exports = osa;
